// Textos en inglés de lib/i18n.js: clave = texto en español.
export default {
  "· Agrega tu RFC y CP en Datos para facturar.": "· Add your RFC and ZIP in Billing details.",
  "Ingresos de {0}": "{0} income",
  "Insumos": "Ingredients",
  "Insumo registrado": "Ingredient on file",
  "Insumos registrados": "Ingredients on file",
  "Ticket con foto en {0}": "Receipt photo in {0}",
  "Tickets con foto en {0}": "Receipt photos in {0}",
  "1 día abierto": "Open 1 day",
  "{0} días abiertos": "Open {0} days",
  "a la semana": "a week",
  "1 grupo": "1 group",
  "{0} grupos": "{0} groups",
  "por hora": "hourly",
  "por turno": "per shift",
  "por día": "daily",
  "semanal": "weekly",
  "Moneda {0}": "Currency {0}",
  "Se depositó {0} de más: el depósito es mayor que el total a pagar.": "{0} over-deposited: the deposit is more than the total to pay.",
  "Lo ya depositado en la semana; el resto se paga en efectivo.": "Already deposited this week; the rest is paid in cash.",
  "Reordenar a {0}": "Reorder {0}",
  "Arrastra para cambiar el orden": "Drag to change the order",
  "Cortes cerrados": "Closed cash-ups",
  "Cómo pagaron los clientes con tarjeta en la semana.": "How customers paid by card this week.",
  "Cómo pagaron los clientes con tarjeta ese día.": "How customers paid by card that day.",
  "Del {0} al {1}.": "{0} to {1}.",
  "Día por día": "Day by day",
  "Ese día la caja no abre.": "The register doesn't open that day.",
  "Ese día no hubo cobros con terminal.": "No card terminal payments that day.",
  "Ese día no se registró ningún gasto.": "No expenses were recorded that day.",
  "Esta semana": "This week",
  "Esta semana no hubo cobros con terminal.": "No card terminal payments this week.",
  "Esta semana no se registró ningún gasto.": "No expenses were recorded this week.",
  "Esta semana todavía no empieza.": "This week hasn't started yet.",
  "Fue día de descanso: la caja no abre.": "It was a day off: the register doesn't open.",
  "Gastos de la semana": "This week's expenses",
  "Gastos del día": "Day's expenses",
  "Hasta hoy": "Up to today",
  "Todavía no hay venta capturada esta semana.": "No sales entered this week yet.",
  "Todos cerrados": "All closed",
  "Venta de la semana menos los gastos de la semana.": "Week's sales minus the week's expenses.",
  "Venta del día menos los gastos del día.": "Day's sales minus the day's expenses.",
  "Venta, gastos y cobros con terminal de cada día, y si su corte ya se cerró.": "Sales, expenses and card payments for each day, and whether its cash-up is closed.",
  "Venta, propinas, gastos y cobros con terminal de cada día, y si su corte ya se cerró.": "Sales, tips, expenses and card payments for each day, and whether its cash-up is closed.",
  "Ingreso aparte de la venta": "Income on top of sales",
  "Venta, gastos y propinas de cada día desde el {0}.": "Sales, expenses and tips for each day since {0}.",
  "Propinas de la semana": "Tips this week",
  "vs. la semana pasada": "vs. last week",
  "¿Cómo le fue a la semana?": "How did the week go?",
  "¿Cómo le fue al día?": "How did the day go?",
  "¿Cómo va la semana?": "How is the week going?",
  "Así va la semana": "How the week is going",
  "Comprobante": "Receipt",
  "Con IVA": "With VAT",
  "Con comprobante": "With receipt",
  "Cuando se capture la venta del día verás aquí cuánto queda.": "Once the day's sales are entered you'll see here how much is left.",
  "De cada {0} vendidos, {1} se fueron en gastos.": "Out of every {0} in sales, {1} went to expenses.",
  "Detalle de cada gasto": "Each expense in detail",
  "Los gastos superan la venta por": "Expenses exceed sales by",
  "Mejor día": "Best day",
  "Pagado": "Paid",
  "Persona por persona": "Person by person",
  "Propinas por turno": "Tips by shift",
  "Queda": "Left",
  "Queda después de gastos": "Left after expenses",
  "Todavía no hay ventas ni gastos esta semana.": "No sales or expenses this week yet.",
  "Venta": "Sales",
  "Venta de la semana": "Week's sales",
  "Venta del día menos los gastos de hoy.": "Day's sales minus today's expenses.",
  "Venta y gastos de cada día desde el {0}.": "Sales and expenses for each day since {0}.",
  "en gastos": "on expenses",
  "vs. el {0} pasado": "vs. last {0}",
  "¿Cómo va el día?": "How is the day going?",
  "1 gasto": "1 expense",
  "1 persona": "1 person",
  "Abierto": "Open",
  "Aún sin capturar": "Not entered yet",
  "Cerrado a las {0}": "Closed at {0}",
  "Cobrado con terminal": "Card terminal sales",
  "Cobros con terminal": "Card terminal payments",
  "Cuadra": "Balanced",
  "Cómo pagaron los clientes con tarjeta hoy.": "How customers paid by card today.",
  "Del {0} al {1}. Se muestra el sábado y el domingo, que es cuando se paga.": "{0} to {1}. Shown on Saturday and Sunday, when payroll is paid.",
  "Descanso": "Day off",
  "Efectivo del cajón": "Cash from the drawer",
  "En qué se fue el dinero, de mayor a menor.": "Where the money went, largest first.",
  "Esta semana todavía no hay asistencia capturada en Nóminas.": "No attendance has been entered in Payroll this week yet.",
  "Falta en caja": "Short in the drawer",
  "Fondo + venta": "Float + sales",
  "Fondo + venta + propinas": "Float + sales + tips",
  "Fondo de caja": "Cash float",
  "Gastos de hoy": "Today's expenses",
  "Hoy es día de descanso: la caja no abre.": "Today is a day off: the register doesn't open.",
  "Hoy la caja no abre.": "The register doesn't open today.",
  "Hoy no se ha registrado ningún gasto.": "No expenses recorded today.",
  "Lo que debía haber": "What should be there",
  "Lo que entró": "What came in",
  "Nómina de la semana": "This week's payroll",
  "Otros": "Other",
  "Por área": "By area",
  "Queda en caja": "Left in the drawer",
  "Salidas del cajón": "Drawer cash-outs",
  "Si las dos barras miden lo mismo, la caja cuadra.": "If both bars are the same length, the register balances.",
  "Sin empezar": "Not started",
  "Sobra en caja": "Over in the drawer",
  "Terminales": "Terminals",
  "Terminales + cajón": "Terminals + drawer",
  "Todavía no hay cobros con terminal hoy.": "No card terminal payments yet today.",
  "Venta del día": "Day's sales",
  "{0} gastos": "{0} expenses",
  "{0} personas": "{0} people",
  "¿Cómo se paga?": "How is it paid?",
  "¿Cómo se pagaron?": "How were they paid?",
  "Resumen de hoy": "Today's summary",
  "Cargando aplicación": "Loading app",
  "Facturas por correo": "Invoices by email",
  "Correos de facturas": "Invoice emails",
  "Correos desde los cuales este negocio reenvía sus facturas XML para que el sistema sepa que son suyas.": "Emails this business forwards its XML invoices from, so the system knows they are theirs.",
  "Cargando pantalla": "Loading screen",
  "Cerrar sesión / Bloquear pantalla": "Sign out / Lock screen",
  "Bloquear": "Lock",
  "{0} · Demo": "{0} · Demo",
  "Nóminas": "Payroll",
  "Inventario": "Inventory",
  "Cuentas": "Accounts",
  "Corte": "Cash-up",
  "Facturas": "Invoices",
  "Ajustes": "Settings",
  "Marca quién trabajó cada turno y la nómina de la semana se calcula sola: sueldos, propinas, bonos y préstamos.": "Mark who worked each shift and the week's payroll calculates itself: wages, tips, bonuses and loans.",
  "Registra los ingresos por terminal y los gastos del día, con su comprobante.": "Record income per terminal and the day's expenses, with their receipts.",
  "Corte de caja": "Cash-up",
  "Fondo, venta y propinas contra lo que entró: cuando el cuadre da {0}, terminas el día.": "Float, sales and tips against what came in: when the difference is {0}, you close the day.",
  "Bóveda": "Vault",
  "Todos los comprobantes del negocio en un solo lugar, listos para buscar.": "All of the business's receipts in one place, ready to search.",
  "Facturación": "Invoicing",
  "Lleva el control de qué gastos ya tienen factura.": "Keep track of which expenses already have an invoice.",
  "Personal, catálogos y WhatsApp. Aquí también puedes volver a ver este recorrido.": "Staff, catalogs and WhatsApp. You can also replay this tour here.",
  "de": "of",
  "Saltar recorrido": "Skip tour",
  "Atrás": "Back",
  "Siguiente": "Next",
  "¡A trabajar!": "Let's get to work!",
  "Email o contraseña incorrectos.": "Wrong email or password.",
  "Ese email no es válido.": "That email isn't valid.",
  "Ese email ya tiene contraseña. Entra o restablécela.": "That email already has a password. Sign in or reset it.",
  "La contraseña debe tener al menos 6 caracteres.": "The password must be at least 6 characters.",
  "Demasiados intentos. Espera unos minutos.": "Too many attempts. Wait a few minutes.",
  "Confirma tu correo: te reenviamos el enlace. Después vuelve a entrar.": "Confirm your email: we sent the link again. Then sign in again.",
  "Confirma tu correo antes de entrar.": "Confirm your email before signing in.",
  "No se pudo verificar tu cuenta.": "Your account couldn't be verified.",
  "No se pudo iniciar sesión. Inténtalo de nuevo.": "Couldn't sign in. Try again.",
  "Listo: te enviamos un enlace para confirmar tu correo. Ábrelo y luego entra.": "Done: we sent you a link to confirm your email. Open it, then sign in.",
  "Escribe tu email y vuelve a pulsar \"¿Olvidaste tu contraseña?\".": "Type your email and press \"Forgot your password?\" again.",
  "Te enviamos un correo para restablecer la contraseña.": "We sent you an email to reset your password.",
  "Conectando…": "Connecting…",
  "Continuar con Google": "Continue with Google",
  "Mantener sesión iniciada": "Keep me signed in",
  "Email": "Email",
  "Contraseña": "Password",
  "Entrar": "Sign in",
  "Nueva contraseña (mín. 6)": "New password (min. 6)",
  "Crear contraseña": "Create password",
  "Primera vez: crear contraseña": "First time: create a password",
  "Ya tengo contraseña": "I already have a password",
  "¿Olvidaste tu contraseña?": "Forgot your password?",
  "RFC copiado.": "Tax ID copied.",
  "No se pudo copiar el RFC.": "Couldn't copy the tax ID.",
  "Facturar a": "Bill to",
  "· RFC": "· Tax ID",
  "· CP": "· ZIP",
  "RFC": "Tax ID",
  "Servidor conectado": "Server connected",
  "Servidor desconectado": "Server disconnected",
  "Sin conexión con el servidor; reintentando en segundo plano": "No connection to the server; retrying in the background",
  "Guardando en el servidor": "Saving to the server",
  "Guardando": "Saving",
  "Cambios guardados": "Changes saved",
  "Eliminar gasto": "Delete expense",
  "¿Eliminar \"{0}\" ({1})?": "Delete \"{0}\" ({1})?",
  "Gasto eliminado": "Expense deleted",
  "Total gastos": "Total expenses",
  "Súper": "Grocery",
  "Suma en \"Total compras Súper\" del Corte": "Counts toward \"Total grocery purchases\" in the daily close",
  "\"{0}\" también quedó en Gastos": "\"{0}\" was also added to Expenses",
  "Gasto actualizado": "Expense updated",
  "No hay proveedores. Agrégalos en Ajustes → Catálogos.": "No suppliers yet. Add them in Settings → Catalogs.",
  "Proveedor / Concepto": "Supplier / Item",
  "Busca o escribe un proveedor nuevo…": "Search or type a new supplier…",
  "Proveedor o concepto": "Supplier or item",
  "Método de pago": "Payment method",
  "No hay métodos de pago activos: agrégalos o reactívalos en Ajustes → Catálogos.": "No active payment methods: add or reactivate them in Settings → Catalogs.",
  "Método": "Method",
  "Aplica IVA": "Includes VAT",
  "Agregar gasto": "Add expense",
  "Agregar Gasto": "Add Expense",
  "Monto de IVA": "VAT amount",
  "Se prellena con el 16% del total; pon el EXACTO del comprobante si difiere.": "Prefilled with 16% of the total; enter the EXACT amount from the receipt if it differs.",
  "Sin gastos esta semana. Agrega el primero con el formulario de arriba.": "No expenses this week. Add the first one with the form above.",
  "Sin gastos este día. Agrega el primero con el formulario de arriba.": "No expenses this day. Add the first one with the form above.",
  "Sin IVA": "No VAT",
  "Editar gasto": "Edit expense",
  "Total compras Súper": "Total grocery purchases",
  "Busca o escribe un proveedor…": "Search or type a supplier…",
  "Monto": "Amount",
  "El IVA del comprobante, no el total (ej. $160).": "The receipt's VAT, not the total (e.g. $160).",
  "Cancelar": "Cancel",
  "Guardar": "Save",
  "Gastos": "Expenses",
  "Eliminar": "Delete",
  "Meseros": "Waiters",
  "Mesero": "Waiter",
  "Efectivo": "Cash",
  "Propina Domingo": "Sunday tips",
  "Efectivo a entregar": "Cash to hand over",
  "Cocina / Limpieza": "Kitchen / Cleaning",
  "Cocina": "Kitchen",
  "Empleado": "Employee",
  "Empleados": "Employees",
  "Hoja de pago en efectivo": "Cash pay sheet",
  "Semana del": "Week of",
  "al": "to",
  "Total en efectivo": "Total cash",
  "Fondo de caja (": "Cash float (",
  "A retirar del banco": "To withdraw from the bank",
  "Total": "Total",
  "Acceso al sistema": "Sign in",
  "Entra con Google o con tu email": "Sign in with Google or your email",
  "Tu cuenta no está autorizada en este espacio de trabajo. Pide al administrador que te agregue.": "Your account isn't authorized in this workspace. Ask the administrator to add you.",
  "Resumen completo de nómina ·": "Full payroll summary ·",
  "Rol": "Role",
  "Días/Turnos": "Days/Shifts",
  "Faltas": "Absences",
  "Salario": "Wage",
  "Propinas": "Tips",
  "Restablecer negocio a valores de fábrica": "Reset business to factory settings",
  "Restablecer a valores de fábrica": "Reset to factory settings",
  "Alta: {0}": "Created: {0}",
  "Borra todos los datos del negocio y vuelve a empezar desde el asistente de configuración. Tu cuenta no se elimina.": "Deletes all business data and starts over from the setup wizard. Your account is not deleted.",
  "Zona de peligro": "Danger zone",
  "Confirmar reinicio": "Confirm reset",
  "Restableciendo…": "Resetting…",
  "No se pudo restablecer el negocio.": "The business could not be reset.",
  "Confirmación": "Confirmation",
  "o": "or",
  "Para continuar, escribe": "To continue, type",
  "Negocio restablecido. Al entrar, su administrador verá el asistente de configuración.": "Business reset. On next login its admin will see the setup wizard.",
  "Se borrarán para siempre el personal, la nómina, los gastos, los ingresos, los cortes, los préstamos y los catálogos. Las cuentas de acceso y la suscripción se conservan. Esta acción no se puede deshacer.": "Staff, payroll, expenses, income, daily closes, loans and catalogs will be permanently deleted. Access accounts and the subscription are kept. This cannot be undone.",
  "Se borrarán para siempre el personal, la nómina, los gastos, los ingresos, los cortes, los préstamos y los catálogos. Tu cuenta y tu suscripción se conservan. Esta acción no se puede deshacer.": "Staff, payroll, expenses, income, daily closes, loans and catalogs will be permanently deleted. Your account and subscription are kept. This cannot be undone.",
  "Restablecer negocio": "Reset business",
  "Si las activas, el cierre de caja y la nómina incluyen propinas. Puedes cambiarlo después en Ajustes.": "If enabled, the cash-up and payroll include tips. You can change it later in Settings.",
  "¿Tu negocio recibe propinas de clientes?": "Does your business receive customer tips?",
  "Sí: se capturan y se reparten.": "Yes: tips are recorded and shared.",
  "No: no verás nada de propinas.": "No: tips are hidden everywhere.",
  "Si lo apagas se ocultan las propinas en el corte, la nómina y los reportes.": "Turning it off hides tips in the cash-up, payroll and reports.",
  "Entradas (Terminales + CASH) − (Fondo + Venta)": "Inflows (Terminals + CASH) − (Float + Sales)",
  "Propinas activadas.": "Tips enabled.",
  "Propinas desactivadas.": "Tips disabled.",
  "Extras": "Extras",
  "Deducciones": "Deductions",
  "Neto": "Net",
  "Nómina": "Payroll",
  "Nomina": "Payroll",
  "Efectivo a dif.": "Cash diff.",
  "TOTAL": "TOTAL",
  "Papelería y artículos de oficina": "Stationery and office supplies",
  "Garrafones de agua": "Water jugs",
  "Neto = Nómina (transferencia bancaria) + Efectivo a dif. (efectivo a entregar; incluye las propinas).": "Net = Payroll (bank transfer) + Cash diff. (cash to hand over; includes tips).",
  "Detalle de faltas": "Absence details",
  "Alguien más está editando": "Someone else is editing",
  "en este momento.": "right now.",
  "Hay otra sesión abierta": "Another session is open",
  "Hay {0} sesiones abiertas": "{0} sessions are open",
  ". Captura en coordinación para no sobrescribir los datos de otro dispositivo.": ". Coordinate your edits so you don't overwrite another device's data.",
  "Recibo de pago ·": "Pay slip ·",
  "Total de la semana": "Week total",
  "Depósito de nómina": "Payroll deposit",
  "Efectivo a pagar": "Cash to pay",
  "Saldo pendiente de préstamo:": "Outstanding loan balance:",
  "Faltas en la semana": "Absences this week",
  "{0} h": "{0} h",
  "Día": "Day",
  "Normal": "Regular",
  "Feriado": "Holiday",
  "Importe": "Amount",
  "Sin horas registradas.": "No hours recorded.",
  "Salario de la semana{0}": "Weekly wage{0}",
  "Bono de puntualidad": "Punctuality bonus",
  "Bono de puntualidad: perdido por falta": "Punctuality bonus: lost due to absence",
  "Extra por puesto": "Position extra",
  "Séptimo día": "Paid day off",
  "{0} × {1}/{2} días": "{0} × {1}/{2} days",
  "manual": "manual",
  "Calculado: {0}": "Calculated: {0}",
  "Calculado: {0}. Borra el monto para volver al cálculo.": "Calculated: {0}. Clear the amount to go back to the calculation.",
  "Extra de propinas": "Tip extra",
  "Pagos extras": "Extra payments",
  "Vacaciones": "Vacation",
  "Préstamos": "Loans",
  "Día / turno": "Day / shift",
  "Modalidad": "Type",
  "Base": "Base",
  "Propina": "Tip",
  "Turno": "Shift",
  "Sin turnos registrados.": "No shifts recorded.",
  "Salario (base × feriado)": "Wage (base × holiday)",
  "Sin proveedor": "No supplier",
  "{0} gasto{1} guardado{2}": "{0} expense{1} saved",
  "{0} en este dispositivo; se suben al reconectar.": "{0} on this device; they'll upload when you reconnect.",
  "Escanear comprobantes": "Scan receipts",
  "Fotografía uno o varios tickets. Revisa los datos antes de guardar.": "Photograph one or more receipts. Check the details before saving.",
  "Tomar foto": "Take photo",
  "Elegir archivos": "Choose files",
  "Analizando foto…": "Analyzing photo…",
  "Gasto manual": "Manual expense",
  "Quitar de la lista": "Remove from list",
  "Leyendo el comprobante…": "Reading the receipt…",
  "Comercio": "Store",
  "IVA": "VAT",
  "Descripción": "Description",
  "Descartar": "Discard",
  "Para facturar": "To invoice",
  "Se registran el": "They're recorded on",
  "(el día elegido arriba), no en la fecha impresa en el ticket.": "(the day chosen above), not the date printed on the receipt.",
  "Guardando…": "Saving…",
  "Guardar {0} gasto{1} ({2})": "Save {0} expense{1} ({2})",
  "Agregar otro gasto a la lista": "Add another expense to the list",
  "Terminales e ingresos": "Terminals and income",
  "Cómo te pagan tus clientes. CASH siempre está.": "How your customers pay you. CASH is always included.",
  "Métodos de pago": "Payment methods",
  "Con qué pagas tus gastos.": "What you pay your expenses with.",
  "Opcional: también se agregan solos al capturar gastos.": "Optional: they're also added automatically when you record expenses.",
  "Tarjeta": "Card",
  "Transferencia": "Transfer",
  "Proveedores": "Suppliers",
  "Conceptos de salida de efectivo": "Cash outflow items",
  "Para qué sale dinero de la caja.": "What cash leaves the register for.",
  "Tu negocio": "Your business",
  "Tus catálogos": "Your catalogs",
  "Listo": "Done",
  "Configura tu negocio": "Set up your business",
  "Paso": "Step",
  "Continuar": "Continue",
  "El logo pesa más de 1 MB.": "The logo is larger than 1 MB.",
  "No se pudo subir el logo.": "Couldn't upload the logo.",
  "No se pudo guardar el nombre.": "Couldn't save the name.",
  "¡Bienvenido a Soedia!": "Welcome to Soedia!",
  "Configura tu negocio en un minuto. Todo se puede cambiar después en Ajustes.": "Set up your business in a minute. You can change everything later in Settings.",
  "Subir logo": "Upload logo",
  "Cambiar": "Change",
  "Sube tu logo": "Upload your logo",
  "PNG, JPG o WebP, máximo 1 MB. Aparece en la app, los recibos y la hoja de efectivo.": "PNG, JPG or WebP, up to 1 MB. It appears in the app, pay slips and the cash sheet.",
  "Nombre del negocio": "Business name",
  "Elige tus catálogos": "Choose your catalogs",
  "Palomea lo que usas o agrega lo tuyo.": "Tick what you use or add your own.",
  "Agregar otro…": "Add another…",
  "Agregar a {0}": "Add to {0}",
  "Agregar": "Add",
  "No se pudo agregar el número.": "Couldn't add the number.",
  "WhatsApp": "WhatsApp",
  "(opcional)": "(optional)",
  "Manda la foto de un ticket por WhatsApp y Soedia lo registra como gasto. Agrega los teléfonos que pueden mandarlos": "Send a photo of a receipt over WhatsApp and Soedia records it as an expense. Add the phones allowed to send them",
  "al número": "to the number",
  "Con código de país, p. ej. 5216641234567": "With country code, e.g. 5216641234567",
  "Teléfono autorizado": "Authorized phone",
  "Quitar +{0}": "Remove +{0}",
  "Saltar por ahora": "Skip for now",
  "Te mostramos en 30 segundos dónde está cada cosa.": "We'll show you where everything is in 30 seconds.",
  "Ver el recorrido": "Take the tour",
  "Verificando conexión…": "Checking connection…",
  "Sincronizado con el servidor.": "Synced with the server.",
  "No se pudo sincronizar. Revisa la conexión e inténtalo de nuevo.": "Couldn't sync. Check your connection and try again.",
  "Sincronizar con el servidor": "Sync with the server",
  "Sincronizar con el servidor (volver a leer todo sin recargar la página)": "Sync with the server (reload everything without refreshing the page)",
  "Este negocio no existe": "This business doesn't exist",
  "No encontramos el subdominio que usaste. Revisa la dirección o contacta a quien te la dio.": "We couldn't find that subdomain. Check the address or contact whoever gave it to you.",
  "Sesión de otro negocio": "Session from another business",
  "Tu sesión pertenece a otro subdominio. Cierra sesión y vuelve a entrar desde el subdominio correcto.": "Your session belongs to another subdomain. Sign out and sign in again from the right subdomain.",
  "Cuenta suspendida": "Account suspended",
  "Esta cuenta de negocio está suspendida. Contacta al administrador de Soedia.": "This business account is suspended. Contact the Soedia administrator.",
  "Sesión sin negocio": "Session without a business",
  "Tu sesión ya no apunta a ningún negocio. Cierra sesión y vuelve a entrar.": "Your session no longer points to any business. Sign out and sign in again.",
  "Cambiar a modo claro": "Switch to light mode",
  "Cambiar a modo oscuro": "Switch to dark mode",
  "Claro": "Light",
  "Oscuro": "Dark",
  "Cerrar aviso": "Dismiss",
  "Guardado exitosamente": "Saved",
  "Semana anterior": "Previous week",
  "Martes a domingo": "Tuesday to Sunday",
  "Semana siguiente": "Next week",
  "Recargar la semana desde el servidor": "Reload the week from the server",
  "Reporte generado": "Report generated",
  "No se pudo generar el reporte. Intenta de nuevo.": "Couldn't generate the report. Try again.",
  "CSV generado": "CSV generated",
  "No se pudo generar el CSV. Intenta de nuevo.": "Couldn't generate the CSV. Try again.",
  "Reporte semanal": "Weekly report",
  "No hay ingresos ni gastos registrados en esta semana.": "No income or expenses recorded this week.",
  "Reporte (PNG)": "Report (PNG)",
  "CSV": "CSV",
  "Reporte de cuentas ·": "Accounts report ·",
  "Reporte de cuentas": "Accounts report",
  "INGRESOS": "INCOME",
  "Total ingresos": "Total income",
  "EGRESOS": "EXPENSES",
  "Total egresos": "Total expenses",
  "RESUMEN": "SUMMARY",
  "Resumen": "Summary",
  "Utilidad": "Profit",
  "IVA cobrado (16%)": "VAT collected (16%)",
  "IVA pagado (facturado)": "VAT paid (invoiced)",
  "IVA cobrado": "VAT collected",
  "IVA pagado": "VAT paid",
  "IVA a pagar": "VAT due",
  "Egresos sin factura": "Expenses without invoice",
  "* Egreso con factura. IVA cobrado = 16% de los ingresos; IVA pagado = solo el de los comprobantes con factura. Los egresos sin factura no son deducibles.": "* Invoiced expense. VAT collected = 16% of income; VAT paid = only from invoiced receipts. Expenses without an invoice aren't deductible.",
  "Ingresos": "Income",
  "Egresos": "Expenses",
  "Egresos sin factura (no deducibles):": "Expenses without invoice (not deductible):",
  "Ingresos por medio de pago": "Income by payment type",
  "Egresos por proveedor": "Expenses by supplier",
  "Salidas por método de pago": "Outflows by payment method",
  "Cubre de martes a domingo. No incluye pagos de nómina.": "Covers Tuesday to Sunday. Doesn't include payroll payments.",
  "Día anterior": "Previous day",
  "Día siguiente": "Next day",
  "Hoy": "Today",
  "Elegir fecha": "Choose date",
  "Anterior": "Previous",
  "Limpiar fecha": "Clear date",
  "Cerrar opciones": "Close options",
  "Mostrar opciones": "Show options",
  "Nuevo: «": "New: «",
  "» (se agrega al catálogo al guardar)": "» (added to the catalog when you save)",
  "Cerrar": "Close",
  "Confirmar": "Confirm",
  "Aceptar": "OK",
  "Online": "Online",
  "Offline": "Offline",
  "Reconectando…": "Reconnecting…",
  "No se encontró el recibo a exportar": "The pay slip to export wasn't found",
  "No se pudo generar la imagen": "Couldn't generate the image",
  "No se pudo convertir la imagen a base64": "Couldn't convert the image to base64",
  "Datos de Facturación {0} - RFC: {1} | CP: {2}": "Billing details {0} - Tax ID: {1} | ZIP: {2}",
  "Martes": "Tuesday",
  "Miércoles": "Wednesday",
  "Jueves": "Thursday",
  "Viernes": "Friday",
  "Sábado": "Saturday",
  "Domingo": "Sunday",
  "Mar": "Tue",
  "Mié": "Wed",
  "Jue": "Thu",
  "Vie": "Fri",
  "Sáb": "Sat",
  "Dom": "Sun",
  "{0}, {1} de {2} de {3}": "{0}, {2} {1}, {3}",
  "FACTURA No.": "INVOICE No.",
  "Gastos facturados {0}": "Invoiced expenses {0}",
  "Resumen de nómina": "Payroll summary",
  "{0} a {1}": "{0} to {1}",
  "No se pudo guardar: otro dispositivo no deja de cambiar esos datos": "Couldn't save: another device keeps changing that data",
  "La semana {0} sigue en conflicto tras varios intentos": "Week {0} is still in conflict after several attempts",
  "Hola {0}, aquí tienes tu recibo de nómina de esta semana.": "Hi {0}, here's your pay slip for this week.",
  "Tarde": "Afternoon",
  "Noche": "Night",
  "Asistencia": "Attended",
  "Asueto": "Day off",
  "Falta": "Absent",
  "Otro": "Other",
  "Fecha": "Date",
  "Concepto": "Item",
  "Proveedor": "Supplier",
  "Metodo": "Method",
  "Facturado": "Invoiced",
  "Si": "Yes",
  "No": "No",
  "No hay tipos de ingreso. Agrégalos en Ajustes → Catálogos.": "No income types yet. Add them in Settings → Catalogs.",
  "Gastos en efectivo del día": "Today's cash expenses",
  "{0} del {1}": "{0} for {1}",
  "Total del día": "Day total",
  "Todavía no hay ingresos esta semana.": "No income yet this week.",
  "Resumen del día": "Day summary",
  "Balance del día": "Day balance",
  "Balance": "Balance",
  "Diario": "Daily",
  "Semanal": "Weekly",
  "Resumen del período": "Period summary",
  "Entradas": "Income",
  "Fondo y venta del día": "Float and day's sales",
  "Fondo de Caja": "Cash float",
  "Auto: es el retiro «Caja» del": "Auto: it's the «Register» withdrawal from",
  ". Puedes editarlo.": ". You can edit it.",
  "Venta del Día": "Day's sales",
  "Propina Tarde": "Afternoon tips",
  "Propina Noche": "Night tips",
  "Total propinas": "Total tips",
  "Apunte de compras durante el cierre. Las pagadas con CASH que salieron del cajón cuentan en el Cajón.": "Purchases made during closing. Those paid with CASH out of the drawer count in the Drawer.",
  "El {0} YA se cerró ({1}). Al continuar se manda otra vez el resumen por WhatsApp y el correo con el respaldo. ¿Reenviar el cierre?": "{0} was ALREADY closed ({1}). Continuing sends the WhatsApp summary and the backup email again. Resend the closing?",
  "Se guardará y cerrará el corte del {0}: llegará un resumen corto por WhatsApp a los números autorizados y el resumen completo con los tickets de ESE día por correo. ¿Terminar el día?": "The cash-up for {0} will be saved and closed: a short summary goes by WhatsApp to the authorized numbers and the full summary with THAT day's receipts by email. Close the day?",
  "Reenviar cierre": "Resend closing",
  "Reenviar": "Resend",
  "Terminar el día": "Close the day",
  "Terminar el Día": "Close the Day",
  "Hay cambios sin guardar en el servidor. Revisa la conexión e inténtalo de nuevo.": "There are changes not saved to the server. Check your connection and try again.",
  "No se pudo cerrar el día. Revisa la conexión e inténtalo de nuevo.": "Couldn't close the day. Check your connection and try again.",
  "Día de descanso: la caja no se cierra": "Rest day: the register isn't closed",
  "Los lunes el negocio no abre. El fondo del martes arrastra el cierre del domingo.": "The business is closed on Mondays. Tuesday's float carries over Sunday's closing.",
  "Terminando el día…": "Closing the day…",
  "Día ya cerrado el": "Day already closed on",
  "Es el último día sin cerrar.": "This is the latest day that hasn't been closed.",
  "No olvides cerrar el día": "Don't forget to close the day",
  "Ya llenaste el corte del {0}, pero sigue abierto. Pulsa «Terminar el Día» para guardarlo y mandar el respaldo.": "You filled in the cash-up for {0}, but it's still open. Tap “Close the Day” to save it and send the backup.",
  "Ir a cerrar": "Go to close",
  "¿Olvidaste cerrar el día?": "Forgot to close the day?",
  "El corte del {0}, ya tiene todo lo obligatorio, pero no se ha cerrado. Sin cerrarlo no se manda el respaldo ni pasa el fondo al día siguiente.": "The cash-up for {0} has everything required, but it hasn't been closed. Until it's closed, the backup isn't sent and the float doesn't carry over to the next day.",
  "Ir a cerrarlo": "Go close it",
  "Después": "Later",
  ". Si vuelves a cerrarlo se reenvía el correo.": ". Closing it again resends the email.",
  "Marca en Nóminas quién trabajó para repartirla.": "Mark who worked in Payroll to split them.",
  "Nóminas:": "Payroll:",
  "c/u ·": "each ·",
  "Día de Descanso (Lunes)": "Rest Day (Monday)",
  "Caja cerrada": "Register closed",
  "La caja no abre; el fondo del martes arrastra el cierre del domingo.": "The register doesn't open; Tuesday's float carries over Sunday's closing.",
  "Diferencia de Caja": "Register Difference",
  "Entradas (Terminales + CASH) − (Fondo + Venta + Propinas)": "Income (Terminals + CASH) − (Float + Sales + Tips)",
  "CASH": "CASH",
  "EFECTIVO": "CASH",
  "CAJÓN": "DRAWER",
  "Entradas (Terminales + Cajón) − (Fondo + Venta + Propinas)": "Income (Terminals + Drawer) − (Float + Sales + Tips)",
  "Entradas (Terminales + Cajón) − (Fondo + Venta)": "Income (Terminals + Drawer) − (Float + Sales)",
  "Cómo entra el dinero: efectivo, terminales, transferencias…": "How money comes in: cash, terminals, transfers…",
  "Suma de movimientos del cajón": "Sum of drawer movements",
  "No hay terminales activos. Agrégalos o reactívalos en Ajustes → Catálogos → Tipos de ingresos.": "No active terminals. Add or reactivate them in Settings → Catalogs → Income types.",
  "Total entradas": "Total income",
  "Cajón": "Drawer",
  "Caja": "Register",
  "Salida": "Outflow",
  "Efectivo que queda en el cajón · Fondo del {0}": "Cash left in the drawer · Float for {0}",
  "Otra salida": "Other outflow",
  "Concepto de la salida": "Outflow item",
  "Monto de la salida": "Outflow amount",
  "Agregar salida": "Add outflow",
  "Sin salidas": "No outflows",
  "Gasto pagado en CASH · se edita en Gastos": "Expense paid in CASH · edit it in Expenses",
  "Se edita en Gastos": "Edit it in Expenses",
  "Total salidas": "Total outflows",
  "Mes anterior": "Previous month",
  "Mes siguiente": "Next month",
  "Este mes": "This month",
  "Sin IVA desglosado": "No itemized VAT",
  "Importe gravado": "Taxable amount",
  "IVA de {0}": "VAT for {0}",
  "Factura No.": "Invoice No.",
  "Parte del gasto que no paga IVA: Total − Importe gravado − IVA": "Part of the expense without VAT: Total − Taxable amount − VAT",
  "Código de ticket/factura": "Receipt/invoice code",
  "Código de ticket/factura de {0}": "Receipt/invoice code for {0}",
  "Marcar como facturado": "Mark as invoiced",
  "Código:": "Code:",
  "Deshacer: {0} vuelve a pendientes": "Undo: {0} goes back to pending",
  "Regresar a pendientes": "Back to pending",
  "Deshacer": "Undo",
  "Agregar gasto facturado": "Add invoiced expense",
  "Para gastos que no se capturaron en la app. Se guarda ya facturado y aparece también en Cuentas ese día.": "For expenses not recorded in the app. It's saved as invoiced and also shows in Accounts on that day.",
  "Fecha del gasto": "Expense date",
  "No hay métodos de pago activos: agrégalos en Ajustes → Catálogos.": "No active payment methods: add them in Settings → Catalogs.",
  "Total del gasto": "Expense total",
  "El del comprobante ({0} si no trae).": "The receipt's ({0} if it has none).",
  "IVA del gasto": "Expense VAT",
  "El IVA no puede ser más del 16% del total.": "VAT can't be more than 16% of the total.",
  "· Importe gravado": "· Taxable amount",
  "· IVA": "· VAT",
  "Código de ticket/factura (opcional)": "Receipt/invoice code (optional)",
  "No se pudo exportar: {0}": "Couldn't export: {0}",
  "Exportar gastos facturados de": "Export invoiced expenses for",
  "Excel": "Excel",
  "Facturado: {0} · {1}": "Invoiced: {0} · {1}",
  "Agregado a facturados: {0} · {1} ({2})": "Added to invoiced: {0} · {1} ({2})",
  "Hay 1 gasto pendiente": "There's 1 pending expense",
  "Hay {0} gastos pendientes": "There are {0} pending expenses",
  "de meses anteriores. Ver": "from previous months. See",
  "Pendientes por facturar": "Pending invoice",
  "Tickets con IVA 0": "Zero-VAT receipts",
  "Solo hay tickets con IVA 0 en {0}.": "Only zero-VAT receipts in {0}.",
  "Todo facturado este mes. ✓": "Everything invoiced this month. ✓",
  "Sin gastos con IVA en {0}.": "No expenses with VAT in {0}.",
  "Gastos facturados": "Invoiced expenses",
  "Aún no hay gastos facturados en": "No invoiced expenses yet in",
  "Total facturado": "Total invoiced",
  "Corte del {0}: propina {1} = {2}": "Cash-up for {0}: {1} tips = {2}",
  "Sin captura esta semana": "Nothing recorded this week",
  "falta(s)": "absence(s)",
  "Ocultar detalle de {0}": "Hide details for {0}",
  "Ver detalle de {0}": "Show details for {0}",
  "Desglose": "Breakdown",
  "Bonos": "Bonuses",
  "Bono": "Bonus",
  "Descuento de préstamo": "Loan deduction",
  "Total a pagar": "Total to pay",
  "Se paga: depósito": "Paid as: deposit",
  "· efectivo": "· cash",
  "Préstamo": "Loan",
  "Saldo del préstamo": "Loan balance",
  "Después de esta semana:": "After this week:",
  "Descuento esta semana": "Deduction this week",
  "Ajustes de la semana": "This week's adjustments",
  "Se precargan desde Ajustes y aquí se pueden cambiar solo para esta semana.": "Preloaded from Settings; changes here apply to this week only.",
  "Toca una tarjeta para ver el desglose; el pago se marca en el resumen de la semana.": "Tap a card to see the breakdown; payment is marked in the week summary.",
  "Faltas del día": "Day's absences",
  "Marcar falta de {0}": "Mark {0} absent",
  "Con falta": "Absent",
  "Propina cada uno": "Tip each",
  "Propina por persona del turno {0}": "Tip per person, {0} shift",
  "Cerrado": "Closed",
  "¿Quién trabajó?": "Who worked?",
  "Por horas": "Hourly",
  "Propina por persona del día": "Tip per person for the day",
  "¿Quién trabajó este día?": "Who worked this day?",
  "{0}: con falta": "{0}: absent",
  "{0}: asistencia (clic para quitar)": "{0}: attended (click to remove)",
  "{0}: marcar asistencia": "{0}: mark attended",
  "Cada asistente recibe": "Each attendee gets",
  "de propina": "in tips",
  "{0} propina": "{0} tips",
  "Sin turnos capturados": "No shifts recorded",
  "Día feriado (×3)": "Holiday (×3)",
  "Por horas (sin turnos)": "Hourly (no shifts)",
  "Día Feriado ×3": "Holiday ×3",
  "Feriado ×3": "Holiday ×3",
  "Marcar asistencia": "Mark attended",
  "Marcar falta": "Mark absent",
  "Día de Asueto — {0}": "Day off — {0}",
  "{0} marcada · clic para desmarcar (queda Asueto) — {1}": "{0} marked · click to unmark (becomes Day off) — {1}",
  "Leyenda de estados de asistencia": "Attendance status legend",
  "Leyenda": "Legend",
  "Asueto / Descanso": "Day off / Rest",
  "(sin marcar)": "(unmarked)",
  "Día / Turno": "Day / Shift",
  "Propina por persona, {0} {1}": "Tip per person, {0} {1}",
  "suma el turno a la nómina;": "adds the shift to payroll;",
  "cuenta en el resumen de la semana; y sin marcar nada el turno queda en": "counts in the week summary; and with nothing marked the shift stays as",
  ". Toca el estado activo para desmarcarlo.": ". Tap the active status to unmark it.",
  "Salario base (× feriado)": "Base wage (× holiday)",
  "Tarde {0} · Noche {1}": "Afternoon {0} · Night {1}",
  "esta semana. En meseros las faltas no cambian la nómina; queda como registro.": "this week. For waiters, absences don't change payroll; they're kept as a record.",
  "Turnos de la semana": "Shifts this week",
  "propina": "tips",
  "No hay meseros. Agrégalos en Ajustes.": "No waiters yet. Add them in Settings.",
  "Guía rápida": "Quick guide",
  "Toca": "Tap",
  "· sin marcar =": "· unmarked =",
  "Nómina individual": "Individual payroll",
  "Quitar falta": "Remove absence",
  "Con falta · clic para quitar": "Absent · click to remove",
  "Sin horas capturadas": "No hours recorded",
  "Horas de {0} el {1}": "{0}'s hours on {1}",
  "Pago de los días": "Pay for the days",
  "Desactivado esta semana": "Disabled this week",
  "Puntualidad": "Punctuality",
  "Bono de puntualidad de {0} ({1})": "{0}'s punctuality bonus ({1})",
  "esta semana: sin bono de puntualidad.": "this week: no punctuality bonus.",
  "No hay personal de cocina. Agrégalo en Ajustes.": "No kitchen staff yet. Add them in Settings.",
  "Horas · Feriado · Faltas": "Hours · Holiday · Absences",
  "Extra de propinas (fin de mes)": "Tip extra (month end)",
  "Pagado (toca para deshacer)": "Paid (tap to undo)",
  "Pendiente de pago (toca para marcar pagado)": "Unpaid (tap to mark paid)",
  "{0}, efectivo {1}: {2}": "{0}, cash {1}: {2}",
  "Desmarcar": "Unmark",
  "Desmarcar todos": "Unmark all",
  "¿Quitar la marca de pagado a todos los empleados de esta semana?": "Remove the paid mark from every employee this week?",
  "No se pudo generar el resumen. Intenta de nuevo.": "Couldn't generate the summary. Try again.",
  "No se pudo compartir el resumen. Intenta de nuevo.": "Couldn't share the summary. Try again.",
  "No se encontró la hoja de efectivo": "The cash sheet wasn't found",
  "No se pudo generar la hoja de efectivo. Intenta de nuevo.": "Couldn't generate the cash sheet. Try again.",
  "Resumen completo de la semana": "Full week summary",
  "Todos los empleados; se exporta con el desglose de cada uno.": "All employees; exported with each one's breakdown.",
  "Neto total": "Total net",
  "Resumen (PNG)": "Summary (PNG)",
  "Generando PDF...": "Generating PDF...",
  "Hoja de Efectivo": "Cash Sheet",
  "Compartir": "Share",
  "Pagados": "Paid",
  "Marcar todos": "Mark all",
  "Por pagar": "To pay",
  "Todos pagados": "All paid",
  "Empleados pagados": "Employees paid",
  "días/turnos · Salario": "days/shifts · Wage",
  "· Propinas": "· Tips",
  "{0} al {1}": "{0} to {1}",
  "Reporte de nómina enviado a {0}.": "Payroll report sent to {0}.",
  "No se pudo enviar el reporte de nómina. Intenta de nuevo.": "Couldn't send the payroll report. Try again.",
  "Enviando reporte…": "Sending report…",
  "Enviar Reporte Semanal de Nómina": "Send Weekly Payroll Report",
  "Normalmente se envía el domingo, al cerrar la semana.": "Usually sent on Sunday, when closing the week.",
  "Enviar reporte de nómina": "Send payroll report",
  "Se enviará por correo la nómina de la semana del": "The payroll will be emailed for the week of",
  "empleado(s), costo total": "employee(s), total cost",
  "en efectivo.": "in cash.",
  "Enviando…": "Sending…",
  "Sí, enviar": "Yes, send",
  "Semana cerrada. Nómina de {0} registrada en Cuentas.": "Week closed. Payroll of {0} recorded in Accounts.",
  "Semana cerrada y limpiada.": "Week closed and cleared.",
  "No se pudo cerrar la semana. Intenta de nuevo.": "Couldn't close the week. Try again.",
  "Cerrar la semana": "Close the week",
  "Finaliza el periodo: registra la nómina de la semana en Cuentas, descuenta del saldo de préstamo lo pagado y borra el detalle capturado (turnos, propinas, asistencias).": "Ends the period: records the week's payroll in Accounts, deducts what was paid from loan balances and clears the recorded details (shifts, tips, attendance).",
  "Exporta antes": "Export first",
  "si necesitas el resumen. Esta acción no se puede deshacer.": "if you need the summary. This can't be undone.",
  "Cerrar y Limpiar Semana": "Close and Clear Week",
  "Cerrar y limpiar la semana": "Close and clear the week",
  "¿Estás seguro de que deseas cerrar esta semana? Se borrará el detalle capturado de esta semana y se descontarán los préstamos del saldo de cada empleado. Esta acción no se puede deshacer.": "Are you sure you want to close this week? This week's recorded details will be cleared and loans will be deducted from each employee's balance. This can't be undone.",
  "Se registrará en Cuentas": "Will be recorded in Accounts",
  "· fecha": "· date",
  "Costo bruto: sueldos, extras, feriados y bonos. Sin propinas ni deducciones.": "Gross cost: wages, extras, holidays and bonuses. No tips or deductions.",
  "No hay nómina capturada: no se registrará ningún gasto.": "No payroll recorded: no expense will be recorded.",
  "Sí, cerrar semana": "Yes, close week",
  "No se pudo generar el recibo. Intenta de nuevo.": "Couldn't generate the pay slip. Try again.",
  "No se pudo enviar el recibo de {0}: {1}.": "Couldn't send {0}'s pay slip: {1}.",
  "Recibo de {0} enviado por WhatsApp.": "{0}'s pay slip sent over WhatsApp.",
  "No se pudo enviar por WhatsApp. Revisa que el bot esté conectado.": "Couldn't send over WhatsApp. Check that the bot is connected.",
  "Recibos de pago": "Pay slips",
  "Una imagen por empleado con el desglose de la semana.{0}": "One image per employee with the week's breakdown.{0}",
  "Descargar recibo de {0}": "Download {0}'s pay slip",
  "Compartir recibo de {0}": "Share {0}'s pay slip",
  "Enviar recibo de {0} por WhatsApp": "Send {0}'s pay slip over WhatsApp",
  "Salarios base": "Base wages",
  "Resumen de la semana": "Week summary",
  "Resumen del mes": "Month summary",
  "Costo total de nómina": "Total payroll cost",
  "Total en efectivo faltante": "Total cash remaining",
  "Semana recargada desde el servidor.": "Week reloaded from the server.",
  "No se pudo recargar. Revisa la conexión e inténtalo de nuevo.": "Couldn't reload. Check your connection and try again.",
  "Salario por hora": "Hourly wage",
  "Saldo de préstamo": "Loan balance",
  "{0} / hora": "{0} / hour",
  "Salario por turno": "Wage per shift",
  "{0} / turno · {1} / hora": "{0} / shift · {1} / hour",
  "Préstamos, deducciones, pagos extras y vacaciones se precargan cada semana en Nóminas y ahí se pueden modificar.": "Loans, deductions, extra payments and vacation are preloaded every week in Payroll and can be changed there.",
  "Editar {0}": "Edit {0}",
  "Nuevo {0}": "New {0}",
  "Nombre": "Name",
  "Nombre completo": "Full name",
  "Apodo": "Nickname",
  "Mote o cómo le dicen; aparece en los desplegables como “Apodo (Nombre)”. Opcional.": "What people call them; shows in dropdowns as “Nickname (Name)”. Optional.",
  "Ej. El Güero, Chuy, La Güera": "E.g. Blondie, Chuy, Red",
  "Con código de país, solo números. Ej. 52 664 123 4567. Si se deja vacío no aparece el botón de WhatsApp al exportar recibos.": "With country code, numbers only. E.g. 52 664 123 4567. If left empty, the WhatsApp button won't appear when exporting pay slips.",
  "Fecha de Nacimiento": "Date of Birth",
  "Para el recordatorio de cumpleaños por WhatsApp (avisa un día antes). Opcional.": "For the WhatsApp birthday reminder (sent a day before). Optional.",
  "Orden": "Order",
  "Aún no hay": "No",
  "s. Agrega el primero.": "s yet. Add the first one.",
  "Subir a {0}": "Move {0} up",
  "Bajar a {0}": "Move {0} down",
  "Dar de baja a {0}": "Deactivate {0}",
  "Dar de baja": "Deactivate",
  "¿Dar de baja a {0}? Dejará de aparecer en Nóminas y en los desplegables, pero su historial (nóminas, préstamos, capturas) se conserva y pasa a Ex-empleados.": "Deactivate {0}? They'll stop appearing in Payroll and dropdowns, but their history (payroll, loans, records) is kept under Former employees.",
  "{0} vuelve a estar activo.": "{0} is active again.",
  "No se pudo reactivar en el servidor. Revisa la conexión.": "Couldn't reactivate on the server. Check your connection.",
  "Ex-empleados ({0})": "Former employees ({0})",
  "Dados de baja: ya no aparecen en Nóminas ni en los desplegables, pero su historial se conserva. Reactívalos si regresan.": "Deactivated: they no longer appear in Payroll or dropdowns, but their history is kept. Reactivate them if they come back.",
  "Fecha de baja": "Deactivation date",
  "Reactivar a {0}": "Reactivate {0}",
  "Apodos separados por coma (Iceberg Chihuahua, ICEBERG…)": "Nicknames separated by commas (Iceberg Chihuahua, ICEBERG…)",
  "El tipo de ingreso \"CASH\" es obligatorio para el cuadre automático de salidas de efectivo y no puede eliminarse ni reordenarse.": "The \"CASH\" income type is required to automatically balance cash outflows and can't be deleted or reordered.",
  "Fijo": "Fixed",
  "Subir {0}": "Move {0} up",
  "Bajar {0}": "Move {0} down",
  "Eliminar {0}": "Delete {0}",
  "No se pudieron leer los inactivos. Revisa la conexión.": "Couldn't load inactive items. Check your connection.",
  "“{0}” vuelve a estar disponible.": "“{0}” is available again.",
  "“{0}” ya existe en este catálogo.": "“{0}” already exists in this catalog.",
  "No hay opciones activas. Agrega una nueva abajo": "No active options. Add a new one below",
  "recupera las dadas de baja": "restores deactivated ones",
  "¿Dar de baja \"{0}\"? Puedes reactivarla en \"Inactivos\".": "Deactivate \"{0}\"? You can reactivate it under \"Inactive\".",
  "Nueva opción": "New option",
  "Agregar opción": "Add option",
  "Ocultar inactivos": "Hide inactive",
  "Leyendo inactivos…": "Loading inactive…",
  "Ver inactivos": "Show inactive",
  "No hay opciones dadas de baja.": "No deactivated options.",
  "Reactivar {0}": "Reactivate {0}",
  "No se pudo consultar el estado del bot.": "Couldn't check the bot's status.",
  "Estado del Bot de WhatsApp": "WhatsApp Bot Status",
  "Consultando estado…": "Checking status…",
  "El bot está": "The bot is",
  "deshabilitado": "disabled",
  ". Para activarlo define": ". To enable it, set",
  "en el": "in the",
  "del backend y reinícialo.": "of the backend and restart it.",
  "WhatsApp Bot: Conectado": "WhatsApp Bot: Connected",
  "Escanéalo con": "Scan it with",
  ": Ajustes → Dispositivos vinculados → Vincular dispositivo. El código expira en ~20 s y se actualiza solo.": ": Settings → Linked devices → Link a device. The code expires in ~20 s and refreshes by itself.",
  "Actualizar QR": "Refresh QR",
  "Conectando… (esperando el código QR)": "Connecting… (waiting for the QR code)",
  "No se pudieron cargar los números autorizados.": "Couldn't load the authorized numbers.",
  "Escribe el número con código de país y solo dígitos (p. ej. 5216641234567).": "Type the number with country code, digits only (e.g. 5216641234567).",
  "Quitar": "Remove",
  "Quitar número": "Remove number",
  "¿Quitar {0} de los autorizados?": "Remove {0} from the authorized numbers?",
  "Números autorizados": "Authorized numbers",
  "Solo estos números pueden escribirle al bot (fotos, PDF, XML o texto) y reciben el resumen diario. Formato: código de país + número, solo dígitos.": "Only these numbers can message the bot (photos, PDF, XML or text) and they get the daily summary. Format: country code + number, digits only.",
  "Sin números autorizados.": "No authorized numbers.",
  "Quitar {0}": "Remove {0}",
  "Nuevo número autorizado": "New authorized number",
  "Agregar número autorizado": "Add authorized number",
  "Ver recorrido": "Take the tour",
  "Catálogos": "Catalogs",
  "Tipos de ingresos": "Income types",
  "Cómo entra el dinero: CASH, terminales, transferencias…": "How money comes in: CASH, terminals, transfers…",
  "Métodos de pago de gastos": "Expense payment methods",
  "Con qué se pagan las salidas.": "What outflows are paid with.",
  "A quién se le compra. Edita una fila para darle apodos separados por coma (su nombre corto o de factura): así un ticket no duplica el proveedor.": "Who you buy from. Edit a row to give it comma-separated nicknames (its short or invoice name), so a receipt doesn't duplicate the supplier.",
  "Conceptos de Salida": "Outflow Items",
  "Los conceptos del desplegable del Cajón en el Corte. Mismo catálogo: agrégalos, edítalos o arrástralos para cambiar su orden.": "The items in the Drawer dropdown of the Cash-up. Same catalog: add, edit or drag them to reorder.",
  "Este comprobante no tiene archivo.": "This receipt has no file.",
  "No se pudo descargar ({0}).": "Couldn't download ({0}).",
  "Ver ticket de {0} · {1}": "View receipt for {0} · {1}",
  "Comprobante de {0}": "Receipt for {0}",
  "Datos de facturación": "Billing details",
  "Comprobante descargado": "Receipt downloaded",
  "Descargar": "Download",
  "Registro": "Record",
  "Gasto": "Expense",
  "No se pudo cargar la Bóveda.": "Couldn't load the Vault.",
  "Refrescar bóveda": "Refresh vault",
  "Bóveda de Tickets": "Receipt Vault",
  "Fecha de la Bóveda": "Vault date",
  "Sin comprobantes para el": "No receipts for",
  ". Escanea un ticket arriba o envía un recibo de nómina para que aparezca aquí.": ". Scan a receipt above or send a pay slip for it to show up here.",
  "Las fotos se conservan 14 días; las anteriores están en el correo del cierre de caja.": "Photos are kept for 14 days; older ones are in the cash-up email.",
  "comprobante": "receipt",
  "Este dispositivo no tiene espacio para su copia local. Lo capturado se sigue guardando en el servidor mientras haya conexión.": "This device has no space for its local copy. What you enter is still saved to the server while you're online.",
  "El backoffice del super administrador no está disponible en la demo.": "The super admin backoffice isn't available in the demo.",
  "No se pudo cargar la lista.": "Couldn't load the list.",
  "Negocio \"{0}\" creado: {1}.soedia.com. Enviamos a {2} un enlace para crear su contraseña.": "Business \"{0}\" created: {1}.soedia.com. We sent {2} a link to create their password.",
  "Negocio \"{0}\" creado: {1}.soedia.com.": "Business \"{0}\" created: {1}.soedia.com.",
  "No se pudo enviar la invitación a {0} ({1}).": "Couldn't send the invitation to {0} ({1}).",
  "error de correo": "email error",
  "Pásale este enlace para que cree su contraseña:": "Send them this link so they can create their password:",
  "Enlace para crear contraseña": "Link to create password",
  "No se envió el correo a {0}. Pásale este enlace para que cree su contraseña:": "The email to {0} wasn't sent. Send them this link so they can create their password:",
  "El dominio soedia.com aún no está verificado en Resend, así que el correo no salió.": "The soedia.com domain isn't verified in Resend yet, so the email didn't go out.",
  "El servidor de correo rechazó las credenciales (SMTP_USER / SMTP_PASSWORD).": "The mail server rejected the credentials (SMTP_USER / SMTP_PASSWORD).",
  "El servidor de correo no respondió.": "The mail server didn't respond.",
  "El correo no está configurado en el servidor.": "Email isn't configured on the server.",
  "El servidor de correo rechazó el envío.": "The mail server rejected the message.",
  "Copiar": "Copy",
  "Copiado": "Copied",
  "Ese subdominio ya está en uso.": "That subdomain is already taken.",
  "Subdominio no válido o reservado.": "Invalid or reserved subdomain.",
  "No se pudo crear el negocio.": "Couldn't create the business.",
  "Super Admin": "Super Admin",
  "Admin Dashboard": "Admin Dashboard",
  "Backoffice de negocios": "Business backoffice",
  "Cerrar sesión": "Sign out",
  "Nuevo negocio": "New business",
  "Crea el negocio y la cuenta de su administrador. Le llega un correo de hola@soedia.com con un enlace para crear su contraseña (o puede entrar con Google si es Gmail).": "Create the business and its administrator's account. They get an email from hola@soedia.com with a link to create their password (or they can sign in with Google if it's Gmail).",
  "Subdominio": "Subdomain",
  "(.soedia.com)": "(.soedia.com)",
  "Email del administrador": "Administrator email",
  "Creando…": "Creating…",
  "Crear negocio": "Create business",
  "Negocios": "Businesses",
  "Cargando…": "Loading…",
  "Enviamos a {0} un enlace para crear su contraseña.": "We sent {0} a link to create their password.",
  "Sin cambios.": "No changes.",
  "sin administrador": "no administrator",
  "Editar email": "Edit email",
  "Reenviar invitación": "Resend invitation",
  "Borrar": "Delete",
  "Le enviamos la invitación a la dirección nueva.": "We'll send the invitation to the new address.",
  "Guardar email": "Save email",
  "Se borran el negocio, TODOS sus datos y las cuentas de sus usuarios. No se puede deshacer.": "This deletes the business, ALL its data and its users' accounts. It can't be undone.",
  "Escribe {0} para confirmar": "Type {0} to confirm",
  "Borrando…": "Deleting…",
  "Borrar negocio": "Delete business",
  "Este enlace ya caducó o ya se usó. Pide uno nuevo con \"¿Olvidaste tu contraseña?\" en la pantalla de acceso.": "This link has expired or was already used. Request a new one with \"Forgot your password?\" on the sign-in screen.",
  "Algo salió mal. Inténtalo de nuevo.": "Something went wrong. Please try again.",
  "Las contraseñas no coinciden.": "The passwords don't match.",
  "Confirmar correo": "Confirm email",
  "Contraseña creada": "Password created",
  "Crea tu contraseña": "Create your password",
  "Para {0}": "For {0}",
  "Nueva contraseña": "New password",
  "Repite la contraseña": "Repeat the password",
  "Guardar contraseña": "Save password",
  "Tu correo quedó confirmado. Ya puedes entrar.": "Your email is confirmed. You can sign in now.",
  "Listo. Ya puedes entrar con tu email y tu nueva contraseña.": "Done. You can now sign in with your email and your new password.",
  "Ir a la pantalla de acceso": "Go to the sign-in screen",
  "Aún no hay negocios.": "No businesses yet.",
  "Estado": "Status",
  "Creado": "Created",
  "Activo": "Active",
  "Suspendido": "Suspended",
  "Administración": "Administration",
  "Backoffice del super administrador.": "Super administrator backoffice.",
  "Tu cuenta no está autorizada como super administrador.": "Your account isn't authorized as super administrator.",
  "Sesión inválida: la cuenta ya no existe. Vuelve a iniciar sesión.": "Invalid session: the account no longer exists. Sign in again.",
  "Sesión inválida. Vuelve a iniciar sesión.": "Invalid session. Sign in again.",
  "Error interno del servidor": "Internal server error",
  "Número inválido: escribe el teléfono con código de país (p. ej. 5216641234567).": "Invalid number: type the phone with country code (e.g. 5216641234567).",
  "Ese número ya está vinculado a otro espacio de trabajo.": "That number is already linked to another workspace.",
  "Fecha inválida. Usa YYYY-MM-DD.": "Invalid date. Use YYYY-MM-DD.",
  "El bot de WhatsApp no está conectado. Escanea el QR en Ajustes → WhatsApp.": "The WhatsApp bot isn't connected. Scan the QR in Settings → WhatsApp.",
  "Falta el token de Google.": "The Google token is missing.",
  "No se pudo verificar tu cuenta de Google.": "Your Google account couldn't be verified.",
  "Confirma tu correo antes de entrar: revisa el enlace que te enviamos.": "Confirm your email before signing in: check the link we sent you.",
  "Subdominio no encontrado.": "Subdomain not found.",
  "Esta cuenta de negocio está suspendida.": "This business account is suspended.",
  "Tu cuenta no está provisionada en este espacio de trabajo. Pide al administrador que te agregue.": "Your account isn't set up in this workspace. Ask the administrator to add you.",
  "Nombre de archivo inválido": "Invalid file name",
  "Archivo no encontrado": "File not found",
  "La imagen no se pudo decodificar.": "The image couldn't be decoded.",
  "La semana cambió en otro dispositivo": "The week changed on another device",
  "El monto del préstamo debe ser un número mayor a 0.": "The loan amount must be a number greater than 0.",
  "No se encontró al empleado del préstamo.": "The loan's employee wasn't found.",
  "Falta la lista de destinatarios.": "The recipient list is missing.",
  "El bot de WhatsApp no está conectado.": "The WhatsApp bot isn't connected.",
  "La base de datos está ocupada; vuelve a intentarlo en unos segundos.": "The database is busy; try again in a few seconds.",
  "El registro cambió en otro dispositivo": "The record changed on another device",
  "Acceso restringido: solo el super administrador puede entrar al backoffice.": "Restricted: only the super administrator can access the backoffice.",
  "La sesión no pertenece a ningún tenant. Vuelve a iniciar sesión.": "The session doesn't belong to any business. Sign in again.",
  "El tenant de la petición no coincide con tu sesión. Entraste desde otro subdominio.": "The request's business doesn't match your session. You signed in from another subdomain.",
  "Esta cuenta de negocio está suspendida. Contacta al administrador.": "This business account is suspended. Contact the administrator.",
  "El monto del ingreso debe ser un número mayor o igual a 0.": "The income amount must be a number greater than or equal to 0.",
  "El monto del gasto debe ser un número mayor o igual a 0.": "The expense amount must be a number greater than or equal to 0.",
  "Gasto no encontrado.": "Expense not found.",
  "El monto debe ser un número mayor a 0.": "The amount must be a number greater than 0.",
  "Faltan campos: nombre, subdominio, email y contraseña del administrador.": "Missing fields: name, subdomain, administrator email and password.",
  "Email no válido.": "Invalid email.",
  "Ese email ya pertenece a otro negocio.": "That email already belongs to another business.",
  "Ese email ya tiene cuenta en Firebase: usa otro o que entre con su contraseña actual.": "That email already has a Firebase account: use another one, or have them sign in with their current password.",
  "No se pudo crear la contraseña (Firebase).": "Couldn't create the password (Firebase).",
  "Ya existe un ítem con ese nombre en este catálogo.": "An item with that name already exists in this catalog.",
  "El método CASH es obligatorio para el cuadre automático de salidas de efectivo y no puede ser eliminado.": "The CASH method is required to automatically balance cash outflows and can't be deleted.",
  "Ítem de catálogo no encontrado.": "Catalog item not found.",
  "Empleado no encontrado.": "Employee not found.",
  "Negocio no encontrado.": "Business not found.",
  "Escribe el nombre del negocio (máx. 80 caracteres).": "Type the business name (max. 80 characters).",
  "Sube una imagen PNG, JPG o WebP.": "Upload a PNG, JPG or WebP image.",
  "No se pudo guardar el logo.": "Couldn't save the logo.",
  "¡{0} está listo!": "{0} is ready!",
  "empleado": "employee",
  "mesero": "waiter",
  "Idioma": "Language",
  "fondo del": "float for",
  "caja del": "register for",
  "${0}/turno": "${0}/shift",
  "Cambiar idioma a {0}": "Switch language to {0}",
  "El asistente no respondió. Inténtalo de nuevo.": "The assistant didn't respond. Try again.",
  "La imagen pesa más de 8 MB.": "The image is larger than 8 MB.",
  "Abrir asistente": "Open assistant",
  "Asistente": "Assistant",
  "El asistente no está disponible en la demo.": "The assistant isn't available in the demo.",
  "Pregúntame por tus números o manda la foto de un ticket para registrarlo.": "Ask me about your numbers or send a photo of a receipt to record it.",
  "¿Cómo van mis gastos esta semana comparados con la anterior?": "How are my expenses this week compared to last week?",
  "¿Cómo puedo optimizar mis gastos a largo plazo?": "How can I optimize my expenses in the long term?",
  "Foto adjunta": "Attached photo",
  "Pensando…": "Thinking…",
  "Quitar foto": "Remove photo",
  "Adjuntar foto": "Attach photo",
  "Escribe un mensaje…": "Type a message…",
  "Mensaje": "Message",
  "Enviar": "Send",
  "Moneda": "Currency",
  "Impuestos": "Taxes",
  "Los que aparecen al capturar un gasto. El porcentaje se usa para calcular el impuesto incluido en el total.": "The ones offered when you record an expense. The percentage is used to work out the tax included in the total.",
  "Sin impuestos.": "No taxes.",
  "Nombre (p. ej. IVA)": "Name (e.g. VAT)",
  "Nombre del impuesto": "Tax name",
  "Porcentaje": "Percentage",
  "Agregar impuesto": "Add tax",
  "Impuesto": "Tax",
  "Monto de {0}": "{0} amount",
  "Se prellena con el {0}% del total; pon el EXACTO del comprobante si difiere.": "Prefilled with {0}% of the total; enter the EXACT amount from the receipt if it differs.",
  "Sin impuesto": "No tax",
  "El impuesto del comprobante, no el total (ej. $160).": "The receipt's tax, not the total (e.g. $160).",
  "Moneda e impuestos": "Currency and taxes",
  "Con qué moneda trabajas y qué impuestos llevan tus gastos.": "The currency you work in and the taxes on your expenses.",
  "Análisis": "Analytics",
  "Revisa mis ingresos y gastos de los últimos {0} y dame 3 sugerencias concretas para optimizar mis gastos a largo plazo.": "Review my income and expenses over the last {0} and give me 3 concrete suggestions to optimize my expenses in the long term.",
  "meses": "months",
  "semanas": "weeks",
  "Mensual": "Monthly",
  "Todavía no hay ingresos ni gastos para comparar.": "No income or expenses to compare yet.",
  "Ingresos del mes": "Income this month",
  "Ingresos de la semana": "Income this week",
  "Impuestos pagados": "Taxes paid",
  "Ingresos vs gastos vs impuestos": "Income vs expenses vs taxes",
  "Últimos {0} meses.": "Last {0} months.",
  "Últimas {0} semanas (martes a domingo).": "Last {0} weeks (Tuesday to Sunday).",
  "Planeación": "Planning",
  "Estimación: sigue la tendencia de los periodos cerrados. No considera temporadas ni eventos.": "Estimate: follows the trend of closed periods. It doesn't account for seasons or events.",
  "Sugerencias del asistente": "Assistant suggestions",
  "Se necesitan al menos 2 periodos cerrados para proyectar.": "At least 2 closed periods are needed to project.",
  "Neto proyectado (próximos {0})": "Projected net (next {0})",
  "Gastos / ingresos (promedio)": "Expenses / income (average)",
  "Semana +{0}": "Week +{0}",
  "Mes +{0}": "Month +{0}",
  "Equipo": "Team",
  "Planeador de horarios": "Schedule planner",
  "Catálogos, reglas, suscripción, idioma y perfil": "Catalogs, rules, subscription, language and profile",
  "Día +{0}": "Day +{0}",
  "Ingresos del día": "Income today",
  "Últimos {0} días.": "Last {0} days.",
  "vs anterior": "vs previous",
  "vs el anterior a la misma fecha": "vs previous period to date",
  "Impuesto no encontrado.": "Tax not found.",
  "El chat no está configurado (falta GEMINI_API_KEY).": "The chat isn't configured (GEMINI_API_KEY is missing).",
  "Escribe un mensaje o adjunta una foto.": "Type a message or attach a photo.",
  "Moneda no válida (código ISO, p. ej. MXN).": "Invalid currency (ISO code, e.g. MXN).",
  "Nada que actualizar.": "Nothing to update.",
  "Escribe el nombre del impuesto (máx. 40 caracteres).": "Type the tax name (max. 40 characters).",
  "El porcentaje debe estar entre 0 y 100.": "The percentage must be between 0 and 100.",
  "Entrar como admin (desarrollo)": "Sign in as admin (development)",
  "Logo guardado: la app usa ahora sus colores.": "Logo saved: the app now uses its colors.",
  "Logo guardado.": "Logo saved.",
  "Si tu logo tiene color, la app toma su tono principal.": "If your logo has color, the app takes on its main tone.",
  "Logo y colores": "Logo and colors",
  "Color no válido (#rrggbb).": "Invalid color (#rrggbb).",
  "TARJETA": "CARD",
  "VENTAS EN LÍNEA": "ONLINE SALES",
  "TRANSFERENCIA": "TRANSFER",
  "TARJETA DE CRÉDITO": "CREDIT CARD",
  "TARJETA DE DÉBITO": "DEBIT CARD",
  "Distribuidora de Mercancía": "Merchandise Distributor",
  "Supermercado": "Supermarket",
  "Papelería y Oficina": "Office Supplies",
  "Gas LP": "Propane Gas",
  "Agua y Limpieza": "Water & Cleaning",
  "Frutas y Verduras": "Produce Market",
  "Bebidas": "Beverages",
  "Salida efectivo": "Cash outflow",
  "Salida de efectivo": "Cash outflow",
  "Pago de servicios": "Utilities",
  "Mantenimiento / Reparación": "Maintenance / Repair",
  "Agua / Limpieza": "Water / Cleaning",
  "Compra de insumos": "Supplies purchase",
  "Prestamo a empleado": "Employee loan",
  "Finiquito de empleado": "Employee severance",
  "Insumos semanales": "Weekly supplies",
  "Despensa": "Groceries",
  "Quesos y embutidos": "Cheese and cold cuts",
  "Recarga de tanque": "Tank refill",
  "Hielo fin de semana": "Weekend ice",
  "Compra mensual": "Monthly purchase",
  "Pescados y mariscos": "Fish and seafood",
  "Renta de tanque": "Tank rental",
  "Capturar": "Capture",
  "Pregúntale al asistente por tus números o mándale la foto de un ticket. Abajo, todos los comprobantes del negocio.": "Ask the assistant about your numbers or send it a photo of a receipt. Below, all of the business's receipts.",
  "Personal, catálogos, moneda e impuestos. Aquí también puedes volver a ver este recorrido.": "Staff, catalogs, currency and taxes. You can also replay this tour here.",
  "{0} con actividad en las últimas 4 semanas": "{0} with activity in the last 4 weeks",
  "Registros (4 semanas)": "Records (4 weeks)",
  "ingresos y gastos capturados": "income and expenses recorded",
  "Gastos registrados": "Expenses recorded",
  "{0} con comprobante": "{0} with a receipt",
  "Cortes de caja cerrados": "Cash-ups closed",
  "días cuadrados en la app": "days balanced in the app",
  "Personal en nómina": "Staff on payroll",
  "empleados activos": "active employees",
  "Volumen administrado": "Volume managed",
  "ingresos + gastos registrados": "income + expenses recorded",
  "Actividad semanal": "Weekly activity",
  "Registros capturados y negocios activos, últimas 12 semanas": "Records captured and active businesses, last 12 weeks",
  "Registros": "Records",
  "Negocios activos": "Active businesses",
  "Uso por negocio": "Usage by business",
  "Uso por persona": "Usage by person",
  "Persona": "Person",
  "Tarjetas": "Cards",
  "Ordenado por actividad reciente": "Sorted by recent activity",
  "Negocio": "Business",
  "Registros (4 sem.)": "Records (4 wk)",
  "Comprobantes": "Receipts",
  "Cortes": "Cash-ups",
  "Personal": "Staff",
  "Última actividad": "Last activity",
  "Negocio {0}": "Business {0}",
  "sin configurar": "not set up",
  "Modo presentación": "Presentation mode",
  "Datos anónimos: sin nombres de negocios, personas ni correos.": "Anonymous data: no business names, people or emails.",
  "El navegador bloqueó la ventana de Google. Toca el botón otra vez.": "The browser blocked the Google window. Tap the button again.",
  "Falta GEMINI_API_KEY en Coolify": "GEMINI_API_KEY is missing in Coolify",
  "Apagado: prende WhatsApp en algún negocio": "Off: turn WhatsApp on for a business",
  "Conectado{0}": "Connected{0}",
  "Escanea el QR con el WhatsApp del número del bot": "Scan the QR with the bot number's WhatsApp",
  "Bot de WhatsApp": "WhatsApp bot",
  "activo": "on",
  "apagado": "off",
  "Revisando configuración…": "Checking setup…",
  "DNS (Dynadot): registro A \"{0}\" → {1}. Un registro \"*\" lo resuelve para todos.": "DNS (Dynadot): A record \"{0}\" → {1}. One \"*\" record covers every business.",
  "Coolify → Website → frontend → Domains: agrega https://{0} y redeploy.": "Coolify → Website → frontend → Domains: add https://{0} and redeploy.",
  "Firebase → Authentication → Settings → Authorized domains: agrega {0}.": "Firebase → Authentication → Settings → Authorized domains: add {0}.",
  "Falta configurar para que abra {0}:": "Still needed before {0} opens:",
  "Pendiente": "Pending",
  "Volver a revisar": "Check again",
  "Guardado. Los reportes llegarán también a esos correos.": "Saved. Reports will also go to those emails.",
  "Correos de reportes": "Report emails",
  "Correos adicionales": "Extra emails",
  "El corte diario y el reporte semanal llegan al admin ({0}) y a estos correos. Sepáralos con comas.": "The daily cash-up and the weekly report go to the admin ({0}) and to these emails. Separate them with commas.",
  "Guardar correos": "Save emails",
  "Por turno": "Per shift",
  "Por hora": "Per hour",
  "Por día": "Per day",
  "Sueldo semanal": "Weekly salary",
  "Misma propina para cada quien en el turno": "Same tip for everyone on the shift",
  "Bote del turno, partes iguales": "Shift pool, split equally",
  "Bote del día, según horas trabajadas": "Day pool, split by hours worked",
  "Bote de la semana, según horas trabajadas": "Week pool, split by hours worked",
  "Propinas de la semana": "Tips for the week",
  "se reparten según las horas ({0} h en la semana)": "split by hours ({0} h this week)",
  "A mano. El {0} % de las propinas de la semana ({1}) sería {2}; borra el monto para volver al cálculo.": "Manual. {0} % of this week's tips ({1}) would be {2}; clear it to go back to the calculation.",
  "La cocina cobra sus propinas al mes: escribe el bote cuando toque.": "The kitchen gets its tips monthly: type the pot when it's due.",
  "El {0} % de las propinas de la semana ({1}).": "{0} % of this week's tips ({1}).",
  "Se reparte según las horas ({0} h en la semana).": "Split by hours ({0} h this week).",
  "A mano. Según horas le tocarían {0}; borra el monto para volver al cálculo.": "Set by hand. By hours it would be {0}; clear the amount to go back to the calculation.",
  "Según horas: {0} h de {1} h = {2}. Escribe otro monto para cambiarlo.": "By hours: {0} h of {1} h = {2}. Type another amount to change it.",
  "Propinas de la semana, a mano": "Tips for the week, set by hand",
  "{0} h de {1} h de la semana": "{0} h of {1} h this week",
  "Propina distinta por empleado": "Different tip per employee",
  "Extra de propinas a mano en la semana": "Manual weekly tip bonus",
  "Sin propinas": "No tips",
  "Grupos de personal": "Staff groups",
  "Cada grupo tiene su propia pestaña en Nóminas y su forma de pago.": "Each group gets its own tab in Payroll and its own way of being paid.",
  "Nombre del grupo": "Group name",
  "Tiene personal: muévelo o dalo de baja primero": "It has staff: deactivate them first",
  "Quitar grupo": "Remove group",
  "Quitar grupo {0}": "Remove group {0}",
  "Se paga": "Paid",
  "Misma propina para cada quien en el día": "Same tip for everyone that day",
  "Bote del día, partes iguales": "Day pool, split equally",
  "Paga horas extra": "Pays overtime",
  "Agregar grupo": "Add group",
  "Turnos y días": "Shifts and days",
  "Qué turnos abre cada día. Un día sin turnos queda cerrado (el lunes siempre es descanso).": "Which shifts open each day. A day with no shifts is closed (Monday is always a rest day).",
  "Nombre del turno": "Shift name",
  "Quitar turno {0}": "Remove shift {0}",
  "Reglas": "Rules",
  "Feriado: el pago se multiplica ×": "Holiday: pay is multiplied ×",
  "Bono de puntualidad ({0})": "Punctuality bonus ({0})",
  "Propinas del Corte → Nómina: a cada turno se le descuenta este % y este monto fijo, y el resto se divide entre quienes trabajaron. Siempre se redondea hacia arriba.": "Daily Close → Payroll tips: each shift has this % and fixed amount deducted, and the rest is split among who worked. Always rounded up.",
  "Propinas: descuento (%)": "Tips: deduction (%)",
  "Propinas: cargo fijo por turno ({0})": "Tips: fixed fee per shift ({0})",
  "Horas extra después de (h/día)": "Overtime after (h/day)",
  "Horas extra se pagan ×": "Overtime is paid ×",
  "Propina total (se reparte)": "Total tips (split)",
  "Propina de {0}, turno {1}": "{0}'s tip, {1} shift",
  "persona": "person",
  "personas": "people",
  "Día feriado (×{0})": "Holiday (×{0})",
  "Día Feriado ×{0}": "Holiday ×{0}",
  "Feriado ×{0}": "Holiday ×{0}",
  "${0}/día": "${0}/day",
  "${0}/semana": "${0}/week",
  "Propina total": "Total tips",
  "Propina de {0}, {1} {2}": "{0}'s tip, {1} {2}",
  "turno": "shift",
  "turnos": "shifts",
  "día": "day",
  "días": "days",
  "día con falta": "day absent",
  "días con falta": "days absent",
  "esta semana: se descuenta del sueldo semanal.": "this week: deducted from the weekly salary.",
  "esta semana. Las faltas no cambian la nómina; queda como registro.": "this week. Absences don't change pay; they're kept as a record.",
  "No hay personal en {0}. Agrégalo en Ajustes.": "No staff in {0}. Add them in Settings.",
  "Propina total del día": "Total tips for the day",
  "Propina del {0}": "Tips on {0}",
  "Propina de {0} el {1}": "{0}'s tip on {1}",
  "falta": "absence",
  "faltas": "absences",
  "esta semana.": "this week.",
  "Salario por día": "Daily pay",
  "{0} / día": "{0} / day",
  "{0} / semana": "{0} / week",
  "Configuración de nómina guardada.": "Payroll setup saved.",
  "No se pudo guardar.": "Couldn't save.",
  "Tu personal": "Your staff",
  "Cómo divides a tu equipo, cómo le pagas y cómo se reparten las propinas.": "How your team is split, how you pay them and how tips are shared.",
  "Semana": "Week",
  "Semana de nómina": "Payroll week",
  "El día con el que empieza cada semana de pago (Nóminas, Cuentas y reportes).": "The day each pay week starts (Payroll, Accounts and reports).",
  "Empieza el": "Starts on",
  "Las semanas ya capturadas se quedan con su día de inicio anterior: cambia esto al cerrar una semana, no a la mitad.": "Weeks already captured keep their previous start day: change this when a week closes, not in the middle of one.",
  "Qué turnos abre cada día. Un día sin turnos queda cerrado (descanso).": "Which shifts open each day. A day with no shifts is closed (rest day).",
  "Lunes": "Monday",
  "Lun": "Mon",
  "Periodo de prueba": "Trial",
  "Activa": "Active",
  "Pago pendiente": "Payment due",
  "Sin pagar": "Unpaid",
  "Cancelada": "Canceled",
  "Pago incompleto": "Payment incomplete",
  "Expirada": "Expired",
  "En pausa": "Paused",
  "¡Gracias! Tu suscripción se está activando.": "Thanks! Your subscription is being activated.",
  "No se pudo abrir Stripe.": "Couldn't open Stripe.",
  "La suscripción aún no está disponible.": "Subscriptions aren't available yet.",
  "Soedia gratis": "Soedia for free",
  "Este negocio usa Soedia sin costo. No hay nada que pagar.": "This business uses Soedia at no cost. There's nothing to pay.",
  "Suscripción a Soedia": "Soedia subscription",
  "anual": "yearly",
  "mensual": "monthly",
  "prueba hasta el {0}": "trial until {0}",
  "se renueva el {0}": "renews on {0}",
  "Elige tu plan: los primeros {0} días son gratis.": "Choose your plan: the first {0} days are free.",
  "Elige tu plan para seguir usando Soedia.": "Choose your plan to keep using Soedia.",
  "No pudimos cobrar tu último pago. Actualiza tu tarjeta para no perder el acceso.": "We couldn't collect your last payment. Update your card to keep access.",
  "Administrar suscripción": "Manage subscription",
  "Los planes aún no están configurados.": "Plans aren't set up yet.",
  "Anual": "Yearly",
  "año": "year",
  "mes": "month",
  "El pago lo procesa Stripe. Ahí mismo cambias tu tarjeta, tu plan o cancelas, y descargas tus facturas.": "Payments are processed by Stripe. There you can change your card or plan, cancel, and download your invoices.",
  "No pudimos cobrar tu suscripción. Toca aquí para actualizar tu tarjeta y no perder el acceso.": "We couldn't charge your subscription. Tap here to update your card and keep access.",
  "Sin suscripción": "No subscription",
  "Prueba": "Trial",
  "Pagando": "Paying",
  "Incompleta": "Incomplete",
  "Gratis": "Free",
  "Soedia sin costo para este negocio: no se le cobra ni se suspende por pago.": "Soedia at no cost for this business: never charged or suspended for payment.",
  "Siempre gratis": "Always free",
  "Enlace de pago": "Payment link",
  "Copiado. Mándaselo al negocio (vence en 24 h):": "Copied. Send it to the business (expires in 24 h):",
  "Suscripción": "Subscription",
  "Pagar plan mensual": "Pay monthly plan",
  "Pagar plan anual": "Pay yearly plan",
  "Si ya pagaste, recarga la página en unos segundos.": "If you already paid, reload the page in a few seconds.",
  "Tu acceso está en pausa": "Your access is paused",
  "Terminó tu prueba gratis o no se pudo cobrar tu suscripción. Elige un plan para seguir: tus datos siguen guardados.": "Your free trial ended or your subscription couldn't be charged. Choose a plan to continue: your data is still saved.",
  "Tu prueba gratis termina el {0}. Si eliges tu plan ahora, el primer cobro es ese día.": "Your free trial ends on {0}. If you choose your plan now, the first charge is that day.",
  "Te quedan {0} días de prueba gratis. Toca aquí para elegir tu plan.": "{0} days left in your free trial. Tap here to choose your plan.",
  "Tu prueba gratis termina hoy. Toca aquí para elegir tu plan y no perder el acceso.": "Your free trial ends today. Tap here to choose your plan and keep access.",
  "Suspendido por pago": "Suspended for payment",
  "Prueba: {0} días": "Trial: {0} days",
  "Esta invitación caducó. Pide una nueva con \"Primera vez: crear contraseña\" en la pantalla de acceso.": "This invitation expired. Ask for a new one with \"First time: create password\" on the sign-in screen.",
  "Esta cuenta ya tiene contraseña. Entra, o usa \"¿Olvidaste tu contraseña?\".": "This account already has a password. Sign in, or use \"Forgot your password?\".",
  "Te mandamos un enlace a tu correo para crear tu contraseña. Si tu cuenta ya tiene una, usa \"¿Olvidaste tu contraseña?\".": "We sent a link to your email to create your password. If your account already has one, use \"Forgot your password?\".",
  "No pudimos conectar con el servidor (puede estar actualizándose). Espera un momento y vuelve a intentarlo.": "We couldn't reach the server (it may be updating). Wait a moment and try again.",
  "Teléfono": "Phone",
  "Con código de país, solo números. Ej. 52 664 123 4567. Opcional.": "With country code, digits only. E.g. 52 664 123 4567. Optional.",
  "Para recordarte su cumpleaños. Opcional.": "To remind you of their birthday. Optional.",
  "Precios guardados en Stripe.": "Prices saved in Stripe.",
  "Cobro con Stripe": "Stripe billing",
  "El enlace caducó o no es válido. Llena el formulario otra vez.": "The link expired or isn't valid. Fill in the form again.",
  "Alguien tomó ese subdominio antes de que confirmaras. Elige otro.": "Someone took that subdomain before you confirmed. Pick another one.",
  "Ese email ya tiene un negocio en Soedia. Entra con él.": "That email already has a business on Soedia. Sign in with it.",
  "Revisa tu correo": "Check your email",
  "Te mandamos un enlace a {0}. Ábrelo para crear tu negocio y elegir tu contraseña.": "We sent a link to {0}. Open it to create your business and choose your password.",
  "¿No te llegó? Revisa tu carpeta de spam.": "Didn't get it? Check your spam folder.",
  "Cambiar mis datos": "Change my details",
  "Crea tu negocio": "Create your business",
  "{0} días gratis, sin tarjeta.": "{0} days free, no card needed.",
  "Ej. Tacos Doña Lupe": "E.g. Lupe's Tacos",
  "Tu dirección": "Your address",
  "Disponible": "Available",
  "Tu email": "Your email",
  "Crear mi negocio": "Create my business",
  "Catálogos y moneda": "Catalogs and currency",
  "Moneda e instalar la app": "Currency and installing the app",
  "Cómo te entra dinero y con qué pagas": "How money comes in and how you pay",
  "Borrar persona": "Delete person",
  "Se borrarán para siempre sus gastos, ingresos y catálogos. Su cuenta de acceso se conserva. Esta acción no se puede deshacer.": "Their expenses, income and catalogs will be deleted forever. Their login is kept. This can't be undone.",
  "Se borran la cuenta de esta persona y TODOS sus datos. No se puede deshacer.": "This person's account and ALL their data are deleted. This can't be undone.",
  "Cuenta restablecida. Al entrar verá el asistente de configuración.": "Account reset. They'll see the setup assistant when they sign in.",
  "Cómo te entra dinero": "How money comes in",
  "Tu sueldo, transferencias… CASH siempre está.": "Your salary, transfers… CASH is always there.",
  "SUELDO": "SALARY",
  "Con qué pagas": "How you pay",
  "Efectivo y tus tarjetas.": "Cash and your cards.",
  "Tarjeta de débito": "Debit card",
  "Tarjeta de crédito": "Credit card",
  "Tus datos": "Your details",
  "Tus cuentas": "Your accounts",
  "Configura tu cuenta": "Set up your account",
  "Tus finanzas personales en un minuto. Todo se puede cambiar después.": "Your personal finances in a minute. You can change everything later.",
  "Fecha de nacimiento": "Date of birth",
  "dd/mm/aaaa": "dd/mm/yyyy",
  "Foto de tu identificación": "Photo of your ID",
  "Identificación guardada": "ID saved",
  "Subir foto de tu INE o pasaporte": "Upload a photo of your ID or passport",
  "Solo tú la puedes ver. Puedes saltarte este paso.": "Only you can see it. You can skip this step.",
  "La foto pesa más de 8 MB.": "The photo is larger than 8 MB.",
  "No se pudo subir la foto.": "Couldn't upload the photo.",
  "Con qué moneda llevas tus cuentas.": "Which currency you keep your accounts in.",
  "¡Tu cuenta está lista!": "Your account is ready!",
  "Fecha de nacimiento no válida.": "Invalid date of birth.",
  "Sube una foto PNG, JPG o WebP.": "Upload a PNG, JPG or WebP photo.",
  "Personas": "People",
  "Persona {0}": "Person {0}",
  "Nueva persona": "New person",
  "Crear persona": "Create person",
  "Nombre completo": "Full name",
  "Su email": "Their email",
  "Aún no hay cuentas personales.": "No personal accounts yet.",
  "Cuenta de {0} creada: {1}.soedia.com. Enviamos a {2} un enlace para crear su contraseña.": "{0}'s account created: {1}.soedia.com. We sent {2} a link to create their password.",
  "Cuenta de {0} creada: {1}.soedia.com.": "{0}'s account created: {1}.soedia.com.",
  "Cuenta personal gratis para siempre, solo con Finanzas personales. Le llega un correo de hola@soedia.com con un enlace para crear su contraseña (o puede entrar con Google si es Gmail).": "Personal account, free forever, with Personal finances only. They get an email from hola@soedia.com with a link to create their password (or they can sign in with Google if it's Gmail).",
  "Tu cuenta personal": "Your personal account",
  "Lleva tus gastos e ingresos. Gratis para siempre.": "Track your expenses and income. Free forever.",
  "Tu nombre completo": "Your full name",
  "Ej. Juan Pérez López": "E.g. John Michael Smith",
  "tunombre": "yourname",
  "¿Usar {0}?": "Use {0}?",
  "Crear mi cuenta personal": "Create my personal account",
  "¿Tienes un negocio?": "Have a business?",
  "¿Es solo para tus finanzas personales?": "Just for your personal finances?",
  "Cuenta personal gratis": "Free personal account",
  "Te mandamos un enlace a {0}. Ábrelo para crear tu cuenta y elegir tu contraseña.": "We sent a link to {0}. Open it to create your account and choose your password.",
  "Ese email ya tiene una cuenta en Soedia. Usa otro o entra con él.": "That email already has a Soedia account. Use another one or sign in with it.",
  "Al terminar la prueba: ${0} al mes o ${1} al año.": "After the trial: ${0} a month or ${1} a year.",
  "Llena los tres campos.": "Fill in all three fields.",
  "Demasiados intentos. Espera un rato y vuelve a intentarlo.": "Too many attempts. Wait a while and try again.",
  "No pudimos mandar el correo. Inténtalo más tarde.": "We couldn't send the email. Try again later.",
  "No pudimos mandar el correo. Inténtalo de nuevo.": "We couldn't send the email. Try again.",
  "Listo para cobrar": "Ready to charge",
  "Falta configurar": "Setup needed",
  "Cuenta de Stripe conectada": "Stripe account connected",
  "Cuenta de Stripe sin conectar": "Stripe account not connected",
  "La app funciona igual, solo que no cobra.": "The app works the same, it just doesn't charge.",
  "Pagos y cancelaciones se sincronizan": "Payments and cancellations sync",
  "Pagos y cancelaciones sin sincronizar": "Payments and cancellations don't sync",
  "Stripe cobra, pero Soedia no se entera de pagos ni cancelaciones.": "Stripe charges, but Soedia doesn't hear about payments or cancellations.",
  "Precios publicados": "Prices published",
  "Faltan los precios": "Prices missing",
  "Fíjalos abajo para poder cobrar.": "Set them below to start charging.",
  "IVA automático activo": "Automatic VAT on",
  "IVA automático apagado": "Automatic VAT off",
  "Opcional. Stripe no agrega impuestos al cobro.": "Optional. Stripe doesn't add tax to the charge.",
  "Cuando se conecte la cuenta de Stripe, aquí aparecen los campos para fijar los precios.": "Once the Stripe account is connected, the price fields will appear here.",
  "Equivale a ${0}/mes · {1}% menos": "Works out to ${0}/mo · {1}% off",
  "El precio": "The price",
  "Ya incluye IVA": "Already includes VAT",
  "Más IVA": "Plus VAT",
  "Sin cambios": "No changes",
  "Mensual (MXN)": "Monthly (MXN)",
  "Anual (MXN)": "Yearly (MXN)",
  "Guardar precios": "Save prices",
  "Cambiar un precio no afecta a quien ya está suscrito; aplica a las suscripciones nuevas.": "Changing a price doesn't affect current subscribers; it applies to new subscriptions.",
  "Escribe los dos montos.": "Enter both amounts.",
  "Secciones": "Sections",
  "Inicio": "Home",
  "Configuración": "Settings",
  "Finanzas": "Finances",
  "Cuentas del día (ingresos por terminal y gastos con comprobante), control de facturas y análisis con gráficas, todo en un solo lugar.": "Daily accounts (terminal income and expenses with receipts), invoice tracking and charts, all in one place.",
  "mi-negocio": "my-business",
  "contador@ejemplo.com, socio@ejemplo.com": "accountant@example.com, partner@example.com",
  "Módulos": "Modules",
  "Cobro": "Billing",
  "Cuenta": "Account",
  "Borrar negocio": "Delete business",
  "Personal": "Staff",
  " Ningún empleado tiene teléfono registrado (Ajustes → Personal).": " No employee has a phone number on file (Settings → Staff).",
  "{0} / turno": "{0} / shift",
  "No se pudo leer el estado del bot.": "Couldn't read the bot status.",
  "Cubre de {0}. No incluye pagos de nómina.": "Covers {0}. Doesn't include payroll payments.",
  "Últimas {0} semanas ({1}).": "Last {0} weeks ({1}).",
  "Hacerlo automático": "Do it automatically",
  "No se pudo registrar en Firebase.": "Couldn't register it in Firebase.",
  "· Agrega tu RFC y CP en Ajustes para tenerlos a la mano.": "· Add your Tax ID and ZIP in Settings to keep them handy.",
  "Soedia no genera tus facturas automáticamente: te deja a la mano los datos para que las pidas en el portal de cada proveedor.": "Soedia doesn't create your invoices automatically: it keeps the details handy so you can request them on each supplier's portal.",
  "Código postal": "ZIP code",
  "El RFC lleva 12 o 13 caracteres (p. ej. ABC010101AB1).": "The RFC has 12 or 13 characters (e.g. ABC010101AB1).",
  "El código postal lleva 5 dígitos.": "The ZIP code has 5 digits.",
  "Datos para facturar": "Billing details",
  "Tu RFC y código postal, para tenerlos a la mano cuando pidas facturas a tus proveedores.": "Your Tax ID (RFC) and ZIP code, handy when you request invoices from your suppliers.",
  "Datos para facturar guardados.": "Billing details saved.",
  "Neto = Nómina (transferencia bancaria) + Efectivo a dif. (efectivo a entregar; incluye las propinas).": "Net = Payroll (bank transfer) + Cash diff. (cash to hand over; includes tips).",
  "Detalle de faltas": "Absence details",
  "Alguien más está editando": "Someone else is editing",
  "en este momento.": "right now.",
  "Hay otra sesión abierta": "Another session is open",
  "Hay {0} sesiones abiertas": "{0} sessions are open",
  ". Captura en coordinación para no sobrescribir los datos de otro dispositivo.": ". Coordinate your edits so you don't overwrite another device's data.",
  "Recibo de pago ·": "Pay slip ·",
  "Total de la semana": "Week total",
  "Depósito de nómina": "Payroll deposit",
  "Efectivo a pagar": "Cash to pay",
  "Saldo pendiente de préstamo:": "Outstanding loan balance:",
  "Faltas en la semana": "Absences this week",
  "{0} h": "{0} h",
  "Día": "Day",
  "Normal": "Regular",
  "Feriado": "Holiday",
  "Importe": "Amount",
  "Sin horas registradas.": "No hours recorded.",
  "Salario de la semana{0}": "Weekly wage{0}",
  "Bono de puntualidad": "Punctuality bonus",
  "Bono de puntualidad: perdido por falta": "Punctuality bonus: lost due to absence",
  "Extra por puesto": "Position extra",
  "Séptimo día": "Paid day off",
  "Extra de propinas": "Tip extra",
  "Pagos extras": "Extra payments",
  "Vacaciones": "Vacation",
  "Préstamos": "Loans",
  "Día / turno": "Day / shift",
  "Modalidad": "Type",
  "Base": "Base",
  "Propina": "Tip",
  "Turno": "Shift",
  "Sin turnos registrados.": "No shifts recorded.",
  "Salario (base × feriado)": "Wage (base × holiday)",
  "Sin proveedor": "No supplier",
  "{0} gasto{1} guardado{2}": "{0} expense{1} saved",
  "{0} en este dispositivo; se suben al reconectar.": "{0} on this device; they'll upload when you reconnect.",
  "Escanear comprobantes": "Scan receipts",
  "Fotografía uno o varios tickets. Revisa los datos antes de guardar.": "Photograph one or more receipts. Check the details before saving.",
  "Tomar foto": "Take photo",
  "Elegir archivos": "Choose files",
  "Analizando foto…": "Analyzing photo…",
  "Gasto manual": "Manual expense",
  "Quitar de la lista": "Remove from list",
  "Leyendo el comprobante…": "Reading the receipt…",
  "Comercio": "Store",
  "IVA": "VAT",
  "Descripción": "Description",
  "Descartar": "Discard",
  "Para facturar": "To invoice",
  "Se registran el": "They're recorded on",
  "(el día elegido arriba), no en la fecha impresa en el ticket.": "(the day chosen above), not the date printed on the receipt.",
  "Guardando…": "Saving…",
  "Guardar {0} gasto{1} ({2})": "Save {0} expense{1} ({2})",
  "Agregar otro gasto a la lista": "Add another expense to the list",
  "Terminales e ingresos": "Terminals and income",
  "Cómo te pagan tus clientes. CASH siempre está.": "How your customers pay you. CASH is always included.",
  "Métodos de pago": "Payment methods",
  "Con qué pagas tus gastos.": "What you pay your expenses with.",
  "Opcional: también se agregan solos al capturar gastos.": "Optional: they're also added automatically when you record expenses.",
  "Tarjeta": "Card",
  "Transferencia": "Transfer",
  "Proveedores": "Suppliers",
  "Conceptos de salida de efectivo": "Cash outflow items",
  "Para qué sale dinero de la caja.": "What cash leaves the register for.",
  "Tu negocio": "Your business",
  "Tus catálogos": "Your catalogs",
  "Listo": "Done",
  "Configura tu negocio": "Set up your business",
  "Paso": "Step",
  "Continuar": "Continue",
  "El logo pesa más de 1 MB.": "The logo is larger than 1 MB.",
  "No se pudo subir el logo.": "Couldn't upload the logo.",
  "No se pudo guardar el nombre.": "Couldn't save the name.",
  "¡Bienvenido a Soedia!": "Welcome to Soedia!",
  "Configura tu negocio en un minuto. Todo se puede cambiar después en Ajustes.": "Set up your business in a minute. You can change everything later in Settings.",
  "Subir logo": "Upload logo",
  "Cambiar": "Change",
  "Sube tu logo": "Upload your logo",
  "PNG, JPG o WebP, máximo 1 MB. Aparece en la app, los recibos y la hoja de efectivo.": "PNG, JPG or WebP, up to 1 MB. It appears in the app, pay slips and the cash sheet.",
  "Nombre del negocio": "Business name",
  "Elige tus catálogos": "Choose your catalogs",
  "Palomea lo que usas o agrega lo tuyo.": "Tick what you use or add your own.",
  "Agregar otro…": "Add another…",
  "Agregar a {0}": "Add to {0}",
  "Agregar": "Add",
  "No se pudo agregar el número.": "Couldn't add the number.",
  "WhatsApp": "WhatsApp",
  "(opcional)": "(optional)",
  "Manda la foto de un ticket por WhatsApp y Soedia lo registra como gasto. Agrega los teléfonos que pueden mandarlos": "Send a photo of a receipt over WhatsApp and Soedia records it as an expense. Add the phones allowed to send them",
  "al número": "to the number",
  "Con código de país, p. ej. 5216641234567": "With country code, e.g. 5216641234567",
  "Teléfono autorizado": "Authorized phone",
  "Quitar +{0}": "Remove +{0}",
  "Saltar por ahora": "Skip for now",
  "Te mostramos en 30 segundos dónde está cada cosa.": "We'll show you where everything is in 30 seconds.",
  "Ver el recorrido": "Take the tour",
  "Verificando conexión…": "Checking connection…",
  "Sincronizado con el servidor.": "Synced with the server.",
  "No se pudo sincronizar. Revisa la conexión e inténtalo de nuevo.": "Couldn't sync. Check your connection and try again.",
  "Sincronizar con el servidor": "Sync with the server",
  "Sincronizar con el servidor (volver a leer todo sin recargar la página)": "Sync with the server (reload everything without refreshing the page)",
  "Este negocio no existe": "This business doesn't exist",
  "No encontramos el subdominio que usaste. Revisa la dirección o contacta a quien te la dio.": "We couldn't find that subdomain. Check the address or contact whoever gave it to you.",
  "Sesión de otro negocio": "Session from another business",
  "Tu sesión pertenece a otro subdominio. Cierra sesión y vuelve a entrar desde el subdominio correcto.": "Your session belongs to another subdomain. Sign out and sign in again from the right subdomain.",
  "Cuenta suspendida": "Account suspended",
  "Esta cuenta de negocio está suspendida. Contacta al administrador de Soedia.": "This business account is suspended. Contact the Soedia administrator.",
  "Sesión sin negocio": "Session without a business",
  "Tu sesión ya no apunta a ningún negocio. Cierra sesión y vuelve a entrar.": "Your session no longer points to any business. Sign out and sign in again.",
  "Cambiar a modo claro": "Switch to light mode",
  "Cambiar a modo oscuro": "Switch to dark mode",
  "Claro": "Light",
  "Oscuro": "Dark",
  "Cerrar aviso": "Dismiss",
  "Guardado exitosamente": "Saved",
  "Semana anterior": "Previous week",
  "Martes a domingo": "Tuesday to Sunday",
  "Semana siguiente": "Next week",
  "Recargar la semana desde el servidor": "Reload the week from the server",
  "Reporte generado": "Report generated",
  "No se pudo generar el reporte. Intenta de nuevo.": "Couldn't generate the report. Try again.",
  "CSV generado": "CSV generated",
  "No se pudo generar el CSV. Intenta de nuevo.": "Couldn't generate the CSV. Try again.",
  "Reporte semanal": "Weekly report",
  "No hay ingresos ni gastos registrados en esta semana.": "No income or expenses recorded this week.",
  "Reporte (PNG)": "Report (PNG)",
  "CSV": "CSV",
  "Reporte de cuentas ·": "Accounts report ·",
  "Reporte de cuentas": "Accounts report",
  "INGRESOS": "INCOME",
  "Total ingresos": "Total income",
  "EGRESOS": "EXPENSES",
  "Total egresos": "Total expenses",
  "RESUMEN": "SUMMARY",
  "Resumen": "Summary",
  "Utilidad": "Profit",
  "IVA cobrado (16%)": "VAT collected (16%)",
  "IVA pagado (facturado)": "VAT paid (invoiced)",
  "IVA cobrado": "VAT collected",
  "IVA pagado": "VAT paid",
  "IVA a pagar": "VAT due",
  "Egresos sin factura": "Expenses without invoice",
  "* Egreso con factura. IVA cobrado = 16% de los ingresos; IVA pagado = solo el de los comprobantes con factura. Los egresos sin factura no son deducibles.": "* Invoiced expense. VAT collected = 16% of income; VAT paid = only from invoiced receipts. Expenses without an invoice aren't deductible.",
  "Ingresos": "Income",
  "Egresos": "Expenses",
  "Egresos sin factura (no deducibles):": "Expenses without invoice (not deductible):",
  "Ingresos por medio de pago": "Income by payment type",
  "Egresos por proveedor": "Expenses by supplier",
  "Salidas por método de pago": "Outflows by payment method",
  "Cubre de martes a domingo. No incluye pagos de nómina.": "Covers Tuesday to Sunday. Doesn't include payroll payments.",
  "Día anterior": "Previous day",
  "Día siguiente": "Next day",
  "Hoy": "Today",
  "Elegir fecha": "Choose date",
  "Cerrar opciones": "Close options",
  "Mostrar opciones": "Show options",
  "Nuevo: «": "New: «",
  "» (se agrega al catálogo al guardar)": "» (added to the catalog when you save)",
  "Cerrar": "Close",
  "Confirmar": "Confirm",
  "Aceptar": "OK",
  "Online": "Online",
  "Offline": "Offline",
  "Reconectando…": "Reconnecting…",
  "No se encontró el recibo a exportar": "The pay slip to export wasn't found",
  "No se pudo generar la imagen": "Couldn't generate the image",
  "No se pudo convertir la imagen a base64": "Couldn't convert the image to base64",
  "Datos de Facturación {0} - RFC: {1} | CP: {2}": "Billing details {0} - Tax ID: {1} | ZIP: {2}",
  "Martes": "Tuesday",
  "Miércoles": "Wednesday",
  "Jueves": "Thursday",
  "Viernes": "Friday",
  "Sábado": "Saturday",
  "Domingo": "Sunday",
  "Mar": "Tue",
  "Mié": "Wed",
  "Jue": "Thu",
  "Vie": "Fri",
  "Sáb": "Sat",
  "Dom": "Sun",
  "{0}, {1} de {2} de {3}": "{0}, {2} {1}, {3}",
  "FACTURA No.": "INVOICE No.",
  "Gastos facturados {0}": "Invoiced expenses {0}",
  "Resumen de nómina": "Payroll summary",
  "{0} a {1}": "{0} to {1}",
  "No se pudo guardar: otro dispositivo no deja de cambiar esos datos": "Couldn't save: another device keeps changing that data",
  "La semana {0} sigue en conflicto tras varios intentos": "Week {0} is still in conflict after several attempts",
  "Hola {0}, aquí tienes tu recibo de nómina de esta semana.": "Hi {0}, here's your pay slip for this week.",
  "Tarde": "Afternoon",
  "Noche": "Night",
  "Asistencia": "Attended",
  "Asueto": "Day off",
  "Falta": "Absent",
  "Otro": "Other",
  "Fecha": "Date",
  "Concepto": "Item",
  "Proveedor": "Supplier",
  "Metodo": "Method",
  "Facturado": "Invoiced",
  "Si": "Yes",
  "No": "No",
  "No hay tipos de ingreso. Agrégalos en Ajustes → Catálogos.": "No income types yet. Add them in Settings → Catalogs.",
  "Gastos en efectivo del día": "Today's cash expenses",
  "{0} del {1}": "{0} for {1}",
  "Total del día": "Day total",
  "Todavía no hay ingresos esta semana.": "No income yet this week.",
  "Resumen del día": "Day summary",
  "Balance del día": "Day balance",
  "Balance": "Balance",
  "Diario": "Daily",
  "Semanal": "Weekly",
  "Resumen del período": "Period summary",
  "Entradas": "Income",
  "Fondo y venta del día": "Float and day's sales",
  "Fondo de Caja": "Cash float",
  "Auto: es el retiro «Caja» del": "Auto: it's the «Register» withdrawal from",
  ". Puedes editarlo.": ". You can edit it.",
  "Venta del Día": "Day's sales",
  "Propina Tarde": "Afternoon tips",
  "Propina Noche": "Night tips",
  "Total propinas": "Total tips",
  "Apunte de compras durante el cierre. Las pagadas con CASH que salieron del cajón cuentan en el Cajón.": "Purchases made during closing. Those paid with CASH out of the drawer count in the Drawer.",
  "El {0} YA se cerró ({1}). Al continuar se manda otra vez el resumen por WhatsApp y el correo con el respaldo. ¿Reenviar el cierre?": "{0} was ALREADY closed ({1}). Continuing sends the WhatsApp summary and the backup email again. Resend the closing?",
  "Se guardará y cerrará el corte del {0}: llegará un resumen corto por WhatsApp a los números autorizados y el resumen completo con los tickets de ESE día por correo. ¿Terminar el día?": "The cash-up for {0} will be saved and closed: a short summary goes by WhatsApp to the authorized numbers and the full summary with THAT day's receipts by email. Close the day?",
  "Reenviar cierre": "Resend closing",
  "Reenviar": "Resend",
  "Terminar el día": "Close the day",
  "Terminar el Día": "Close the Day",
  "Hay cambios sin guardar en el servidor. Revisa la conexión e inténtalo de nuevo.": "There are changes not saved to the server. Check your connection and try again.",
  "No se pudo cerrar el día. Revisa la conexión e inténtalo de nuevo.": "Couldn't close the day. Check your connection and try again.",
  "Día de descanso: la caja no se cierra": "Rest day: the register isn't closed",
  "Los lunes el negocio no abre. El fondo del martes arrastra el cierre del domingo.": "The business is closed on Mondays. Tuesday's float carries over Sunday's closing.",
  "Terminando el día…": "Closing the day…",
  "Día ya cerrado el": "Day already closed on",
  "Es el último día sin cerrar.": "This is the latest day that hasn't been closed.",
  "No olvides cerrar el día": "Don't forget to close the day",
  "Ya llenaste el corte del {0}, pero sigue abierto. Pulsa «Terminar el Día» para guardarlo y mandar el respaldo.": "You filled in the cash-up for {0}, but it's still open. Tap “Close the Day” to save it and send the backup.",
  "Ir a cerrar": "Go to close",
  "¿Olvidaste cerrar el día?": "Forgot to close the day?",
  "El corte del {0}, ya tiene todo lo obligatorio, pero no se ha cerrado. Sin cerrarlo no se manda el respaldo ni pasa el fondo al día siguiente.": "The cash-up for {0} has everything required, but it hasn't been closed. Until it's closed, the backup isn't sent and the float doesn't carry over to the next day.",
  "Ir a cerrarlo": "Go close it",
  "Después": "Later",
  ". Si vuelves a cerrarlo se reenvía el correo.": ". Closing it again resends the email.",
  "Marca en Nóminas quién trabajó para repartirla.": "Mark who worked in Payroll to split them.",
  "Nóminas:": "Payroll:",
  "c/u ·": "each ·",
  "Día de Descanso (Lunes)": "Rest Day (Monday)",
  "Caja cerrada": "Register closed",
  "La caja no abre; el fondo del martes arrastra el cierre del domingo.": "The register doesn't open; Tuesday's float carries over Sunday's closing.",
  "Diferencia de Caja": "Register Difference",
  "Entradas (Terminales + CASH) − (Fondo + Venta + Propinas)": "Income (Terminals + CASH) − (Float + Sales + Tips)",
  "CASH": "CASH",
  "Suma de las Salidas de Efectivo": "Sum of Cash Outflows",
  "No hay terminales activos. Agrégalos o reactívalos en Ajustes → Catálogos → Tipos de ingresos.": "No active terminals. Add or reactivate them in Settings → Catalogs → Income types.",
  "Total entradas": "Total income",
  "Cajón": "Drawer",
  "Caja": "Register",
  "Salida": "Outflow",
  "Efectivo que queda en el cajón · Fondo del {0}": "Cash left in the drawer · Float for {0}",
  "Otra salida": "Other outflow",
  "Concepto de la salida": "Outflow item",
  "Monto de la salida": "Outflow amount",
  "Agregar salida": "Add outflow",
  "Sin salidas": "No outflows",
  "Gasto pagado en CASH · se edita en Gastos": "Expense paid in CASH · edit it in Expenses",
  "Se edita en Gastos": "Edit it in Expenses",
  "Total salidas": "Total outflows",
  "Mes anterior": "Previous month",
  "Mes siguiente": "Next month",
  "Este mes": "This month",
  "Sin IVA desglosado": "No itemized VAT",
  "Importe gravado": "Taxable amount",
  "IVA de {0}": "VAT for {0}",
  "Factura No.": "Invoice No.",
  "Parte del gasto que no paga IVA: Total − Importe gravado − IVA": "Part of the expense without VAT: Total − Taxable amount − VAT",
  "Código de ticket/factura": "Receipt/invoice code",
  "Código de ticket/factura de {0}": "Receipt/invoice code for {0}",
  "Marcar como facturado": "Mark as invoiced",
  "Código:": "Code:",
  "Total de gastos facturados": "Total invoiced expenses",
  "Total de IVA": "Total VAT",
  "Con factura (CFDI) ligada": "With a linked invoice (CFDI)",
  "De esos gastos facturados": "From those invoiced expenses",
  "No se pudo cargar el resumen.": "Could not load the summary.",
  "Folio fiscal:": "Tax folio (UUID):",
  "Deshacer: {0} vuelve a pendientes": "Undo: {0} goes back to pending",
  "Regresar a pendientes": "Back to pending",
  "Deshacer": "Undo",
  "Agregar gasto facturado": "Add invoiced expense",
  "Para gastos que no se capturaron en la app. Se guarda ya facturado y aparece también en Cuentas ese día.": "For expenses not recorded in the app. It's saved as invoiced and also shows in Accounts on that day.",
  "Fecha del gasto": "Expense date",
  "No hay métodos de pago activos: agrégalos en Ajustes → Catálogos.": "No active payment methods: add them in Settings → Catalogs.",
  "Total del gasto": "Expense total",
  "El del comprobante ({0} si no trae).": "The receipt's ({0} if it has none).",
  "IVA del gasto": "Expense VAT",
  "El IVA no puede ser más del 16% del total.": "VAT can't be more than 16% of the total.",
  "· Importe gravado": "· Taxable amount",
  "· IVA": "· VAT",
  "Código de ticket/factura (opcional)": "Receipt/invoice code (optional)",
  "No se pudo exportar: {0}": "Couldn't export: {0}",
  "Exportar gastos facturados de": "Export invoiced expenses for",
  "Excel": "Excel",
  "Facturado: {0} · {1}": "Invoiced: {0} · {1}",
  "Agregado a facturados: {0} · {1} ({2})": "Added to invoiced: {0} · {1} ({2})",
  "Hay 1 gasto pendiente": "There's 1 pending expense",
  "Hay {0} gastos pendientes": "There are {0} pending expenses",
  "de meses anteriores. Ver": "from previous months. See",
  "Pendientes por facturar": "Pending invoice",
  "Todo facturado este mes. ✓": "Everything invoiced this month. ✓",
  "Sin gastos con IVA en {0}.": "No expenses with VAT in {0}.",
  "Gastos facturados": "Invoiced expenses",
  "Aún no hay gastos facturados en": "No invoiced expenses yet in",
  "Total facturado": "Total invoiced",
  "Corte del {0}: propina {1} = {2}": "Cash-up for {0}: {1} tips = {2}",
  "Sin captura esta semana": "Nothing recorded this week",
  "falta(s)": "absence(s)",
  "Ocultar detalle de {0}": "Hide details for {0}",
  "Ver detalle de {0}": "Show details for {0}",
  "Desglose": "Breakdown",
  "Bonos": "Bonuses",
  "Bono": "Bonus",
  "Descuento de préstamo": "Loan deduction",
  "Total a pagar": "Total to pay",
  "Se paga: depósito": "Paid as: deposit",
  "· efectivo": "· cash",
  "Préstamo": "Loan",
  "Saldo del préstamo": "Loan balance",
  "Después de esta semana:": "After this week:",
  "Descuento esta semana": "Deduction this week",
  "Ajustes de la semana": "This week's adjustments",
  "Se precargan desde Ajustes y aquí se pueden cambiar solo para esta semana.": "Preloaded from Settings; changes here apply to this week only.",
  "Toca una tarjeta para ver el desglose; el pago se marca en el resumen de la semana.": "Tap a card to see the breakdown; payment is marked in the week summary.",
  "Faltas del día": "Day's absences",
  "Marcar falta de {0}": "Mark {0} absent",
  "Con falta": "Absent",
  "Propina cada uno": "Tip each",
  "Propina por persona del turno {0}": "Tip per person, {0} shift",
  "Cerrado": "Closed",
  "¿Quién trabajó?": "Who worked?",
  "Por horas": "Hourly",
  "Propina por persona del día": "Tip per person for the day",
  "¿Quién trabajó este día?": "Who worked this day?",
  "{0}: con falta": "{0}: absent",
  "{0}: asistencia (clic para quitar)": "{0}: attended (click to remove)",
  "{0}: marcar asistencia": "{0}: mark attended",
  "Cada asistente recibe": "Each attendee gets",
  "de propina": "in tips",
  "{0} propina": "{0} tips",
  "Sin turnos capturados": "No shifts recorded",
  "Día feriado (×3)": "Holiday (×3)",
  "Por horas (sin turnos)": "Hourly (no shifts)",
  "Día Feriado ×3": "Holiday ×3",
  "Feriado ×3": "Holiday ×3",
  "Marcar asistencia": "Mark attended",
  "Marcar falta": "Mark absent",
  "Día de Asueto — {0}": "Day off — {0}",
  "{0} marcada · clic para desmarcar (queda Asueto) — {1}": "{0} marked · click to unmark (becomes Day off) — {1}",
  "Leyenda de estados de asistencia": "Attendance status legend",
  "Leyenda": "Legend",
  "Asueto / Descanso": "Day off / Rest",
  "(sin marcar)": "(unmarked)",
  "Día / Turno": "Day / Shift",
  "Propina por persona, {0} {1}": "Tip per person, {0} {1}",
  "suma el turno a la nómina;": "adds the shift to payroll;",
  "cuenta en el resumen de la semana; y sin marcar nada el turno queda en": "counts in the week summary; and with nothing marked the shift stays as",
  ". Toca el estado activo para desmarcarlo.": ". Tap the active status to unmark it.",
  "Salario base (× feriado)": "Base wage (× holiday)",
  "Tarde {0} · Noche {1}": "Afternoon {0} · Night {1}",
  "esta semana. En meseros las faltas no cambian la nómina; queda como registro.": "this week. For waiters, absences don't change payroll; they're kept as a record.",
  "Turnos de la semana": "Shifts this week",
  "propina": "tips",
  "No hay meseros. Agrégalos en Ajustes.": "No waiters yet. Add them in Settings.",
  "Guía rápida": "Quick guide",
  "Toca": "Tap",
  "· sin marcar =": "· unmarked =",
  "Nómina individual": "Individual payroll",
  "Quitar falta": "Remove absence",
  "Con falta · clic para quitar": "Absent · click to remove",
  "Sin horas capturadas": "No hours recorded",
  "Horas de {0} el {1}": "{0}'s hours on {1}",
  "Pago de los días": "Pay for the days",
  "Desactivado esta semana": "Disabled this week",
  "Puntualidad": "Punctuality",
  "Bono de puntualidad de {0} ({1})": "{0}'s punctuality bonus ({1})",
  "esta semana: sin bono de puntualidad.": "this week: no punctuality bonus.",
  "No hay personal de cocina. Agrégalo en Ajustes.": "No kitchen staff yet. Add them in Settings.",
  "Horas · Feriado · Faltas": "Hours · Holiday · Absences",
  "Extra de propinas (fin de mes)": "Tip extra (month end)",
  "Pagado (toca para deshacer)": "Paid (tap to undo)",
  "Pendiente de pago (toca para marcar pagado)": "Unpaid (tap to mark paid)",
  "{0}, efectivo {1}: {2}": "{0}, cash {1}: {2}",
  "Desmarcar": "Unmark",
  "Desmarcar todos": "Unmark all",
  "¿Quitar la marca de pagado a todos los empleados de esta semana?": "Remove the paid mark from every employee this week?",
  "No se pudo generar el resumen. Intenta de nuevo.": "Couldn't generate the summary. Try again.",
  "No se pudo compartir el resumen. Intenta de nuevo.": "Couldn't share the summary. Try again.",
  "No se encontró la hoja de efectivo": "The cash sheet wasn't found",
  "No se pudo generar la hoja de efectivo. Intenta de nuevo.": "Couldn't generate the cash sheet. Try again.",
  "Resumen completo de la semana": "Full week summary",
  "Todos los empleados; se exporta con el desglose de cada uno.": "All employees; exported with each one's breakdown.",
  "Neto total": "Total net",
  "Resumen (PNG)": "Summary (PNG)",
  "Generando PDF...": "Generating PDF...",
  "Hoja de Efectivo": "Cash Sheet",
  "Compartir": "Share",
  "Pagados": "Paid",
  "Marcar todos": "Mark all",
  "Por pagar": "To pay",
  "Todos pagados": "All paid",
  "Empleados pagados": "Employees paid",
  "días/turnos · Salario": "days/shifts · Wage",
  "· Propinas": "· Tips",
  "{0} al {1}": "{0} to {1}",
  "Reporte de nómina enviado a {0}.": "Payroll report sent to {0}.",
  "No se pudo enviar el reporte de nómina. Intenta de nuevo.": "Couldn't send the payroll report. Try again.",
  "Enviando reporte…": "Sending report…",
  "Enviar Reporte Semanal de Nómina": "Send Weekly Payroll Report",
  "Normalmente se envía el domingo, al cerrar la semana.": "Usually sent on Sunday, when closing the week.",
  "Enviar reporte de nómina": "Send payroll report",
  "Se enviará por correo la nómina de la semana del": "The payroll will be emailed for the week of",
  "empleado(s), costo total": "employee(s), total cost",
  "en efectivo.": "in cash.",
  "Enviando…": "Sending…",
  "Sí, enviar": "Yes, send",
  "Semana cerrada. Nómina de {0} registrada en Cuentas.": "Week closed. Payroll of {0} recorded in Accounts.",
  "Semana cerrada y limpiada.": "Week closed and cleared.",
  "No se pudo cerrar la semana. Intenta de nuevo.": "Couldn't close the week. Try again.",
  "Cerrar la semana": "Close the week",
  "Finaliza el periodo: registra la nómina de la semana en Cuentas, descuenta del saldo de préstamo lo pagado y borra el detalle capturado (turnos, propinas, asistencias).": "Ends the period: records the week's payroll in Accounts, deducts what was paid from loan balances and clears the recorded details (shifts, tips, attendance).",
  "Exporta antes": "Export first",
  "si necesitas el resumen. Esta acción no se puede deshacer.": "if you need the summary. This can't be undone.",
  "Cerrar y Limpiar Semana": "Close and Clear Week",
  "Cerrar y limpiar la semana": "Close and clear the week",
  "¿Estás seguro de que deseas cerrar esta semana? Se borrará el detalle capturado de esta semana y se descontarán los préstamos del saldo de cada empleado. Esta acción no se puede deshacer.": "Are you sure you want to close this week? This week's recorded details will be cleared and loans will be deducted from each employee's balance. This can't be undone.",
  "Se registrará en Cuentas": "Will be recorded in Accounts",
  "· fecha": "· date",
  "Costo bruto: sueldos, extras, feriados y bonos. Sin propinas ni deducciones.": "Gross cost: wages, extras, holidays and bonuses. No tips or deductions.",
  "No hay nómina capturada: no se registrará ningún gasto.": "No payroll recorded: no expense will be recorded.",
  "Sí, cerrar semana": "Yes, close week",
  "No se pudo generar el recibo. Intenta de nuevo.": "Couldn't generate the pay slip. Try again.",
  "No se pudo enviar el recibo de {0}: {1}.": "Couldn't send {0}'s pay slip: {1}.",
  "Recibo de {0} enviado por WhatsApp.": "{0}'s pay slip sent over WhatsApp.",
  "No se pudo enviar por WhatsApp. Revisa que el bot esté conectado.": "Couldn't send over WhatsApp. Check that the bot is connected.",
  "Recibos de pago": "Pay slips",
  "Una imagen por empleado con el desglose de la semana.{0}": "One image per employee with the week's breakdown.{0}",
  "Descargar recibo de {0}": "Download {0}'s pay slip",
  "Compartir recibo de {0}": "Share {0}'s pay slip",
  "Enviar recibo de {0} por WhatsApp": "Send {0}'s pay slip over WhatsApp",
  "Salarios base": "Base wages",
  "Resumen de la semana": "Week summary",
  "Resumen del mes": "Month summary",
  "Costo total de nómina": "Total payroll cost",
  "Total en efectivo faltante": "Total cash remaining",
  "Semana recargada desde el servidor.": "Week reloaded from the server.",
  "No se pudo recargar. Revisa la conexión e inténtalo de nuevo.": "Couldn't reload. Check your connection and try again.",
  "Salario por hora": "Hourly wage",
  "Saldo de préstamo": "Loan balance",
  "{0} / hora": "{0} / hour",
  "Salario por turno": "Wage per shift",
  "{0} / turno · {1} / hora": "{0} / shift · {1} / hour",
  "Préstamos, deducciones, pagos extras y vacaciones se precargan cada semana en Nóminas y ahí se pueden modificar.": "Loans, deductions, extra payments and vacation are preloaded every week in Payroll and can be changed there.",
  "Editar {0}": "Edit {0}",
  "Nuevo {0}": "New {0}",
  "Nombre": "Name",
  "Nombre completo": "Full name",
  "Apodo": "Nickname",
  "Mote o cómo le dicen; aparece en los desplegables como “Apodo (Nombre)”. Opcional.": "What people call them; shows in dropdowns as “Nickname (Name)”. Optional.",
  "Ej. El Güero, Chuy, La Güera": "E.g. Blondie, Chuy, Red",
  "Con código de país, solo números. Ej. 52 664 123 4567. Si se deja vacío no aparece el botón de WhatsApp al exportar recibos.": "With country code, numbers only. E.g. 52 664 123 4567. If left empty, the WhatsApp button won't appear when exporting pay slips.",
  "Fecha de Nacimiento": "Date of Birth",
  "Para el recordatorio de cumpleaños por WhatsApp (avisa un día antes). Opcional.": "For the WhatsApp birthday reminder (sent a day before). Optional.",
  "Orden": "Order",
  "Aún no hay": "No",
  "s. Agrega el primero.": "s yet. Add the first one.",
  "Subir a {0}": "Move {0} up",
  "Bajar a {0}": "Move {0} down",
  "Dar de baja a {0}": "Deactivate {0}",
  "Dar de baja": "Deactivate",
  "¿Dar de baja a {0}? Dejará de aparecer en Nóminas y en los desplegables, pero su historial (nóminas, préstamos, capturas) se conserva y pasa a Ex-empleados.": "Deactivate {0}? They'll stop appearing in Payroll and dropdowns, but their history (payroll, loans, records) is kept under Former employees.",
  "{0} vuelve a estar activo.": "{0} is active again.",
  "No se pudo reactivar en el servidor. Revisa la conexión.": "Couldn't reactivate on the server. Check your connection.",
  "Ex-empleados ({0})": "Former employees ({0})",
  "Dados de baja: ya no aparecen en Nóminas ni en los desplegables, pero su historial se conserva. Reactívalos si regresan.": "Deactivated: they no longer appear in Payroll or dropdowns, but their history is kept. Reactivate them if they come back.",
  "Fecha de baja": "Deactivation date",
  "Reactivar a {0}": "Reactivate {0}",
  "Apodos separados por coma (Iceberg Chihuahua, ICEBERG…)": "Nicknames separated by commas (Iceberg Chihuahua, ICEBERG…)",
  "El tipo de ingreso \"CASH\" es obligatorio para el cuadre automático de salidas de efectivo y no puede eliminarse ni reordenarse.": "The \"CASH\" income type is required to automatically balance cash outflows and can't be deleted or reordered.",
  "Fijo": "Fixed",
  "Subir {0}": "Move {0} up",
  "Bajar {0}": "Move {0} down",
  "Eliminar {0}": "Delete {0}",
  "No se pudieron leer los inactivos. Revisa la conexión.": "Couldn't load inactive items. Check your connection.",
  "“{0}” vuelve a estar disponible.": "“{0}” is available again.",
  "“{0}” ya existe en este catálogo.": "“{0}” already exists in this catalog.",
  "No hay opciones activas. Agrega una nueva abajo": "No active options. Add a new one below",
  "recupera las dadas de baja": "restores deactivated ones",
  "¿Dar de baja \"{0}\"? Puedes reactivarla en \"Inactivos\".": "Deactivate \"{0}\"? You can reactivate it under \"Inactive\".",
  "Nueva opción": "New option",
  "Agregar opción": "Add option",
  "Ocultar inactivos": "Hide inactive",
  "Leyendo inactivos…": "Loading inactive…",
  "Ver inactivos": "Show inactive",
  "No hay opciones dadas de baja.": "No deactivated options.",
  "Reactivar {0}": "Reactivate {0}",
  "No se pudo consultar el estado del bot.": "Couldn't check the bot's status.",
  "Estado del Bot de WhatsApp": "WhatsApp Bot Status",
  "Consultando estado…": "Checking status…",
  "El bot está": "The bot is",
  "deshabilitado": "disabled",
  ". Para activarlo define": ". To enable it, set",
  "en el": "in the",
  "del backend y reinícialo.": "of the backend and restart it.",
  "WhatsApp Bot: Conectado": "WhatsApp Bot: Connected",
  "Escanéalo con": "Scan it with",
  ": Ajustes → Dispositivos vinculados → Vincular dispositivo. El código expira en ~20 s y se actualiza solo.": ": Settings → Linked devices → Link a device. The code expires in ~20 s and refreshes by itself.",
  "Actualizar QR": "Refresh QR",
  "Conectando… (esperando el código QR)": "Connecting… (waiting for the QR code)",
  "No se pudieron cargar los números autorizados.": "Couldn't load the authorized numbers.",
  "Escribe el número con código de país y solo dígitos (p. ej. 5216641234567).": "Type the number with country code, digits only (e.g. 5216641234567).",
  "Quitar": "Remove",
  "Quitar número": "Remove number",
  "¿Quitar {0} de los autorizados?": "Remove {0} from the authorized numbers?",
  "Números autorizados": "Authorized numbers",
  "Solo estos números pueden escribirle al bot (fotos, PDF, XML o texto) y reciben el resumen diario. Formato: código de país + número, solo dígitos.": "Only these numbers can message the bot (photos, PDF, XML or text) and they get the daily summary. Format: country code + number, digits only.",
  "Sin números autorizados.": "No authorized numbers.",
  "Quitar {0}": "Remove {0}",
  "Nuevo número autorizado": "New authorized number",
  "Agregar número autorizado": "Add authorized number",
  "Ver recorrido": "Take the tour",
  "Catálogos": "Catalogs",
  "Tipos de ingresos": "Income types",
  "Cómo entra el dinero: CASH, terminales, transferencias…": "How money comes in: CASH, terminals, transfers…",
  "Métodos de pago de gastos": "Expense payment methods",
  "Con qué se pagan las salidas.": "What outflows are paid with.",
  "A quién se le compra. Edita una fila para darle apodos separados por coma (su nombre corto o de factura): así un ticket no duplica el proveedor.": "Who you buy from. Edit a row to give it comma-separated nicknames (its short or invoice name), so a receipt doesn't duplicate the supplier.",
  "Conceptos de Salida": "Outflow Items",
  "Los conceptos del desplegable del Cajón en el Corte. Mismo catálogo: agrégalos, edítalos o arrástralos para cambiar su orden.": "The items in the Drawer dropdown of the Cash-up. Same catalog: add, edit or drag them to reorder.",
  "Este comprobante no tiene archivo.": "This receipt has no file.",
  "No se pudo descargar ({0}).": "Couldn't download ({0}).",
  "Ver ticket de {0} · {1}": "View receipt for {0} · {1}",
  "Comprobante de {0}": "Receipt for {0}",
  "Datos de facturación": "Billing details",
  "Comprobante descargado": "Receipt downloaded",
  "Descargar": "Download",
  "Registro": "Record",
  "Gasto": "Expense",
  "No se pudo cargar la Bóveda.": "Couldn't load the Vault.",
  "Refrescar bóveda": "Refresh vault",
  "Bóveda de Tickets": "Receipt Vault",
  "Fecha de la Bóveda": "Vault date",
  "Sin comprobantes para el": "No receipts for",
  ". Escanea un ticket arriba o envía un recibo de nómina para que aparezca aquí.": ". Scan a receipt above or send a pay slip for it to show up here.",
  "Las fotos se conservan 14 días; las anteriores están en el correo del cierre de caja.": "Photos are kept for 14 days; older ones are in the cash-up email.",
  "comprobante": "receipt",
  "Este dispositivo no tiene espacio para su copia local. Lo capturado se sigue guardando en el servidor mientras haya conexión.": "This device has no space for its local copy. What you enter is still saved to the server while you're online.",
  "El backoffice del super administrador no está disponible en la demo.": "The super admin backoffice isn't available in the demo.",
  "No se pudo cargar la lista.": "Couldn't load the list.",
  "Negocio \"{0}\" creado: {1}.soedia.com. Enviamos a {2} un enlace para crear su contraseña.": "Business \"{0}\" created: {1}.soedia.com. We sent {2} a link to create their password.",
  "Negocio \"{0}\" creado: {1}.soedia.com.": "Business \"{0}\" created: {1}.soedia.com.",
  "No se pudo enviar la invitación a {0} ({1}).": "Couldn't send the invitation to {0} ({1}).",
  "error de correo": "email error",
  "Pásale este enlace para que cree su contraseña:": "Send them this link so they can create their password:",
  "Enlace para crear contraseña": "Link to create password",
  "Ese subdominio ya está en uso.": "That subdomain is already taken.",
  "Subdominio no válido o reservado.": "Invalid or reserved subdomain.",
  "No se pudo crear el negocio.": "Couldn't create the business.",
  "Super Admin": "Super Admin",
  "Admin Dashboard": "Admin Dashboard",
  "Backoffice de negocios": "Business backoffice",
  "Cerrar sesión": "Sign out",
  "Nuevo negocio": "New business",
  "Crea el negocio y la cuenta de su administrador. Le llega un correo de hola@soedia.com con un enlace para crear su contraseña (o puede entrar con Google si es Gmail).": "Create the business and its administrator's account. They get an email from hola@soedia.com with a link to create their password (or they can sign in with Google if it's Gmail).",
  "Subdominio": "Subdomain",
  "(.soedia.com)": "(.soedia.com)",
  "Email del administrador": "Administrator email",
  "Creando…": "Creating…",
  "Crear negocio": "Create business",
  "Negocios": "Businesses",
  "Cargando…": "Loading…",
  "Enviamos a {0} un enlace para crear su contraseña.": "We sent {0} a link to create their password.",
  "Sin cambios.": "No changes.",
  "sin administrador": "no administrator",
  "Editar email": "Edit email",
  "Reenviar invitación": "Resend invitation",
  "Borrar": "Delete",
  "Le enviamos la invitación a la dirección nueva.": "We'll send the invitation to the new address.",
  "Guardar email": "Save email",
  "Se borran el negocio, TODOS sus datos y las cuentas de sus usuarios. No se puede deshacer.": "This deletes the business, ALL its data and its users' accounts. It can't be undone.",
  "Escribe {0} para confirmar": "Type {0} to confirm",
  "Borrando…": "Deleting…",
  "Borrar negocio": "Delete business",
  "Este enlace ya caducó o ya se usó. Pide uno nuevo con \"¿Olvidaste tu contraseña?\" en la pantalla de acceso.": "This link has expired or was already used. Request a new one with \"Forgot your password?\" on the sign-in screen.",
  "Algo salió mal. Inténtalo de nuevo.": "Something went wrong. Please try again.",
  "Las contraseñas no coinciden.": "The passwords don't match.",
  "Confirmar correo": "Confirm email",
  "Contraseña creada": "Password created",
  "Crea tu contraseña": "Create your password",
  "Para {0}": "For {0}",
  "Nueva contraseña": "New password",
  "Repite la contraseña": "Repeat the password",
  "Guardar contraseña": "Save password",
  "Tu correo quedó confirmado. Ya puedes entrar.": "Your email is confirmed. You can sign in now.",
  "Listo. Ya puedes entrar con tu email y tu nueva contraseña.": "Done. You can now sign in with your email and your new password.",
  "Ir a la pantalla de acceso": "Go to the sign-in screen",
  "Aún no hay negocios.": "No businesses yet.",
  "Estado": "Status",
  "Creado": "Created",
  "Activo": "Active",
  "Suspendido": "Suspended",
  "Administración": "Administration",
  "Backoffice del super administrador.": "Super administrator backoffice.",
  "Tu cuenta no está autorizada como super administrador.": "Your account isn't authorized as super administrator.",
  "Sesión inválida: la cuenta ya no existe. Vuelve a iniciar sesión.": "Invalid session: the account no longer exists. Sign in again.",
  "Sesión inválida. Vuelve a iniciar sesión.": "Invalid session. Sign in again.",
  "Error interno del servidor": "Internal server error",
  "Número inválido: escribe el teléfono con código de país (p. ej. 5216641234567).": "Invalid number: type the phone with country code (e.g. 5216641234567).",
  "Ese número ya está vinculado a otro espacio de trabajo.": "That number is already linked to another workspace.",
  "Fecha inválida. Usa YYYY-MM-DD.": "Invalid date. Use YYYY-MM-DD.",
  "El bot de WhatsApp no está conectado. Escanea el QR en Ajustes → WhatsApp.": "The WhatsApp bot isn't connected. Scan the QR in Settings → WhatsApp.",
  "Falta el token de Google.": "The Google token is missing.",
  "No se pudo verificar tu cuenta de Google.": "Your Google account couldn't be verified.",
  "Confirma tu correo antes de entrar: revisa el enlace que te enviamos.": "Confirm your email before signing in: check the link we sent you.",
  "Subdominio no encontrado.": "Subdomain not found.",
  "Esta cuenta de negocio está suspendida.": "This business account is suspended.",
  "Tu cuenta no está provisionada en este espacio de trabajo. Pide al administrador que te agregue.": "Your account isn't set up in this workspace. Ask the administrator to add you.",
  "Nombre de archivo inválido": "Invalid file name",
  "Archivo no encontrado": "File not found",
  "La imagen no se pudo decodificar.": "The image couldn't be decoded.",
  "La semana cambió en otro dispositivo": "The week changed on another device",
  "El monto del préstamo debe ser un número mayor a 0.": "The loan amount must be a number greater than 0.",
  "No se encontró al empleado del préstamo.": "The loan's employee wasn't found.",
  "Falta la lista de destinatarios.": "The recipient list is missing.",
  "El bot de WhatsApp no está conectado.": "The WhatsApp bot isn't connected.",
  "La base de datos está ocupada; vuelve a intentarlo en unos segundos.": "The database is busy; try again in a few seconds.",
  "El registro cambió en otro dispositivo": "The record changed on another device",
  "Acceso restringido: solo el super administrador puede entrar al backoffice.": "Restricted: only the super administrator can access the backoffice.",
  "La sesión no pertenece a ningún tenant. Vuelve a iniciar sesión.": "The session doesn't belong to any business. Sign in again.",
  "El tenant de la petición no coincide con tu sesión. Entraste desde otro subdominio.": "The request's business doesn't match your session. You signed in from another subdomain.",
  "Esta cuenta de negocio está suspendida. Contacta al administrador.": "This business account is suspended. Contact the administrator.",
  "El monto del ingreso debe ser un número mayor o igual a 0.": "The income amount must be a number greater than or equal to 0.",
  "El monto del gasto debe ser un número mayor o igual a 0.": "The expense amount must be a number greater than or equal to 0.",
  "Gasto no encontrado.": "Expense not found.",
  "El monto debe ser un número mayor a 0.": "The amount must be a number greater than 0.",
  "Faltan campos: nombre, subdominio, email y contraseña del administrador.": "Missing fields: name, subdomain, administrator email and password.",
  "Email no válido.": "Invalid email.",
  "Ese email ya pertenece a otro negocio.": "That email already belongs to another business.",
  "Ese email ya tiene cuenta en Firebase: usa otro o que entre con su contraseña actual.": "That email already has a Firebase account: use another one, or have them sign in with their current password.",
  "No se pudo crear la contraseña (Firebase).": "Couldn't create the password (Firebase).",
  "Ya existe un ítem con ese nombre en este catálogo.": "An item with that name already exists in this catalog.",
  "El método CASH es obligatorio para el cuadre automático de salidas de efectivo y no puede ser eliminado.": "The CASH method is required to automatically balance cash outflows and can't be deleted.",
  "Ítem de catálogo no encontrado.": "Catalog item not found.",
  "Empleado no encontrado.": "Employee not found.",
  "Negocio no encontrado.": "Business not found.",
  "Escribe el nombre del negocio (máx. 80 caracteres).": "Type the business name (max. 80 characters).",
  "Sube una imagen PNG, JPG o WebP.": "Upload a PNG, JPG or WebP image.",
  "No se pudo guardar el logo.": "Couldn't save the logo.",
  "¡{0} está listo!": "{0} is ready!",
  "empleado": "employee",
  "mesero": "waiter",
  "Idioma": "Language",
  "fondo del": "float for",
  "caja del": "register for",
  "${0}/turno": "${0}/shift",
  "Cambiar idioma a {0}": "Switch language to {0}",
  "El asistente no respondió. Inténtalo de nuevo.": "The assistant didn't respond. Try again.",
  "La imagen pesa más de 8 MB.": "The image is larger than 8 MB.",
  "Abrir asistente": "Open assistant",
  "Asistente": "Assistant",
  "El asistente no está disponible en la demo.": "The assistant isn't available in the demo.",
  "Pregúntame por tus números o manda la foto de un ticket para registrarlo.": "Ask me about your numbers or send a photo of a receipt to record it.",
  "¿Cómo van mis gastos esta semana comparados con la anterior?": "How are my expenses this week compared to last week?",
  "¿Cómo puedo optimizar mis gastos a largo plazo?": "How can I optimize my expenses in the long term?",
  "Foto adjunta": "Attached photo",
  "Pensando…": "Thinking…",
  "Quitar foto": "Remove photo",
  "Adjuntar foto": "Attach photo",
  "Escribe un mensaje…": "Type a message…",
  "Mensaje": "Message",
  "Enviar": "Send",
  "Moneda": "Currency",
  "Impuestos": "Taxes",
  "Los que aparecen al capturar un gasto. El porcentaje se usa para calcular el impuesto incluido en el total.": "The ones offered when you record an expense. The percentage is used to work out the tax included in the total.",
  "Sin impuestos.": "No taxes.",
  "Nombre (p. ej. IVA)": "Name (e.g. VAT)",
  "Nombre del impuesto": "Tax name",
  "Porcentaje": "Percentage",
  "Agregar impuesto": "Add tax",
  "Impuesto": "Tax",
  "Monto de {0}": "{0} amount",
  "Se prellena con el {0}% del total; pon el EXACTO del comprobante si difiere.": "Prefilled with {0}% of the total; enter the EXACT amount from the receipt if it differs.",
  "Sin impuesto": "No tax",
  "El impuesto del comprobante, no el total (ej. $160).": "The receipt's tax, not the total (e.g. $160).",
  "Moneda e impuestos": "Currency and taxes",
  "Con qué moneda trabajas y qué impuestos llevan tus gastos.": "The currency you work in and the taxes on your expenses.",
  "Análisis": "Analytics",
  "Revisa mis ingresos y gastos de los últimos {0} y dame 3 sugerencias concretas para optimizar mis gastos a largo plazo.": "Review my income and expenses over the last {0} and give me 3 concrete suggestions to optimize my expenses in the long term.",
  "meses": "months",
  "semanas": "weeks",
  "Mensual": "Monthly",
  "Todavía no hay ingresos ni gastos para comparar.": "No income or expenses to compare yet.",
  "Ingresos del mes": "Income this month",
  "Ingresos de la semana": "Income this week",
  "Impuestos pagados": "Taxes paid",
  "Ingresos vs gastos vs impuestos": "Income vs expenses vs taxes",
  "Últimos {0} meses.": "Last {0} months.",
  "Últimas {0} semanas (martes a domingo).": "Last {0} weeks (Tuesday to Sunday).",
  "Planeación": "Planning",
  "Estimación: sigue la tendencia de los periodos cerrados. No considera temporadas ni eventos.": "Estimate: follows the trend of closed periods. It doesn't account for seasons or events.",
  "Sugerencias del asistente": "Assistant suggestions",
  "Se necesitan al menos 2 periodos cerrados para proyectar.": "At least 2 closed periods are needed to project.",
  "Neto proyectado (próximos {0})": "Projected net (next {0})",
  "Gastos / ingresos (promedio)": "Expenses / income (average)",
  "Semana +{0}": "Week +{0}",
  "Mes +{0}": "Month +{0}",
  "vs anterior": "vs previous",
  "Impuesto no encontrado.": "Tax not found.",
  "El chat no está configurado (falta GEMINI_API_KEY).": "The chat isn't configured (GEMINI_API_KEY is missing).",
  "Escribe un mensaje o adjunta una foto.": "Type a message or attach a photo.",
  "Moneda no válida (código ISO, p. ej. MXN).": "Invalid currency (ISO code, e.g. MXN).",
  "Nada que actualizar.": "Nothing to update.",
  "Escribe el nombre del impuesto (máx. 40 caracteres).": "Type the tax name (max. 40 characters).",
  "El porcentaje debe estar entre 0 y 100.": "The percentage must be between 0 and 100.",
  "Entrar como admin (desarrollo)": "Sign in as admin (development)",
  "Logo guardado: la app usa ahora sus colores.": "Logo saved: the app now uses its colors.",
  "Logo guardado.": "Logo saved.",
  "Si tu logo tiene color, la app toma su tono principal.": "If your logo has color, the app takes on its main tone.",
  "Logo y colores": "Logo and colors",
  "Color no válido (#rrggbb).": "Invalid color (#rrggbb).",
  "TARJETA": "CARD",
  "VENTAS EN LÍNEA": "ONLINE SALES",
  "TRANSFERENCIA": "TRANSFER",
  "TARJETA DE CRÉDITO": "CREDIT CARD",
  "TARJETA DE DÉBITO": "DEBIT CARD",
  "Distribuidora de Mercancía": "Merchandise Distributor",
  "Supermercado": "Supermarket",
  "Papelería y Oficina": "Office Supplies",
  "Gas LP": "Propane Gas",
  "Agua y Limpieza": "Water & Cleaning",
  "Frutas y Verduras": "Produce Market",
  "Bebidas": "Beverages",
  "Salida efectivo": "Cash outflow",
  "Salida de efectivo": "Cash outflow",
  "Pago de servicios": "Utilities",
  "Mantenimiento / Reparación": "Maintenance / Repair",
  "Agua / Limpieza": "Water / Cleaning",
  "Compra de insumos": "Supplies purchase",
  "Prestamo a empleado": "Employee loan",
  "Finiquito de empleado": "Employee severance",
  "Insumos semanales": "Weekly supplies",
  "Despensa": "Groceries",
  "Quesos y embutidos": "Cheese and cold cuts",
  "Recarga de tanque": "Tank refill",
  "Hielo fin de semana": "Weekend ice",
  "Compra mensual": "Monthly purchase",
  "Pescados y mariscos": "Fish and seafood",
  "Renta de tanque": "Tank rental",
  "Pregúntale al asistente por tus números o mándale la foto de un ticket. Abajo, todos los comprobantes del negocio.": "Ask the assistant about your numbers or send it a photo of a receipt. Below, all of the business's receipts.",
  "Personal, catálogos, moneda e impuestos. Aquí también puedes volver a ver este recorrido.": "Staff, catalogs, currency and taxes. You can also replay this tour here.",
  "{0} con actividad en las últimas 4 semanas": "{0} with activity in the last 4 weeks",
  "Registros (4 semanas)": "Records (4 weeks)",
  "ingresos y gastos capturados": "income and expenses recorded",
  "Gastos registrados": "Expenses recorded",
  "{0} con comprobante": "{0} with a receipt",
  "Cortes de caja cerrados": "Cash-ups closed",
  "días cuadrados en la app": "days balanced in the app",
  "Personal en nómina": "Staff on payroll",
  "empleados activos": "active employees",
  "Volumen administrado": "Volume managed",
  "ingresos + gastos registrados": "income + expenses recorded",
  "Actividad semanal": "Weekly activity",
  "Registros capturados y negocios activos, últimas 12 semanas": "Records captured and active businesses, last 12 weeks",
  "Registros": "Records",
  "Negocios activos": "Active businesses",
  "Uso por negocio": "Usage by business",
  "Ordenado por actividad reciente": "Sorted by recent activity",
  "Negocio": "Business",
  "Registros (4 sem.)": "Records (4 wk)",
  "Comprobantes": "Receipts",
  "Cortes": "Cash-ups",
  "Personal": "Staff",
  "Última actividad": "Last activity",
  "Negocio {0}": "Business {0}",
  "sin configurar": "not set up",
  "Modo presentación": "Presentation mode",
  "Datos anónimos: sin nombres de negocios, personas ni correos.": "Anonymous data: no business names, people or emails.",
  "El navegador bloqueó la ventana de Google. Toca el botón otra vez.": "The browser blocked the Google window. Tap the button again.",
  "Falta GEMINI_API_KEY en Coolify": "GEMINI_API_KEY is missing in Coolify",
  "Apagado: prende WhatsApp en algún negocio": "Off: turn WhatsApp on for a business",
  "Conectado{0}": "Connected{0}",
  "Escanea el QR con el WhatsApp del número del bot": "Scan the QR with the bot number's WhatsApp",
  "Bot de WhatsApp": "WhatsApp bot",
  "activo": "on",
  "apagado": "off",
  "Revisando configuración…": "Checking setup…",
  "DNS (Dynadot): registro A \"{0}\" → {1}. Un registro \"*\" lo resuelve para todos.": "DNS (Dynadot): A record \"{0}\" → {1}. One \"*\" record covers every business.",
  "Coolify → Website → frontend → Domains: agrega https://{0} y redeploy.": "Coolify → Website → frontend → Domains: add https://{0} and redeploy.",
  "Firebase → Authentication → Settings → Authorized domains: agrega {0}.": "Firebase → Authentication → Settings → Authorized domains: add {0}.",
  "Falta configurar para que abra {0}:": "Still needed before {0} opens:",
  "Pendiente": "Pending",
  "Volver a revisar": "Check again",
  "Guardado. Los reportes llegarán también a esos correos.": "Saved. Reports will also go to those emails.",
  "Correos de reportes": "Report emails",
  "Correos adicionales": "Extra emails",
  "El corte diario y el reporte semanal llegan al admin ({0}) y a estos correos. Sepáralos con comas.": "The daily cash-up and the weekly report go to the admin ({0}) and to these emails. Separate them with commas.",
  "Guardar correos": "Save emails",
  "Por turno": "Per shift",
  "Por hora": "Per hour",
  "Por día": "Per day",
  "Sueldo semanal": "Weekly salary",
  "Misma propina para cada quien en el turno": "Same tip for everyone on the shift",
  "Bote del turno, partes iguales": "Shift pool, split equally",
  "Bote del día, según horas trabajadas": "Day pool, split by hours worked",
  "Bote de la semana, según horas trabajadas": "Week pool, split by hours worked",
  "Propinas de la semana": "Tips for the week",
  "se reparten según las horas ({0} h en la semana)": "split by hours ({0} h this week)",
  "A mano. Según horas le tocarían {0}; borra el monto para volver al cálculo.": "Set by hand. By hours it would be {0}; clear the amount to go back to the calculation.",
  "Según horas: {0} h de {1} h = {2}. Escribe otro monto para cambiarlo.": "By hours: {0} h of {1} h = {2}. Type another amount to change it.",
  "Propinas de la semana, a mano": "Tips for the week, set by hand",
  "{0} h de {1} h de la semana": "{0} h of {1} h this week",
  "Propina distinta por empleado": "Different tip per employee",
  "Extra de propinas a mano en la semana": "Manual weekly tip bonus",
  "Sin propinas": "No tips",
  "Grupos de personal": "Staff groups",
  "Cada grupo tiene su propia pestaña en Nóminas y su forma de pago.": "Each group gets its own tab in Payroll and its own way of being paid.",
  "Nombre del grupo": "Group name",
  "Tiene personal: muévelo o dalo de baja primero": "It has staff: deactivate them first",
  "Quitar grupo": "Remove group",
  "Quitar grupo {0}": "Remove group {0}",
  "Se paga": "Paid",
  "Misma propina para cada quien en el día": "Same tip for everyone that day",
  "Bote del día, partes iguales": "Day pool, split equally",
  "Paga horas extra": "Pays overtime",
  "Agregar grupo": "Add group",
  "Turnos y días": "Shifts and days",
  "Qué turnos abre cada día. Un día sin turnos queda cerrado (el lunes siempre es descanso).": "Which shifts open each day. A day with no shifts is closed (Monday is always a rest day).",
  "Nombre del turno": "Shift name",
  "Quitar turno {0}": "Remove shift {0}",
  "Reglas": "Rules",
  "Feriado: el pago se multiplica ×": "Holiday: pay is multiplied ×",
  "Bono de puntualidad ({0})": "Punctuality bonus ({0})",
  "Propinas del Corte → Nómina: a cada turno se le descuenta este % y este monto fijo, y el resto se divide entre quienes trabajaron. Siempre se redondea hacia arriba.": "Daily Close → Payroll tips: each shift has this % and fixed amount deducted, and the rest is split among who worked. Always rounded up.",
  "Propinas: descuento (%)": "Tips: deduction (%)",
  "Propinas: cargo fijo por turno ({0})": "Tips: fixed fee per shift ({0})",
  "Propinas: parte de cocina (%)": "Tips: kitchen share (%)",
  "Propinas de cocina se pagan": "Kitchen tips are paid",
  "Cada semana": "Every week",
  "Cada mes": "Every month",
  "Propinas del mes": "Tips this month",
  "El total de propinas del mes y lo que le toca a la cocina.": "The month's total tips and the kitchen's share.",
  "La cocina cobra sus propinas": "Kitchen gets its tips",
  "La cocina cobra sus propinas cada mes.": "The kitchen now gets its tips monthly.",
  "La cocina cobra sus propinas cada semana.": "The kitchen now gets its tips weekly.",
  "La cocina cobra al cierre del mes: en {0} lleva {1}.": "The kitchen is paid at month end: {1} so far in {0}.",
  "La cocina cobra cada semana: esta es la suma de todas las semanas del mes.": "The kitchen is paid weekly: this is the sum of every week in the month.",
  "Todavía no hay propinas capturadas este mes.": "No tips recorded this month yet.",
  "Propinas del Corte → Nómina: a cada turno se le descuenta la parte de cocina (%) y el monto fijo, y el resto se divide entre los meseros que trabajaron. Siempre se redondea hacia arriba.": "Daily Close → Payroll tips: each shift has the kitchen share (%) and the fixed amount deducted, and the rest is split among the waiters who worked. Always rounded up.",
  "Porcentaje de cocina guardado.": "Kitchen share saved.",
  "El total de propinas de la semana y lo que le toca a la cocina.": "The week's total tips and the kitchen's share.",
  "Total de propinas": "Total tips",
  "Le toca a cocina": "Kitchen gets",
  "Porcentaje de propinas para cocina": "Kitchen tip percentage",
  "Para cocina": "For the kitchen",
  "Para meseros": "For waiters",
  "Todavía no hay propinas capturadas esta semana.": "No tips recorded this week yet.",
  "Horas extra después de (h/día)": "Overtime after (h/day)",
  "Horas extra se pagan ×": "Overtime is paid ×",
  "Propina total (se reparte)": "Total tips (split)",
  "Propina de {0}, turno {1}": "{0}'s tip, {1} shift",
  "persona": "person",
  "personas": "people",
  "Día feriado (×{0})": "Holiday (×{0})",
  "Día Feriado ×{0}": "Holiday ×{0}",
  "Feriado ×{0}": "Holiday ×{0}",
  "${0}/día": "${0}/day",
  "${0}/semana": "${0}/week",
  "Propina total": "Total tips",
  "Propina de {0}, {1} {2}": "{0}'s tip, {1} {2}",
  "turno": "shift",
  "turnos": "shifts",
  "día": "day",
  "días": "days",
  "día con falta": "day absent",
  "días con falta": "days absent",
  "esta semana: se descuenta del sueldo semanal.": "this week: deducted from the weekly salary.",
  "esta semana. Las faltas no cambian la nómina; queda como registro.": "this week. Absences don't change pay; they're kept as a record.",
  "No hay personal en {0}. Agrégalo en Ajustes.": "No staff in {0}. Add them in Settings.",
  "Propina total del día": "Total tips for the day",
  "Propina del {0}": "Tips on {0}",
  "Propina de {0} el {1}": "{0}'s tip on {1}",
  "falta": "absence",
  "faltas": "absences",
  "esta semana.": "this week.",
  "Salario por día": "Daily pay",
  "{0} / día": "{0} / day",
  "{0} / semana": "{0} / week",
  "Configuración de nómina guardada.": "Payroll setup saved.",
  "No se pudo guardar.": "Couldn't save.",
  "Tu personal": "Your staff",
  "Cómo divides a tu equipo, cómo le pagas y cómo se reparten las propinas.": "How your team is split, how you pay them and how tips are shared.",
  "Semana": "Week",
  "Semana de nómina": "Payroll week",
  "El día con el que empieza cada semana de pago (Nóminas, Cuentas y reportes).": "The day each pay week starts (Payroll, Accounts and reports).",
  "Empieza el": "Starts on",
  "Las semanas ya capturadas se quedan con su día de inicio anterior: cambia esto al cerrar una semana, no a la mitad.": "Weeks already captured keep their previous start day: change this when a week closes, not in the middle of one.",
  "Qué turnos abre cada día. Un día sin turnos queda cerrado (descanso).": "Which shifts open each day. A day with no shifts is closed (rest day).",
  "Lunes": "Monday",
  "Lun": "Mon",
  "Periodo de prueba": "Trial",
  "Activa": "Active",
  "Pago pendiente": "Payment due",
  "Sin pagar": "Unpaid",
  "Cancelada": "Canceled",
  "Pago incompleto": "Payment incomplete",
  "Expirada": "Expired",
  "En pausa": "Paused",
  "¡Gracias! Tu suscripción se está activando.": "Thanks! Your subscription is being activated.",
  "No se pudo abrir Stripe.": "Couldn't open Stripe.",
  "La suscripción aún no está disponible.": "Subscriptions aren't available yet.",
  "Soedia gratis": "Soedia for free",
  "Este negocio usa Soedia sin costo. No hay nada que pagar.": "This business uses Soedia at no cost. There's nothing to pay.",
  "Suscripción a Soedia": "Soedia subscription",
  "anual": "yearly",
  "mensual": "monthly",
  "prueba hasta el {0}": "trial until {0}",
  "se renueva el {0}": "renews on {0}",
  "Elige tu plan: los primeros {0} días son gratis.": "Choose your plan: the first {0} days are free.",
  "Elige tu plan para seguir usando Soedia.": "Choose your plan to keep using Soedia.",
  "No pudimos cobrar tu último pago. Actualiza tu tarjeta para no perder el acceso.": "We couldn't collect your last payment. Update your card to keep access.",
  "Administrar suscripción": "Manage subscription",
  "Los planes aún no están configurados.": "Plans aren't set up yet.",
  "Anual": "Yearly",
  "año": "year",
  "mes": "month",
  "El pago lo procesa Stripe. Ahí mismo cambias tu tarjeta, tu plan o cancelas, y descargas tus facturas.": "Payments are processed by Stripe. There you can change your card or plan, cancel, and download your invoices.",
  "No pudimos cobrar tu suscripción. Toca aquí para actualizar tu tarjeta y no perder el acceso.": "We couldn't charge your subscription. Tap here to update your card and keep access.",
  "Sin suscripción": "No subscription",
  "Prueba": "Trial",
  "Pagando": "Paying",
  "Incompleta": "Incomplete",
  "Gratis": "Free",
  "Soedia sin costo para este negocio: no se le cobra ni se suspende por pago.": "Soedia at no cost for this business: never charged or suspended for payment.",
  "Siempre gratis": "Always free",
  "Enlace de pago": "Payment link",
  "Copiado. Mándaselo al negocio (vence en 24 h):": "Copied. Send it to the business (expires in 24 h):",
  "Suscripción": "Subscription",
  "Pagar plan mensual": "Pay monthly plan",
  "Pagar plan anual": "Pay yearly plan",
  "Si ya pagaste, recarga la página en unos segundos.": "If you already paid, reload the page in a few seconds.",
  "Tu acceso está en pausa": "Your access is paused",
  "Terminó tu prueba gratis o no se pudo cobrar tu suscripción. Elige un plan para seguir: tus datos siguen guardados.": "Your free trial ended or your subscription couldn't be charged. Choose a plan to continue: your data is still saved.",
  "Tu prueba gratis termina el {0}. Si eliges tu plan ahora, el primer cobro es ese día.": "Your free trial ends on {0}. If you choose your plan now, the first charge is that day.",
  "Te quedan {0} días de prueba gratis. Toca aquí para elegir tu plan.": "{0} days left in your free trial. Tap here to choose your plan.",
  "Tu prueba gratis termina hoy. Toca aquí para elegir tu plan y no perder el acceso.": "Your free trial ends today. Tap here to choose your plan and keep access.",
  "Suspendido por pago": "Suspended for payment",
  "Prueba: {0} días": "Trial: {0} days",
  "Esta invitación caducó. Pide una nueva con \"Primera vez: crear contraseña\" en la pantalla de acceso.": "This invitation expired. Ask for a new one with \"First time: create password\" on the sign-in screen.",
  "Esta cuenta ya tiene contraseña. Entra, o usa \"¿Olvidaste tu contraseña?\".": "This account already has a password. Sign in, or use \"Forgot your password?\".",
  "Te mandamos un enlace a tu correo para crear tu contraseña. Si tu cuenta ya tiene una, usa \"¿Olvidaste tu contraseña?\".": "We sent a link to your email to create your password. If your account already has one, use \"Forgot your password?\".",
  "No pudimos conectar con el servidor (puede estar actualizándose). Espera un momento y vuelve a intentarlo.": "We couldn't reach the server (it may be updating). Wait a moment and try again.",
  "Teléfono": "Phone",
  "Con código de país, solo números. Ej. 52 664 123 4567. Opcional.": "With country code, digits only. E.g. 52 664 123 4567. Optional.",
  "Para recordarte su cumpleaños. Opcional.": "To remind you of their birthday. Optional.",
  "Precios guardados en Stripe.": "Prices saved in Stripe.",
  "Cobro con Stripe": "Stripe billing",
  "Mensual (MXN)": "Monthly (MXN)",
  "Anual (MXN)": "Yearly (MXN)",
  "Guardar precios": "Save prices",
  "Cambiar un precio no afecta a quien ya está suscrito; aplica a las suscripciones nuevas.": "Changing a price doesn't affect current subscribers; it applies to new subscriptions.",
  "Escribe los dos montos.": "Enter both amounts.",
  "Secciones": "Sections",
  "Inicio": "Home",
  "Configuración": "Settings",
  "Finanzas": "Finances",
  "Cuentas del día (ingresos por terminal y gastos con comprobante), control de facturas y análisis con gráficas, todo en un solo lugar.": "Daily accounts (terminal income and expenses with receipts), invoice tracking and charts, all in one place.",
  "mi-negocio": "my-business",
  "contador@ejemplo.com, socio@ejemplo.com": "accountant@example.com, partner@example.com",
  "Módulos": "Modules",
  "Cobro": "Billing",
  "Cuenta": "Account",
  "Borrar negocio": "Delete business",
  "Personal": "Staff",
  " Ningún empleado tiene teléfono registrado (Ajustes → Personal).": " No employee has a phone number on file (Settings → Staff).",
  "{0} / turno": "{0} / shift",
  "No se pudo leer el estado del bot.": "Couldn't read the bot status.",
  "Cubre de {0}. No incluye pagos de nómina.": "Covers {0}. Doesn't include payroll payments.",
  "Últimas {0} semanas ({1}).": "Last {0} weeks ({1}).",
  "Hacerlo automático": "Do it automatically",
  "No se pudo registrar en Firebase.": "Couldn't register it in Firebase.",
  "· Agrega tu RFC y CP en Ajustes para tenerlos a la mano.": "· Add your Tax ID and ZIP in Settings to keep them handy.",
  "Soedia no genera tus facturas automáticamente: te deja a la mano los datos para que las pidas en el portal de cada proveedor.": "Soedia doesn't create your invoices automatically: it keeps the details handy so you can request them on each supplier's portal.",
  "Código postal": "ZIP code",
  "El RFC lleva 12 o 13 caracteres (p. ej. ABC010101AB1).": "The RFC has 12 or 13 characters (e.g. ABC010101AB1).",
  "El código postal lleva 5 dígitos.": "The ZIP code has 5 digits.",
  "Datos para facturar": "Billing details",
  "Tu RFC y código postal, para tenerlos a la mano cuando pidas facturas a tus proveedores.": "Your Tax ID (RFC) and ZIP code, handy when you request invoices from your suppliers.",
  "Datos para facturar guardados.": "Billing details saved.",
  "Modo Restaurante": "Restaurant Mode",
  "Modo Local / Servicios": "Retail / Services Mode",
  "Prueba la demo con tu tipo de negocio": "Try the demo with your type of business",
  "Tipo de negocio de la demo": "Demo business type",
  "Atención al cliente": "Customer service",
  "Taller / Empaque": "Workshop / Packing",
  "Ventas de los últimos 7 días": "Sales for the last 7 days",
  "Propina: {0}": "Tip: {0}",
  "Pasta Carbonara": "Pasta Carbonara",
  "Parrillada": "Grill platter",
  "Pizza y vino": "Pizza and wine",
  "Insumos: Tomate": "Supplies: Tomatoes",
  "Insumos: Queso parmesano": "Supplies: Parmesan cheese",
  "Corte de cabello": "Haircut",
  "Anillo de plata": "Silver ring",
  "Tinte y peinado": "Color and styling",
  "Insumos: Empaques": "Supplies: Packaging",
  "Insumos: Shampoo y tintes": "Supplies: Shampoo and dyes",
  "Insumos: Bolsas y etiquetas": "Supplies: Bags and labels",
  "Insumos: Tintes y shampoo": "Supplies: Dyes and shampoo",
  "Insumos: Plata y joyería": "Supplies: Silver and jewelry",
  "Mayorista": "Wholesaler",
  "Horas": "Hours",
  "Horas trabajadas de {0}": "Hours worked by {0}",
  "turno trabajado": "shift worked",
  "turnos trabajados": "shifts worked",
  "pagado; marcar como pendiente": "paid; mark as pending",
  "pendiente; marcar como pagado": "pending; mark as paid",
  "recibo": "payslip",
  "Neto = Nómina (transferencia bancaria) + Efectivo a dif. (efectivo a entregar).": "Net = Payroll (bank transfer) + Cash diff. (cash to hand over).",
  // Salidas del Cajón para empleados → Nóminas (lib/cajonPayroll.js)
  "Se descontará en la nómina de {0}": "It will be deducted from {0}'s payroll",
  "¿De qué empleado?": "Which employee?",
  "Empleado de la salida": "Employee for this outflow",
  "Para empleados: {0}": "For employees: {0}",
  "Descuento por semana": "Weekly deduction",
  "¿Cuánto se le descuenta por semana? Se suma a su saldo de préstamo y el primer descuento es la próxima semana.": "How much is deducted each week? It's added to their loan balance and the first deduction is next week.",
  "Saldo actual: {0}.": "Current balance: {0}.",
  "Préstamo a {0} · {1}/semana": "Loan to {0} · {1}/week",
  "Préstamo a {0}: {1} por semana desde la próxima": "Loan to {0}: {1} per week starting next week",
  "No se pudo sumar al saldo de préstamo; revísalo en Nóminas.": "Couldn't add it to the loan balance; check it in Payroll.",
  "No se pudo quitar el préstamo del saldo; revísalo en Nóminas.": "Couldn't remove the loan from the balance; check it in Payroll.",
  "Del Cajón el {0}: {1} · {2} por semana desde la próxima semana": "From the Drawer on {0}: {1} · {2} per week starting next week",
  "No hay empleados activos. Agrégalos en Ajustes.": "No active employees. Add them in Settings.",
  "Se le descuenta en Nóminas esa semana (Deducciones).": "It's deducted in that week's Payroll (Deductions).",
  "Nómina de {0}": "{0}'s payroll",
  "Para empleados: el Corte pide de quién es y se descuenta en su nómina": "For employees: the Cash-up asks who it's for and it's deducted from their payroll",
  "+ {0} del Cajón del Corte: {1}": "+ {0} from the Cash-up Drawer: {1}",
  "Los conceptos del desplegable del Cajón en el Corte. Mismo catálogo: agrégalos, edítalos o arrástralos para cambiar su orden. Marca con el ícono de persona los que son para alguien del equipo (Bono, Préstamo...): el Corte pide de quién es y se le descuenta en Nóminas esa semana; un Préstamo se suma a su saldo de préstamo y se descuenta por semana.": "The items in the Drawer dropdown of the Cash-up. Same catalog: add, edit or drag them to reorder. Tap the person icon on the ones that go to a team member (Bonus, Loan...): the Cash-up asks who it's for and it's deducted in that week's Payroll; a Loan is added to their loan balance and deducted weekly.",
  "Obligatorio": "Required",
  "¿Salió del cajón?": "Did it come out of the drawer?",
  "Sí, del cajón": "Yes, from the drawer",
  "Si salió del cajón, también se resta en el Cajón del Corte.": "If it came out of the drawer, it is also subtracted in the Cash-up Drawer.",
  "Se resta en el Cajón del Corte.": "It is subtracted in the Cash-up Drawer.",
  "Queda como gasto, pero no se resta en el Cajón.": "It stays as an expense, but it is not subtracted in the Drawer.",
  "No salió del cajón": "Not from the drawer"
};

// ---------------------------------------------------------------------------
// MÓDULO OPCIONAL: CONTROL DE INVENTARIO Y MERMAS
// ---------------------------------------------------------------------------
const inventoryStrings = {
  // Sección principal
  "Control de Inventario": "Inventory Control",
  "Módulo de inventario y mermas": "Inventory & Shrinkage Module",
  "Configurar el módulo": "Configure module",
  "Habilitar módulo": "Enable module",
  "Deshabilitar módulo": "Disable module",
  "Estado del módulo": "Module status",
  "Módulo activo": "Module active",
  "Módulo desactivado": "Module disabled",
  "El módulo de inventario y mermas está deshabilitado. Actívalo desde el panel de Ajustes del super administrador para comenzar a usar el módulo.":
  "Inventory & shrinkage module is disabled. Enable it from the Super Admin panel to start using it.",
  "Configuración del módulo": "Module configuration",
  "Habilitar módulo": "Enable module",
  "Deshabilitar módulo": "Disable module",

  // Ingresar compras
  "Ingresar Compras": "Enter Purchase",
  "Registrar compra del día": "Record today's purchase",
  "Escanear recibo de compra": "Scan purchase receipt",
  "Tomar foto del comprobante": "Take a photo of the receipt",
  "Haz clic para usar la cámara del dispositivo": "Click to use your device camera",
  "La cámara debe estar habilitada en tu dispositivo": "Camera must be enabled on your device",
  "Programa de navegación no admitido": "Unsupported browser",
  "Tu navegador no soporta la cámara": "Your browser does not support camera",
  "No se pudo acceder a la cámara": "Couldn't access the camera",
  "Por favor, permite la cámara en las configuraciones del navegador e inténtalo de nuevo.": "Please allow camera access in your browser settings and try again.",
  "Subiendo imagen…": "Uploading image…",
  "Escaneqe el recibo nuevamente": "Scan the receipt again",
  "AI: Extrayendo productos…": "AI: Extracting products…",
  "Sin resultados": "No results",
  "No se encontraron productos en este comprobante": "No products found in this receipt",
  "Intenta con otro comprobante": "Try another receipt",
  "Ajustes": "Settings",
  "Guardar": "Save",
  "Guardado": "Saved",
  "Cancelar": "Cancel",
  "Eliminar": "Delete",
  "Nombre del producto": "Product name",
  "Cantidad": "Quantity",
  "Unidad": "Unit",
  "Costo unitario": "Unit cost",
  "Unidades": "Units",

  // Mermas
  "Control de Mermas": "Shrinkage Control",
  "Reporte de merma": "Shrinkage report",
  "Cálculo de merma": "Shrinkage calculation",
  "Fecha inicio": "Start date",
  "Fecha fin": "End date",
  "Stock real": "Actual stock",
  "Stock teórico": "Theoretical stock",
  "Variación": "Variance",
  "Cero": "Zero",
  "Merma detectada": "Shrinkage detected",
  "Sin merma": "No shrinkage",
  "Sin pérdidas": "No losses",
  "Pérdida": "Loss",
  "Perdida": "Lost",
  "El cálculo requiere al menos un ítem de inventario": "Calculation requires at least one inventory item",
  "Ingresa un rango de fechas": "Enter a date range",
  "Perdido": "Lost",
  "Ganancia": "Gain",
  "Mermas del período": "Shrinkage for the period",
  "Resumen de mermas": "Shrinkage summary",
  "Detalles": "Details",
  "Volver al inicio": "Back to start",
  "Ajustes del módulo": "Module settings",
  "Añadir ítem de inventario": "Add inventory item",
  "Registrar entrada de stock": "Record stock entry",
  "Registrar auditoría física": "Record physical audit",
  "Borrar": "Clear",
  "Recargando…": "Reloading…",
  "Error de conexión": "Connection error",
  "Intenta de nuevo más tarde": "Try again later",
  "Módulo": "Module",
  "Lista de ítems": "Item list",
  "Plato": "Dish",
  "Receta": "Recipe",
  "No se encontraron recetas para este plato": "No recipes found for this dish",
  "Vendido": "Sold",
  "Unidades vendidas": "Units sold",
  "Relación": "Ratio",
  "Ejemplos": "Examples",
  "Alimentos": "Food",
  "Bebidas": "Drinks",
  "Ingredientes": "Ingredients",
  "SKU": "SKU",
  "Proveedor": "Supplier",
  "Escanear": "Scan",
  "Cerrar": "Close",
  "Editar": "Edit",
  "Volver": "Back",
  "Copiar": "Copy",
  "Guardar cambios": "Save changes",
  "Leer pizarrón": "Read whiteboard",
  "Leer pizarrón de horas": "Read hours whiteboard",
  "Toma una foto del pizarrón de la semana del {0} al {1}. Las horas se comparan con lo que ya está capturado antes de guardar nada.": "Take a photo of the whiteboard for the week of {0} to {1}. The hours are compared with what's already entered before anything is saved.",
  "Elegir foto": "Choose photo",
  "Leyendo el pizarrón…": "Reading the whiteboard…",
  "No pude leer horas en la foto. Intenta con una más nítida.": "I couldn't read any hours in the photo. Try a sharper one.",
  "No se pudo leer el pizarrón.": "Couldn't read the whiteboard.",
  "Todo coincide con lo capturado.": "Everything matches what's entered.",
  "{0} por llenar · {1} iguales · {2} distintas · {3} sin anotar en el pizarrón": "{0} to fill · {1} matching · {2} different · {3} not on the whiteboard",
  "se llena": "will be filled",
  "distinto (márcalo para cambiar)": "different (tick to change)",
  "en sistema, no en pizarrón": "in the app, not on the whiteboard",
  "(no está en el pizarrón)": "(not on the whiteboard)",
  "Elige a quién corresponde o se ignora.": "Pick who this is, or it's ignored.",
  "Otra foto": "Another photo",
  "Guardar {0} días": "Save {0} days",
  "Pizarrón aplicado: {0} días actualizados": "Whiteboard applied: {0} days updated",
  "No es de {0}": "Not in {0}",
  "cocina": "kitchen",
  "este grupo": "this group",
  "antes {0}": "was {0}",
  "sistema {0}": "app {0}",
  // Inventario (Menú / Compras / Merma)
  "Menú": "Menu",
  "Compras": "Purchases",
  "Merma": "Shrinkage",
  "Paso 1 de 3 · Tus platillos y qué lleva cada uno.": "Step 1 of 3 · Your dishes and what goes into each one.",
  "Paso 2 de 3 · Registra lo que entra: usa un ticket de Gastos o toma una foto.": "Step 2 of 3 · Log what comes in: use a receipt from Expenses or take a photo.",
  "Paso 3 de 3 · Pon lo vendido y lo que hay: ve cuánto se perdió.": "Step 3 of 3 · Enter what sold and what's left: see how much was lost.",
  "Sube tu menú o agrega platillos y lo que lleva cada uno.": "Upload your menu or add dishes and what goes into each.",
  "Escanea los tickets de lo que compras.": "Scan the receipts of what you buy.",
  "Pon lo vendido y lo que hay: ves cuánto se perdió.": "Enter what sold and what's left: see how much was lost.",
  "Agregar platillos": "Add dishes",
  "Sube fotos o el PDF de tu menú: armamos los platillos, sus recetas y la lista de insumos. Revisas todo antes de guardar.": "Upload photos or a PDF of your menu: we build the dishes, their recipes and the supplies list. You review everything before saving.",
  "Leyendo menú…": "Reading menu…",
  "Subir menú (fotos o PDF)": "Upload menu (photos or PDF)",
  "o a mano": "or by hand",
  "Nombre del platillo": "Dish name",
  "Encontrados en el menú ({0})": "Found on the menu ({0})",
  "Quitar todos": "Unselect all",
  "Importar {0}": "Import {0}",
  "Sin receta sugerida": "No suggested recipe",
  "✦ = insumo nuevo: se crea al importar.": "✦ = new supply: created on import.",
  "Cómo funciona": "How it works",
  "Tu menú": "Your menu",
  "{0} sin receta": "{0} without recipe",
  "Buscar platillo": "Search dish",
  "Ningún platillo coincide con \"{0}\".": "No dish matches \"{0}\".",
  "1 insumo": "1 supply",
  "{0} insumos": "{0} supplies",
  "costo {0}": "cost {0}",
  "Falta receta": "Needs recipe",
  "¿Cuánto lleva UN platillo de cada insumo?": "How much of each supply goes into ONE dish?",
  "Elige un insumo": "Choose a supply",
  "Insumo": "Supply",
  "Cantidad por platillo": "Amount per dish",
  "Quitar insumo": "Remove supply",
  "Nombre del insumo nuevo (p. ej. Queso mozzarella)": "New supply name (e.g. Mozzarella cheese)",
  "Nombre del insumo nuevo": "New supply name",
  "Agregar insumo": "Add supply",
  "Costo estimado por platillo": "Estimated cost per dish",
  "Eliminar platillo": "Delete dish",
  "Guardar receta": "Save recipe",
  "Receta guardada.": "Recipe saved.",
  "¿Eliminar \"{0}\" y su receta?": "Delete \"{0}\" and its recipe?",
  "No se encontraron platillos en el menú.": "No dishes found on the menu.",
  "No se pudo leer el menú.": "Couldn't read the menu.",
  "Selecciona al menos un platillo.": "Select at least one dish.",
  "{0} platillos nuevos, {1} actualizados, {2} insumos nuevos.": "{0} new dishes, {1} updated, {2} new supplies.",
  "＋ Nuevo insumo": "＋ New supply",
  "Leyendo ticket…": "Reading receipt…",
  "Otro ticket": "Another receipt",
  "Escanear ticket": "Scan receipt",
  "Toma una foto del ticket: leemos productos, cantidades y precios, y tú solo confirmas.": "Take a photo of the receipt: we read products, quantities and prices, you just confirm.",
  "Capturar a mano": "Enter by hand",
  "Fecha de la compra": "Purchase date",
  "Productos": "Products",
  "1 insumo nuevo": "1 new supply",
  "{0} insumos nuevos": "{0} new supplies",
  "En el ticket": "On the receipt",
  "Es el insumo": "Supply",
  "Precio unitario": "Unit price",
  "Subtotal": "Subtotal",
  "Quitar línea": "Remove line",
  "Agregar línea": "Add line",
  "Total de la compra": "Purchase total",
  "Guardar compra": "Save purchase",
  "Descartar y empezar de nuevo": "Discard and start over",
  "¿Descartar esta compra sin guardarla?": "Discard this purchase without saving?",
  "No se detectaron productos en el ticket.": "No products detected on the receipt.",
  "No se pudo leer el ticket.": "Couldn't read the receipt.",
  "Ponle nombre a los insumos nuevos.": "Name the new supplies.",
  "Agrega al menos una línea con cantidad.": "Add at least one line with a quantity.",
  "Compra guardada.": "Purchase saved.",
  "Merma ({0})": "Shrinkage ({0})",
  "Merma (%)": "Shrinkage (%)",
  "Faltantes valuados al último precio": "Shortages valued at last price",
  "Del costo teórico consumido ({0})": "Of theoretical cost consumed ({0})",
  "Contados": "Counted",
  "Insumos con conteo real": "Supplies with a real count",
  "Periodo desde el conteo del {0}": "Period since the {0} count",
  "Sin conteo previo: se parte de cero": "No previous count: starting from zero",
  "¿Cuánto vendiste?": "How much did you sell?",
  "Platillos vendidos desde el último conteo.": "Dishes sold since the last count.",
  "Primero define tus platillos y recetas.": "First set up your dishes and recipes.",
  "Ir a Menú": "Go to Menu",
  "Vendidos de {0}": "{0} sold",
  "Total vendidos": "Total sold",
  "¿Cuánto hay en realidad?": "How much is actually there?",
  "Cuenta lo que hay en la cocina y escríbelo. Lo que dejes vacío no se toma en cuenta.": "Count what's in the kitchen and enter it. Anything left blank is ignored.",
  "Aún no hay insumos. Sube tu menú para crearlos.": "No supplies yet. Upload your menu to create them.",
  "Todos": "All",
  "Sin contar": "Not counted",
  "Diferencias": "Differences",
  "Ya contaste todos los insumos.": "You've counted every supply.",
  "Ningún insumo con diferencia.": "No supply with a difference.",
  "Debería haber": "Expected",
  "Real de {0}": "Actual {0}",
  "Falta {0}": "Short {0}",
  "Sobra {0}": "Over {0}",
  "Cuadra": "Matches",
  "Inicial + compras": "Start + purchases",
  "Consumo teórico": "Theoretical use",
  "Real": "Actual",
  "Diferencia": "Difference",
  "\"Debería haber\" = último conteo + compras − lo que usan los platillos vendidos. En rojo, lo que falta (merma).": "\"Expected\" = last count + purchases − what the dishes sold use. In red, what's missing (shrinkage).",
  "Guardar conteo y cerrar periodo": "Save count and close period",
  "El conteo queda como punto de partida del siguiente periodo.": "The count becomes the starting point for the next period.",
  "Cerrar periodo": "Close period",
  "El conteo se guarda como el nuevo punto de partida. Los vendidos se reinician. ¿Continuar?": "The count is saved as the new starting point. Sales are reset. Continue?",
  "Guardar conteo": "Save count",
  "Conteo guardado. Empieza un periodo nuevo.": "Count saved. A new period begins.",
  "Captura el conteo real de al menos un insumo.": "Enter the actual count of at least one supply.",
  "¿Qué insumo es?": "Which supply is it?",
  "En el ticket dice": "The receipt says",
  "Buscar insumo": "Search supply",
  "Parecidos": "Similar",
  "Todos los insumos": "All supplies",
  "Ningún insumo coincide con \"{0}\".": "No supply matches \"{0}\".",
  "Crear insumo nuevo": "Create new supply",
  "No está en tu lista: se agrega al guardar": "Not on your list: added when you save",
  "No es insumo": "Not a supply",
  "Bolsas, propinas, impuestos… no se guarda": "Bags, tips, taxes… not saved",
  "Sin conectar": "Not linked",
  "Conectado": "Linked",
  "Recordado": "Remembered",
  "Nuevo": "New",
  "Ignorado": "Skipped",
  "Toma una foto del ticket: leemos cada producto y tú lo conectas con tu lista de insumos.": "Take a photo of the receipt: we read each product and you link it to your supplies list.",
  "Conecta cada producto": "Link each product",
  "{0} de {1}": "{0} of {1}",
  "Productos conectados": "Products linked",
  "Los tickets abrevian o cortan los nombres: dinos qué insumo es cada línea. La próxima vez lo recordamos.": "Receipts abbreviate or cut off names: tell us which supply each line is. We'll remember next time.",
  "Aceptar las {0} sugerencias": "Accept the {0} suggestions",
  "Agregado a mano": "Added by hand",
  "¿Es": "Is it",
  "Sí, es ese": "Yes, that one",
  "Elegir otro": "Choose another",
  "Conectar con un insumo": "Link to a supply",
  "Insumo nuevo": "New supply",
  "Nombre del insumo": "Supply name",
  "No es insumo: no se guarda.": "Not a supply: not saved.",
  "Falta conectar 1 producto": "1 product left to link",
  "Faltan {0} productos por conectar": "{0} products left to link",
  "Falta la cantidad de \"{0}\".": "Missing the quantity for \"{0}\".",
  "una línea": "a line",
  "Tickets que ya subiste en Gastos": "Receipts you already uploaded in Expenses",
  "Toca uno para registrar lo que compraste, sin tomar otra foto.": "Tap one to log what you bought, no new photo needed.",
  "Ya registrado": "Already logged",
  "Ver menos": "Show less",
  "Ver más ({0})": "Show more ({0})",
  "O toma una foto nueva": "Or take a new photo",
  "Ya registraste una compra con este ticket. ¿Registrarlo otra vez?": "You already logged a purchase with this receipt. Log it again?",
  "Sí, otra vez": "Yes, again",
  "Ticket de Gastos: {0} · {1}": "Expenses receipt: {0} · {1}",
  "No se pudo cargar el comprobante ({0}).": "Couldn't load the receipt ({0}).",
  "No se pudo cargar el comprobante": "Couldn't load the receipt",
  "Instalar app": "Install app",
  "Instala Soedia en tu teléfono": "Install Soedia on your phone",
  "Ábrela desde tu pantalla de inicio, a pantalla completa.": "Open it from your home screen, full screen.",
  "y luego “Agregar a inicio”.": "then “Add to Home Screen”.",
  "Instalar": "Install",
  "Ocultar": "Hide",
  "Elige el código de país del número.": "Pick the number's country code.",
  "Escribe el número completo, sin el código de país.": "Type the full number, without the country code.",
  "Solo estos números pueden escribirle al bot (fotos, PDF, XML o texto) y reciben el resumen diario. Elige el país y escribe el número sin el código.": "Only these numbers can message the bot (photos, PDF, XML or text) and they get the daily summary. Pick the country and type the number without the code.",
  "Código de país": "Country code",
  "Número": "Number",
  "Estados Unidos / Canadá": "United States / Canada",
  "Idioma del dueño": "Owner's language",
  "El bot de WhatsApp y los reportes le escriben en este idioma.": "The WhatsApp bot and the reports write to them in this language.",
  "Idioma del bot y los reportes": "Bot and reports language",
  "El bot de WhatsApp y los reportes te escribirán en este idioma.": "The WhatsApp bot and the reports will write to you in this language.",
  "Código de país: {0}": "Country code: {0}",
  "Buscar país o código": "Search country or code",
  "Países": "Countries",
  "El {0} YA se cerró ({1}). Al continuar se manda otro correo con el respaldo. ¿Reenviar el cierre?": "{0} was ALREADY closed ({1}). Continuing sends another email with the backup. Resend the closing?",
  "Se guardará y cerrará el corte del {0}: se enviarán el resumen y los tickets de ESE día por correo al administrador. ¿Terminar el día?": "The cash-up for {0} will be saved and closed: the summary and THAT day's receipts will be emailed to the administrator. Close the day?",
  // Planeador de Horarios
  "Uniforme": "Uniform",
  "Sin uniforme": "No uniform",
  "sin uniforme": "no uniform",
  "Uniforme del {0} {1}": "Uniform for {0} {1}",
  "Uniforme del {0} {1}: {2}": "Uniform for {0} {1}: {2}",
  "El gerente de meseros elige el color de cada día de la semana.": "The waiter manager picks the color for each day of the week.",
  "¿Tus meseros usan uniforme?": "Do your waiters wear a uniform?",
  "Sí: el horario muestra el color de cada día.": "Yes: the schedule shows each day's color.",
  "No: el horario no muestra uniformes.": "No: the schedule doesn't show uniforms.",
  "El planeador de la semana de Cocina y Meseros. Cada cambio se guarda solo; todo se puede cambiar después en Ajustes > Personal > Horarios.": "The weekly planner for Kitchen and Waiters. Every change saves itself; you can change everything later in Settings > Staff > Schedules.",
  "Ver tutorial": "View tutorial",
  "Saltar tutorial": "Skip tutorial",
  "¡Listo!": "Done!",
  "Tu horario": "Your schedule",
  "Aquí planeas la semana de tu equipo, de lunes a domingo. Solo ves a la gente de tu área.": "Plan your team's week here, Monday to Sunday. You only see the people in your area.",
  "Marca quién trabaja": "Mark who works",
  "Toca la casilla de cada persona en el día que trabaja. Si tu equipo va por turno, toca Tarde o Noche. Todo se guarda solo.": "Tap each person's box on the days they work. If your team works in shifts, tap Afternoon or Night. Everything saves itself.",
  "Cambia de semana": "Change week",
  "Con las flechas de arriba pasas a la semana siguiente o regresas a la anterior.": "Use the arrows at the top to go to the next week or back to the previous one.",
  "Uniforme del día": "Uniform of the day",
  "Si tu equipo usa uniforme, toca la fila \"Uniforme\" para elegir el color de cada día.": "If your team wears a uniform, tap the \"Uniform\" row to pick each day's color.",
  "Compártelo": "Share it",
  "\"Exportar como Imagen\" arma el horario listo para mandarlo al grupo de WhatsApp.": "\"Export as Image\" builds the schedule ready to send to the WhatsApp group.",
  "Aún no hay colores de uniforme: el dueño los agrega en Configurar.": "No uniform colors yet: the owner adds them in Settings.",
  "Horario de la semana": "Weekly schedule",
  "1 día": "1 day",
  "{0} días": "{0} days",
  "{0}, {1} {2}": "{0}, {1} {2}",
  "{0}, {1} {2}, {3}": "{0}, {1} {2}, {3}",
  "1 turno": "1 shift",
  "{0} turnos": "{0} shifts",
  "El negocio cierra ese día": "The business is closed that day",
  "Horario · {0}": "Schedule · {0}",
  "Semana del {0} al {1}": "Week of {0} to {1}",
  "Descansa": "Off",
  "Uniforme de la semana:": "Uniform of the week:",
  "No se guardó el cambio. Revisa la conexión.": "The change wasn't saved. Check your connection.",
  "No se guardó el uniforme. Revisa la conexión.": "The uniform wasn't saved. Check your connection.",
  "Imagen descargada.": "Image downloaded.",
  "No se pudo generar la imagen.": "Couldn't create the image.",
  "Exportar como Imagen": "Export as Image",
  "Horarios": "Schedules",
  "No se pudo cargar el horario. Revisa la conexión.": "Couldn't load the schedule. Check your connection.",
  "Reintentar": "Retry",
  "Cargando horario": "Loading schedule",
  "Tu cuenta no tiene un horario asignado.": "Your account has no schedule assigned.",
  "Nadie está en este horario todavía. Elige quién va aquí en Configurar horarios.": "Nobody is on this schedule yet. Choose who goes here in Schedule settings.",
  "El dueño todavía no te asigna empleados.": "The owner hasn't assigned you any employees yet.",
  "Configurar horarios": "Schedule settings",
  "Quién va en cada horario, uniformes y encargados": "Who goes on each schedule, uniforms and managers",
  "Ninguno": "None",
  "No se pudo leer la configuración de horarios. Revisa la conexión.": "Couldn't load the schedule settings. Check your connection.",
  "Cargando": "Loading",
  "No se pudo agregar el uniforme.": "Couldn't add the uniform.",
  "No se pudo quitar el uniforme.": "Couldn't remove the uniform.",
  "Invitación enviada a {0}.": "Invitation sent to {0}.",
  "{0} ya puede entrar con su cuenta.": "{0} can now sign in with their account.",
  "No se pudo invitar al encargado.": "Couldn't invite the manager.",
  "Quitar encargado": "Remove manager",
  "{0} ya no podrá entrar al Planeador de Horarios.": "{0} will no longer be able to open the Shift Scheduler.",
  "No se pudo quitar al encargado.": "Couldn't remove the manager.",
  "¿Quién va en cada horario?": "Who goes on each schedule?",
  "El jefe de cocina solo ve a los de Cocina y el gerente de meseros solo a los de Meseros. Deja en \"Ninguno\" a quien no planean ellos (por ejemplo, limpieza).": "The head chef only sees Kitchen and the head waiter only sees Waiters. Leave anyone they don't schedule (cleaning staff, for example) on \"None\".",
  "Aún no hay empleados: dalos de alta en Ajustes.": "No employees yet: add them in Settings.",
  "Uniformes": "Uniforms",
  "Los colores que el gerente de meseros puede elegir cada semana.": "The colors the head waiter can choose each week.",
  "Color del uniforme": "Uniform color",
  "Nombre del color (p. ej. Gris)": "Color name (e.g. Gray)",
  "Nombre del color": "Color name",
  "Agregar uniforme": "Add uniform",
  "Encargados": "Managers",
  "Sus cuentas solo abren el Planeador de Horarios: no ven nóminas, cuentas ni el corte.": "Their accounts only open the Shift Scheduler: they can't see payroll, accounts or the cash-up.",
  "Quitar a {0}": "Remove {0}",
  "correo@ejemplo.com": "email@example.com",
  "Correo del encargado": "Manager's email",
  "Invitar": "Invite",
  "No se pudo mandar el correo. Pásale este enlace para que cree su contraseña:": "The email couldn't be sent. Give them this link to create their password:",
  "Salir": "Sign out",
  "Jefe de cocina": "Head chef",
  "Gerente de meseros": "Head waiter",
  "Solo el dueño puede cambiar esto.": "Only the owner can change this.",
  "La semana debe empezar en lunes (YYYY-MM-DD).": "The week must start on a Monday (YYYY-MM-DD).",
  "Faltan los 7 días (lunes a domingo).": "All 7 days (Monday to Sunday) are required.",
  "Ese empleado no está en tu horario.": "That employee isn't on your schedule.",
  "El uniforme lo elige quien planea a los meseros.": "The uniform is chosen by whoever schedules the waiters.",
  "Ese uniforme ya no existe.": "That uniform no longer exists.",
  "Sección no válida.": "Invalid section.",
  "Escribe el nombre del color (máx. 40 caracteres).": "Enter the color name (max. 40 characters).",
  "Correo no válido.": "Invalid email.",
  "Rol no válido.": "Invalid role.",
  "Ese correo ya tiene una cuenta en Soedia.": "That email already has a Soedia account.",
  "No se pudo crear la cuenta. Inténtalo de nuevo.": "Couldn't create the account. Try again.",
  "Encargado no encontrado.": "Manager not found.",
  "Tu cuenta solo abre el Planeador de Horarios.": "Your account only opens the Shift Scheduler.",
  // Comisión bancaria (tipos de ingreso)
  "Comisión bancaria": "Bank commission",
  "El efectivo no paga comisión.": "Cash has no bank commission.",
  "Comisión bancaria de {0}": "Bank commission for {0}",
  "Comisión bancaria de la nueva opción": "Bank commission for the new option",
  "La comisión bancaria debe ser un porcentaje de 0 a 100.": "The bank commission must be a percentage from 0 to 100.",
  "No se pudo mandar la invitación a {0}. Quítalo y vuelve a invitarlo.": "Couldn't send the invitation to {0}. Remove them and invite them again.",
  "Lo que entró hoy": "What came in today",
  "Lo que entró este día": "What came in this day",
  "Lo que entró esta semana": "What came in this week",
  "No se registraron compras este día.": "No purchases were recorded this day.",
  "No se registraron compras esta semana.": "No purchases were recorded this week.",
  "1 línea": "1 line",
  "{0} líneas": "{0} lines",
  "Ese día aún no llega.": "That day hasn't come yet.",
  "No se guardó conteo este día.": "No count was saved this day.",
  "No se guardó conteo esta semana.": "No count was saved this week.",
  "La merma de un periodo queda aquí cuando se guarda su conteo.": "A period's shrinkage shows up here once its count is saved.",
  "Conteo de hoy": "Today's count",
  "Conteo del día": "Count for the day",
  "Conteos de la semana": "Counts for the week",
  "Guardado el {0}": "Saved on {0}",
  "la diferencia suma todos los conteos": "the difference adds up every count",
  "Vendidos": "Sold",
  "Platillos vendidos ({0})": "Dishes sold ({0})",
  "Platillo borrado": "Deleted dish",
  "Había": "Counted",
  "Periodo abierto": "Open period",
  "El idioma de la app en este dispositivo.": "The app's language on this device.",
  "Perfil": "Profile",
  "App": "App",
  "Fotos de tickets y recibos": "Receipt and payslip photos",
  "RFC y datos de tickets": "Tax ID and receipt data",
  "Equipo y horarios": "Team and schedules",
  "Grupos, pago y turnos": "Groups, pay and shifts",
  "Ingresos, pagos, proveedores": "Income, payments, suppliers",
  "Ajustes especiales": "Special settings",
  "Tu plan y pagos": "Your plan and payments",
  "Español / English": "Español / English",
  "Logo, colores y moneda": "Logo, colors and currency",
  "Ajustes especiales del pago: feriados, horas extra, puntualidad y propinas.": "Special pay settings: holidays, overtime, punctuality and tips.",
  "Fecha de los tickets": "Receipts date",
  "Las fotos de los tickets y recibos de nómina guardados, por día.": "Saved receipt and payslip photos, by day.",
  ". Escanea un ticket en Capturar o envía un recibo de nómina para que aparezca aquí.": ". Scan a receipt in Capture or send a payslip to see it here.",
  "IVA mínimo para facturar": "Minimum VAT to invoice",
  "Los tickets con menos IVA no aparecen en Pendientes por facturar. Déjalo vacío para facturar todos.": "Receipts with less VAT don't show up in Pending invoices. Leave it empty to invoice all of them.",
  "Portal de {0}": "{0} portal",
  "No se pudieron cargar los tickets.": "Couldn't load the receipts.",
  "Datos de facturación de tickets": "Receipt invoicing data",
  "Refrescar": "Refresh",
  "Lo que el escáner leyó de cada ticket para pedir su factura en el portal de la cadena.": "What the scanner read from each receipt, to request its invoice on the store's portal.",
  "Ningún ticket del {0} trae datos para facturar.": "No receipts from {0} have invoicing data.",
  "Más": "More",
  "Bóveda, facturación, personal, catálogos y más. Aquí también puedes volver a ver este recorrido.": "Vault, invoicing, staff, catalogs and more. You can also replay this tour here.",
  "Dashboard": "Dashboard",
  "Resumen del día y análisis": "Daily summary and analytics",
  "Menú, compras y merma": "Menu, purchases and waste",
  "Ingresos, gastos e impuestos": "Income, expenses and taxes",
  "Razón (opcional)": "Reason (optional)",
  "Razón del extra de propinas de {0}": "Reason for {0}'s tip extra",
  "{0} en {1}: {2}": "{0} in {1}: {2}",
  "Sin faltas en {0}": "No absences in {0}",
  "Usar solo finanzas personales": "Use personal finances only",
  "Volver a los módulos de empresa": "Turn business modules back on",
  "Se esconden Nóminas, Corte, Personal, Horarios, Nómina, Reglas, Dashboard e Inventario, y el bot de WhatsApp solo registra gastos. No se borra nada: puedes volver a encenderlos cuando quieras.": "Payroll, Day close, Staff, Schedules, Payroll setup, Rules, Dashboard and Inventory are hidden, and the WhatsApp bot only records expenses. Nothing is deleted: you can turn them back on anytime.",
  "Vuelven Nóminas, Corte y los demás módulos de empresa, con todo lo que ya tenían.": "Payroll, Day close and the other business modules come back, with everything they already had.",
  "Activar": "Turn on",
  "Desactivar": "Turn off",
  "Modo finanzas personales activado.": "Personal finance mode on.",
  "Módulos de empresa activados.": "Business modules on.",
  "Solo finanzas personales": "Personal finances only",
  "Apaga Nóminas, Corte y los demás módulos de empresa; quedan Finanzas, Capturar y Bóveda. No se borra nada.": "Turns off Payroll, Day close and the other business modules; Finances, Capture and Vault stay. Nothing is deleted.",
  "Catálogos, suscripción, idioma y perfil": "Catalogs, subscription, language and profile",
  "Finanzas personales": "Personal finances",
  "Renuncia voluntaria": "Resignation",
  "Mutuo acuerdo o fin de contrato": "Mutual agreement or end of contract",
  "Despido justificado (art. 47)": "Dismissal for cause (art. 47)",
  "Despido injustificado (liquidación)": "Unjustified dismissal (severance)",
  "Descargar PDF": "Download PDF",
  "No se pudo generar el documento. Intenta de nuevo.": "Couldn't create the document. Try again.",
  "Imprimir": "Print",
  "Zona del salario mínimo 2026": "2026 minimum wage zone",
  "General {0}": "General {0}",
  "Frontera norte {0}": "Northern border {0}",
  "baja": "inactive",
  "Captura la fecha de ingreso.": "Enter the start date.",
  "Captura la fecha de salida.": "Enter the last day of work.",
  "La fecha de salida es anterior al ingreso.": "The last day is before the start date.",
  "Elige a quién": "Choose who",
  "Fecha de ingreso": "Start date",
  "Último día de trabajo": "Last day of work",
  "Guardar como su fecha de ingreso": "Save as their start date",
  "Motivo de la salida": "Reason for leaving",
  "Salario diario": "Daily wage",
  "Sale de su pago en Personal ({0}). Ajústalo si su salario diario real es otro.": "Taken from their pay in Team ({0}). Adjust it if their real daily wage is different.",
  "por hora × 8 horas": "hourly × 8 hours",
  "semanal ÷ 7": "weekly ÷ 7",
  "un turno por día": "one shift a day",
  "Días sin pagar": "Unpaid days",
  "Trabajados y aún no pagados.": "Worked and not paid yet.",
  "Vacaciones pendientes": "Pending vacation",
  "Días de años anteriores que no tomó.": "Days from past years not taken.",
  "Días de aguinaldo": "Christmas bonus days",
  "Mínimo 15.": "At least 15.",
  "Prima vacacional": "Vacation bonus",
  "Mínimo 25%.": "At least 25%.",
  "Ya se le pagó el aguinaldo de este año": "This year's Christmas bonus was already paid",
  "Sumar 20 días por año": "Add 20 days per year",
  "Solo si no se le reinstala o es de los casos del art. 49 (ver la explicación).": "Only if they aren't reinstated or it's an art. 49 case (see the explanation).",
  "Otras percepciones": "Other earnings",
  "Descuentos": "Deductions",
  "Préstamo pendiente: {0}": "Pending loan: {0}",
  "Finiquito y liquidación": "Final pay and severance",
  "Finiquito": "Final pay",
  "{0} años completos · {1} días": "{0} full years · {1} days",
  "{0} años": "{0} years",
  "Finiquito o liquidación": "Final pay or severance",
  "Año": "Year",
  "Aguinaldo {0}": "Christmas bonus {0}",
  "No hay personal activo.": "No active staff.",
  "desde {0}": "since {0}",
  "sin fecha de ingreso: año completo": "no start date: full year",
  "Salario diario de {0}": "Daily wage of {0}",
  "PDF de todos": "PDF for everyone",
  "PDF de {0}": "PDF for {0}",
  "Finiquito y aguinaldo": "Final pay & Christmas bonus",
  "Aguinaldo": "Christmas bonus",
  "Para calcular su antigüedad, vacaciones, aguinaldo y finiquito. Opcional.": "Used for seniority, vacation, Christmas bonus and final pay. Optional.",
  "Cálculo según la ley y documento para firmar": "Calculated by law, with a document to sign",
  "Se paga antes del 20 de diciembre": "Due before December 20",
  "Vacaciones ya pagadas": "Vacation already paid",
  "Días que ya tomó o se le pagaron desde su último aniversario.": "Days already taken or paid since their last work anniversary.",
  "Antes de cerrar el finiquito": "Before closing the final pay",
  "Compartir Soedia": "Share Soedia",
  "Al final se agrega el link: {0}": "The link is added at the end: {0}",
  "Mandar por WhatsApp": "Send on WhatsApp",
  "Copiar mensaje": "Copy message",
  "Descargar imagen": "Download image",
  "No se pudo copiar.": "Couldn't copy.",
  "No se pudo abrir el menú de compartir. Copia el mensaje o descarga la imagen.": "Couldn't open the share menu. Copy the message or download the image.",
  "En WhatsApp Web el link sale con su foto. Si la quieres como imagen aparte, descárgala y adjúntala.": "On WhatsApp Web the link shows its picture. To send it as a separate image, download it and attach it.",
  "Imagen de Soedia que se manda: nómina, caja, gastos y facturación en un solo lugar": "Soedia image that gets sent: payroll, cash, expenses and invoicing in one place",
};
